<template>
  <div>
    <article v-if="stepNumber === 1">
      <p>
        Dear <span>{{ name }}</span
        >,
      </p>
      <p>
        We hope you're enjoying it so far - and that these short modules are
        educational &amp; inspiring!
      </p>
      <p>
        As you know, we made it <strong><i>our mission</i></strong> to guide you
        through using Dropsmart in the easiest &amp; most efficient way!
      </p>
      <p>
        So, relax and tune in as you're tunning into our supper-speedy 17 steps
        system for Mastering Dropsmart &amp; making the most of it! 🙂
      </p>
      <p>
        Also, if you have additional queries &amp; questions, don't hesitate to
        contact us using the form below.
      </p>
      <p>
        In today's step, we're explaining why one essential oil works better
        than many.
      </p>
      <p>
        After all, the knowledge that essential oil works is magnificent, but
        understanding <strong>why</strong> is equally important!
      </p>
      <p>
        Sometimes, using <strong><i>one</i></strong> essential oil beats using
        <strong><i>many</i></strong> due to several reasons:
      </p>
      <ul>
        <li>We might dilute the effect.</li>
        <li>We might waste our resources.</li>
        <li>We might even contradict ourselves.</li>
      </ul>
      <p>
        To name a few! 🙂
      </p>
      <p>
        Now, let's take the well-research &amp; widely known Lavander (<i
          >Lavandula angustifolia</i
        >) as an example.
      </p>
      <p>
        One of the main reasons for using Lavander is its sedative properties.
      </p>
      <p>
        The sedative effects of the Lavander have been researched numerous times
        and are supported by various credible references.
      </p>
      <p>
        Lavender is often used in aromatherapy practices to remedy sleep issues
        &amp; is fiercely advocated by many aromatherapy experts &amp; renowned
        practitioners!
      </p>
      <p>
        To fully understand Lavander's power &amp; to know
        <strong>why</strong> it works the way it does, it's best to look at the
        detailed report - the <strong>GC (Gas Chromatography)</strong>.
      </p>
      <p>
        To understand any oil, it's paramount to understand its chemical
        constituents - so which chemical constituents make Lavender a superior
        sedative &amp; a powerful ally to diminish sleep disturbances? The
        answer is:
      </p>

      <ul>
        <li>linalool, and</li>
        <li>linalyl acetate.</li>
      </ul>
      <p>
        These two components together create the majority of Lavander essential
        oils used today.
      </p>
      <p>
        Knowing the chemical components explains the
        <strong><i>why</i></strong> behind an essential oil's effectiveness.
      </p>
      <p>
        But knowing the
        <strong><i>percentage of each chemical constituent</i></strong> present
        in a specific oil gives us even more information about the
        <strong><i>extent</i></strong
        >.
      </p>
      <p>
        As you can see, in the example with this specific oil, Lavander - its
        main constituents linalool and linalyl acetate are the ones that make it
        soothing.
      </p>
      <p>
        Their references confirm over 70% sedative properties for these two
        components in particular.
      </p>
      <p>
        A list of properties in Dropsmart explains <strong>why</strong> Lavander
        essential oil is sedative, anti-inflammatory, and anti-bacterial and
        binds the explanation with the
        <strong><i>chemical components</i></strong
        >, which are thoroughly researched and scientifically backed up.
      </p>
      <p>
        This allows us to demystify why is a particular essential oil effective,
        to which extent, and what for. In other words, now we can truly
        understand <strong><i>what is inside our oil</i></strong
        >.
      </p>
      <p>
        Now let's presume you want to blend Lavander with another essential oil
        to get a certain effect - assist in pain management, for example.
      </p>
      <p>
        Let's imagine you decided to blend it with Peppermint (<i>Mentha</i> x
        <i>piperita</i>) since this is one of your favorite and most gladly used
        oils (plus you might like the smell).
      </p>
      <p>
        Because Peppermint is primarily a stimulant - combining Lavander with
        Peppermint will diminish Lavander's power - and do quite the opposite of
        calming you down while trying to decrease the pain.
      </p>
      <p>
        This means that combining Peppermint with Lavander will dilute
        Lavander's effect and lessen its healing properties.
      </p>
      <p>
        In this case, using Lavander as a single essential oil is far more
        potent than blending it. However, let's presume you still want to blend
        - and give that minty scent to the blend without diminishing its
        properties.
      </p>
      <p>
        In this case - using Bergamont mint (<i>Mentha aquatica</i>) is
        recommended since this essential oil will complement Lavender in its
        sedative effect as it shares the same two soothing components (linalool
        and linalyl acetate).
      </p>
      <p>
        This explains why the less researched Bergamot mint is used for
        relaxation even though we don't have scientific research on this
        essential oil.
      </p>
      <p>
        What we do have is plenty of research on linalool and linalyl acetate,
        which are making up the larger portion of Bergamont mint essential oil.
      </p>
      <p>
        This gives us rock-solid information on its healing properties &amp;
        credible scientific reasons for using Bergamot mint essential oil for
        sleep and relaxation (and blending it with Lavander).
      </p>
      <p>
        But is it recommended to blend these two complementary oils to induce
        sleep quicker &amp; easier? No, because they both have a similar amount
        of the two sedative constituents - which means they'll do the same job -
        either together or separately.
      </p>
      <p>
        Blending is, in this case, a pure waste of resources - unless we blend
        solely for the smell. Otherwise, environmentally and monetarily -
        blending these two oils isn't recommended.
      </p>
      <p>
        We hope this post has contributed to your knowledge and expanded your
        awareness about the appropriate and safe use of essential oils.
      </p>
      <p>
        A little more awareness takes us a long way - and in Dropsmart, we're
        all about taking extra miles and exploring the magnitude of the
        essential oils an inch deeper every time!
      </p>

      <p>
        Sincerely,
        <br />
        Dropsmart Team
        <br /><a href="https://dropsmart.io/">Dropsmart.io</a> - The most
        trusted essential oil resource center.
      </p>
      <p>
        <strong>P.S.</strong> Using one essential oil is often more effective
        than using 1, 2, 3, or more oils simultaneously since each oil is a
        blend on its own. A unique combination of chemical constituents which
        work in your favor and help you with a galore of healing properties.
      </p>
      <p class="text-center">
        <strong>
          Thank you for watching &amp; please continue your journey with the
          next step.
        </strong>
      </p>
    </article>

    <article v-else-if="stepNumber === 2">
      <p>
        Dear <span>{{ name }}</span
        >,
      </p>

      <p>
        We hope you have had a pleasant journey with us so far and that you've
        enjoyed the previous email in which we explained when and why is one
        essential oil more powerful than the blend itself.
      </p>

      <p>
        It's our privilege to guide you through using Dropsmart in the easiest
        &amp; most efficient way possible!
      </p>

      <p>
        If you have additional queries &amp; questions, don't hesitate to leave
        your comment on the form below.
      </p>

      <p class="text-center">
        <strong>We are here for you and we care. </strong>
      </p>

      <p>
        Last time we talked about how &amp; why one essential oil is powerful
        enough on its own and should be used exclusively - without diluting its
        power by unnecessarily blending it.
      </p>

      <p>
        <strong
          >Today we will touch upon similarities and differences between
          different essential oils.</strong
        >
      </p>

      <p>
        <strong
          >We're going to search for differences (and similarities) in essential
          oils, which we often use for relaxation - to compare their effects
          &amp; see why</strong
        >
        they work the way they do.
      </p>

      <p>
        As you certainly know, there's a plethora of oils we're using for
        relaxation, sleep &amp; stress management - from Lavander (<i
          >Lavandula angustifolia</i
        >) over Neroli (<i>Citrus</i> x <i>aurantium</i>) to Bergamot (<i
          >Citrus bergamia</i
        >) &amp; Clary sage (<i>Salvia sclarea</i>). But, even though all of
        these oils have nearly the same healing properties, they are as similar
        as they are different - and this is where the
        <strong><i>advanced filter feature</i></strong> in Dropsmart comes in
        <strong><i>extra handy</i></strong
        >.
      </p>
      <p></p>

      <p>
        There are 10 filtering options within Dropsmart that allow us to search
        oils relating to their:
      </p>
      <ol>
        <li>sellers,</li>
        <li>extraction methods,</li>
        <li>plant parts,</li>
        <li>plant notes,</li>
        <li>origin,</li>
        <li>odor descriptions,</li>
        <li>odor intensity,</li>
        <li>cultivation,</li>
        <li>botanical families, and</li>
        <li>chemical groups &amp; components.</li>
      </ol>

      <p>
        To explain the similarities of the oils mentioned above, we will use the
        last filtering option - chemical groups &amp; components.
      </p>

      <p>
        We're going to search for essential oil, which has the chemical
        component <strong>linalool</strong> represented at least
        <strong>5%</strong> in its overall constituents mix.
      </p>

      <p>
        We're also going to add <strong>linalyl acetate</strong> into the filter
        (at a 5% representation rate) since
        <strong>linalool &amp; linalyl acetate</strong> are one of the main
        constituents heavily present in the Lavander.
      </p>

      <p>
        An essential oil that is widely known &amp; gladly used for remedying
        sleep issues, managing stress, and inducing relaxation.
      </p>
      <p />

      <p>
        When we combine those two chemical components and try to find oils that
        have them represented in larger amounts - Dropsmart presents us with 60
        different options (oils).
      </p>

      <p>
        Those two main components are represented with 2 distinctive colors (red
        &amp; purple) - and it's easy to see that all of the oils recommended
        have them in abundance by simply glimpsing through chemical pie charts.
      </p>

      <p>
        For this comparison, we have taken four very similar - yet fairly
        different oils. We compared:
      </p>

      <ul>
        <li>
          <a href="https://app.dropsmart.io/oil/1137"
            >Lavender (<i>Lavandula angustifolia</i>)</a
          >,
        </li>
        <li>
          <a href="https://app.dropsmart.io/oil/1004"
            >Clary Sage (<i>Salvia sclarea</i>)</a
          >,
        </li>
        <li>
          <a href="https://app.dropsmart.io/oil/266"
            >Neroli (<i>Citrus x aurantium</i>)</a
          >, and
        </li>
        <li>
          <a href="https://app.dropsmart.io/oil/640"
            >Bergamot (<i>Citrus bergamia</i>)</a
          >.
        </li>
      </ul>

      <p>
        The main similarity is that all oils have linalyl acetate and linalool
        as chemical constituents - two of which have another component that adds
        a whole new range of healing properties to these oils.
      </p>

      <p>
        Even though all oils have linalyl acetate and linalool present in their
        GC/MS reports - the ratios of those constituents are entirely different.
      </p>

      <p>
        <strong
          >For example, Clary Sage has over 75% of linalyl acetate, unlike
          Lavender which doesn't even have 40% of the same constituent. This
          difference explains the lower yet more distinctive smell of Clary Sage
          - in situations in which we want to opt for lower notes.</strong
        >
      </p>

      <p>
        Limonene is the third chemical constituent that is slightly present
        within Lavender &amp; Clary Sage essential oils but is abundantly
        represented in the Neroli and Bergamot oils.
      </p>

      <p>
        <strong>Limonene</strong> is very well-known &amp; abundantly researched
        as an incredible antidepressant.
      </p>

      <p>But how is this information useful to us?</p>

      <p>How can we apply this knowledge?</p>

      <p>Let's take Neroli oil as an example.</p>

      <p>
        Neroli is extremely abundant in limonene, linalyl acetate, and linalool.
      </p>

      <p>
        This makes it a super-powerful synergy for soothing negative emotions -
        but it is also one of the more expensive oils. Luckily, this synergy is
        extremely easy to reproduce once the knowledge of the proper blending is
        unleashed.
      </p>

      <p>
        Suppose we wish to create almost the same chemical chart with Lavender
        &amp; Bergamot. In that case, we can do so by simply adding, e.g., lemon
        (rich in limonene &amp; beta-pinene) to either of those two oils - and
        obtain the same effect as we would have if we had used Neroli.
      </p>

      <p>
        It gives us options between using oils on their own &amp; blending them
        with other oils to obtain a specific effect. This also helps us not to
        be wasteful - of neither money, time, or resources.
      </p>

      <p>
        This way, we know when not to blend specific oils - for example,
        Lavender &amp; Clary Sage - since they have the same chemistry.
      </p>

      <p>
        We can do whatever we wish to treat with essential oils by carefully
        observing chemical components &amp; seeing does chemistry support our
        choices.
      </p>

      <p>But more about this in future posts! 🙂</p>

      <p>
        We hope this content has contributed to your knowledge and expanded your
        awareness about the appropriate and safe use of essential oils.
      </p>

      <p>
        A little more awareness takes us a long way - and in Dropsmart, we're
        all about taking extra miles and exploring the magnitude of the
        essential oils an inch deeper every time!
      </p>
      <p />

      <p>
        We wish you a lovely day,
        <br />
        Dropsmart Team
        <br /><a href="https://dropsmart.io/">Dropsmart.io</a> - The most
        trusted essential oil resource center.
      </p>

      <p>
        <strong>P.S.</strong> Today we explained how knowing how essential oils
        are different and how they are the same is rather important for many
        reasons. Not only does it help us to make the right choice around
        blending options, but it also helps us to save time, money &amp;
        resources as we're choosing options backed by science.
      </p>

      <p class="text-center">
        <strong>
          Thanks for watching &amp; please continue your journey with the next
          step.
        </strong>
      </p>
    </article>

    <article v-else-if="stepNumber === 3">
      <p>
        Dear <span>{{ name }}</span
        >,
      </p>

      <p>
        We hope you're enjoying it so far - and that these short modules are
        educational &amp; inspiring!
      </p>

      <p>
        As you know, we made it <strong><i>our mission</i></strong> to guide you
        through using Dropsmart in the easiest &amp; most efficient way!
      </p>

      <p>
        Now that you took the time to go through the previous two steps to
        understand essential oils truly.
      </p>

      <p>
        Now that you understand <strong>why</strong> essential oils work,
        <strong>how</strong> they work behind the scenes, and their power - it's
        time to start blending! 🙂
      </p>

      <p>
        Blending in a smart way - way it's more effective, beneficial, and
        efficient. In a way that brings you more results &amp; control over what
        you're doing.
      </p>

      <p>
        Blending in a way you understand and utilize the immense impact of
        chemistry on your product, blends, formulations, teachings, and every
        bit of your practice.
      </p>

      <p>
        This time we're taking Eucalyptus Globulus (<a
          href="https://app.dropsmart.io/oil/612"
          ><i>Eucalyptus globulus</i></a
        >), a very well-known essential oil often used for the respiratory
        system.
      </p>

      <p>
        You'll find numerous scientific references in Dropsmart that testify
        that Eucalyptus is a wise choice for any infection.
      </p>

      <p>
        Let's take a look at application methods and suggestions. We're going to
        see a copious amount of research regarding
        <i>Eucalyptus globulus</i> and immune system improvements - with a
        special emphasis on respiratory conditions.
      </p>
      <p />

      <p>But this time, we again will start with <strong>why</strong>.</p>

      <p>Why does <i>Eucalyptus globulus</i> work?</p>

      <p>What is the secret?</p>

      <p>And how can logically back up this secret?</p>

      <p>The answer is, like always - in the GC reports!</p>

      <p>
        <i>Eucalyptus globulus</i> is so effective in the abundant amount of 1,8
        cineole chemical component in this oil. This constituent is marvelously
        researched &amp; verified in many publications as anti-inflammatory,
        anti-microbial, anti-oxidant, etc. This constituent also makes up almost
        70% of this essential oil!
      </p>
      <p></p>

      <p>
        The other reason is alpha-pinene. Another incredibly well-known
        constituent which is anti-infective, anti-viral &amp; analgesic.
      </p>

      <p>
        Now, let's talk about
        <strong>how not to blend (before we touch upon how to do that)</strong>.
      </p>

      <p>
        When it comes to blending, many practitioners rely solely on application
        suggestions for a specific oil. There's a common misconception that the
        more is, the merrier - which cannot be farther from the truth.
      </p>

      <p>
        For example, we may choose to blend <i>Eucalyptus globulus</i> &amp;
        <a href="https://app.dropsmart.io/oil/852"
          >Rosemary(<i>Rosmarinus officinalis</i>)</a
        >
        since we saw they both contain 1,8 cineole &amp; alpha-pinene &amp; we
        aspire to create a supreme infection-fighting oil.
      </p>

      <p>However, that is not going to be the result.</p>

      <p>
        The only aftermath of this decision is diluted rosemary oil weaker in
        its healing properties.
      </p>

      <p>
        Rosemary essential oil (as visible from the GC report) is an extremely
        well-rounded oil with a rather interesting chemical constituent known as
        camphor - which brings a powerful dynamic to the oil itself.
        Unfortunately, this makes Rosemary oil challenging to blend in general
        if we don't want to diminish its remarkable composition.
      </p>

      <p>
        To avoid any potential guesswork, we used our virtual blending simulator
        and blended these two oils - and we highly recommend you do the same
        before blending.
      </p>

      <p>
        And although at first glance, it may seem that this blend addresses
        respiratory conditions nicely, giving it a second look - and observing
        the Detailed Report created by Dropsmart, it becomes pretty apparent
        that the only thing we did is make rosemary essential oil less powerful
        by decreasing the amount of camphor &amp; alpha-pinene.
      </p>

      <p>
        And this is why understanding the impact of chemical components on the
        final product completely changes the game &amp; gives us maximum control
        over the result.
      </p>

      <p>Let's shift to the blend, which is a good idea! 🙂</p>

      <p>
        And that could be a blend of <i>Eucalyptus globulus</i> &amp;
        <a href="https://app.dropsmart.io/oil/813"
          >Peppermint (<i>Mentha</i> x <i>piperita</i>)</a
        >.
      </p>

      <p>
        Due to an abundance of menthol, it works incredibly well on nasal
        passages &amp; in synergy with Eucalyptus Globulus, heightens diversity
        and applicability.
      </p>

      <p>
        When we blend Rosemary with Peppermint, we don't "lose camphor" while
        adding another constituent, menthol, to the mix. Which makes this blend
        more powerful and impactful than if we used those two oils on their own.
      </p>

      <p>
        These examples confirm that understanding why each essential oil works
        is a prerequisite for successful blending.
      </p>

      <p>
        Once we understand that rosemary works splendidly because of the three
        main components and Eucalyptus because of two - we can make an educated
        guess as to what needs (or doesn't need) to be added to make the most of
        those oils.
      </p>

      <p>
        That's how we make smart, efficient, educated &amp; powerful blends!
      </p>

      <p>And getting the maximum of products we already have!</p>

      <p>
        We hope this content has contributed to your knowledge and expanded your
        awareness about the appropriate and safe use of essential oils.
      </p>

      <p>
        A little more awareness takes us a long way - and in Dropsmart, we're
        all about taking extra miles and exploring the magnitude of the
        essential oils an inch deeper every time!
      </p>

      <p>
        We wish you a lovely day,
        <br />
        Dropsmart Team
        <br /><a href="https://dropsmart.io/">Dropsmart.io</a> - The most
        trusted essential oil resource center.
      </p>
      <p>
        <strong>P.S.</strong> Blending is an art that must be done gradually and
        thoroughly understanding singular essential oils and their chemical
        constituents.
      </p>

      <p>
        Suppose we don't know why certain oil works the way it does and don't
        understand the chemical mechanic behind them. In that case, there's a
        big chance we'll create wasteful blends &amp; even unintentionally
        decrease the potency of oils.
      </p>

      <p class="text-center">
        <strong>
          Thanks for watching &amp; please continue your journey with the next
          step.
        </strong>
      </p>
    </article>

    <article v-else-if="stepNumber === 4">
      <p>
        Dear <span>{{ name }}</span
        >,
      </p>

      <!-- STARTS HERE -->
      <div
        class="ql-block"
        data-block-id="block-934a731a-ae6f-4a90-85a4-48dffe798e2c"
      >
        In the previous step, we highlighted why chemistry is our friend - and
        our most powerful ally!
      </div>
      <div
        class="ql-block"
        data-block-id="block-2fcdfddc-8e91-41ce-91f2-e9fa04a1e625"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f1f7551e-121a-4915-8126-4726dcba152e"
      >
        We also hope you&apos;re enjoying the steps we are creating and sharing
        with you since they have an <strong>important mission&nbsp;</strong>- to
        ensure you get to most from Dropsmart &amp; have fun while using it!
        &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-19d2d157-b42b-4dc7-a77d-546a090b3ee4"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f5cd5026-294c-4655-b747-201bc9f30ba0"
      >
        This time we decided to share how you can reconstruct Neroli oil and
        find substitutes for different oils altogether.&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-e7ce5aab-4018-40d7-b63e-4c97a62c8833"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b2afb6b9-10d9-44f1-907c-f74005877370"
      >
        Maybe you&apos;re glimpsing through the recipe you wish to replicate but
        are failing one oil short, or there&apos;s a blend you&apos;re curious
        to try - but one ingredient is missing.
      </div>
      <div
        class="ql-block"
        data-block-id="block-57ed6470-866f-4b52-8157-71cc970c39b9"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-fb048b64-b876-4e2d-b6bc-1067e41ca93b"
      >
        Perhaps you&apos;re developing a new product or an immersive class for
        your students/clients, and you don&apos;t wish to use an expensive oil -
        but you still aim at achieving a specific result.&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-a6283041-55f5-417f-9e91-c2b436fb9c4f"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-6df353d8-eed2-416c-813b-429f75d0ae35"
      >
        Regardless of <strong>why</strong> you wish to substitute a specific
        oil, a <strong>suitable substitute always&nbsp;</strong>exists!
      </div>
      <div
        class="ql-block"
        data-block-id="block-d2d00f91-58f1-459e-9218-3b12b3a960a8"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-d751e483-6073-4d18-b4db-1ea1c3355371"
      >
        And Dropsmart is here to help you find it! 🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-b23e646b-93eb-49f8-a869-23d52ec230d5"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-cb20841f-d757-4d2e-a8e2-96cc572d5823"
      >
        But how?
      </div>
      <div
        class="ql-block"
        data-block-id="block-695564b1-deb5-498a-8da5-1c73098f5ca2"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-db39b22a-b3ea-44cf-b2a3-4a1c49a0a45e"
      >
        Firstly by understanding everything, we talked about - starting with
        <strong>chemistry.&nbsp;</strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-3d0a1473-3570-4e56-b5d6-b32d27faab82"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a26a19b0-9d0c-44ae-93ac-3aaaf6b68adb"
      >
        For example, as visible in the Dropsmart and mentioned in the previous
        steps,
        <a
          class="ql-link"
          href="https://app.dropsmart.io/oil/266"
          rel="noopener noreferrer"
          target="_blank"
          >Neroli&nbsp;</a
        ><em
          ><a
            class="ql-link"
            href="https://app.dropsmart.io/oil/266"
            rel="noopener noreferrer"
            target="_blank"
            >(Citrus &times; aurantium</a
          ></em
        ><a
          class="ql-link"
          href="https://app.dropsmart.io/oil/266"
          rel="noopener noreferrer"
          target="_blank"
          >)</a
        >
        is a rather powerful sedative.
      </div>
      <div
        class="ql-block"
        data-block-id="block-40ce3dfd-19ce-442b-9fce-eee16e56d3b7"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-960a1abe-d378-4b48-9b04-9e8654dd87c5"
      >
        What makes it so powerful are its chemical constituents - mostly
        linalool &amp; linalyl acetate.
      </div>
      <div
        class="ql-block"
        data-block-id="block-7b5bea37-d3e6-43bc-998c-b4a203206034"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f4f69597-d7dc-41d6-b6a0-044160f5f17c"
      >
        If we observe, for example, its hypotensive &amp; antidepressant
        properties, we can see, once again, that these properties are also
        present due to the linalool chemical constituent in Neroli.&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-b13e7c30-3216-4c28-8b26-80caa44ebdb3"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-3e095731-8b78-4a0c-9740-545115c49e7c"
      >
        So this way not only do we understand
        <strong>what&nbsp;</strong>essential oil is doing, but we have full
        comprehension of the <strong>why behind it.&nbsp;</strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-1ae65ce2-c7b1-432a-8723-9ff0de979890"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-28971c61-3dd2-4dd2-bc9c-92d5629183f3"
      >
        Now, how can we use this knowledge to make an adequate swap?
      </div>
      <div
        class="ql-block"
        data-block-id="block-751812bf-7d45-47d2-b3f7-829f89ce4879"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-000f2073-be6c-42a2-a5e0-c4687801de50"
      >
        It&apos;s a step-by-step process, which starts with the first step -
        <strong>discerning chemical constituents.</strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-2cda410d-211c-42ef-9cbe-2f716833da9a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-8ea1ab25-a6dc-47e7-b34a-f4a688da8c36"
      >
        Let&apos;s take Neroli oil as an example.&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-6899c204-56cb-442d-9e2b-fcd857d1f0b5"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-7acf2e5b-5723-44a5-9eb5-a2af9313885a"
      >
        Although Neroli is a relatively expensive and special oil - it&apos;s
        rather simple in its chemistry.
      </div>
      <div
        class="ql-block"
        data-block-id="block-138992aa-96d5-490e-86bb-cc87364dd866"
      >
        <br />
      </div>
      <p
        class="text-center"
        data-block-id="block-a52aab9f-6930-4b3c-9bc5-af4be027e4b5"
      >
        <strong>Now - let&apos;s reconstruct it from the bottom up!🙂</strong
        >&nbsp;
      </p>
      <div
        class="ql-block"
        data-block-id="block-e7176a54-2a5a-44cb-9617-915977460e86"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-6e9b4788-78aa-42b2-8491-4623bdd9afa5"
      >
        One of the main constituents of Neroli oil with such a powerful soothing
        effect is:&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-fdea6bd1-f4a9-4e66-ae2c-e6aa68999376"
      >
        <br />
      </div>
      <ul>
        <li>
          <strong><em>linalyl acetate,</em></strong>
        </li>
        <li>
          <strong><em>linalool,&nbsp;</em></strong>
        </li>
        <li>
          <strong><em>beta-pinene, &amp;</em></strong>
        </li>
        <li>
          <strong><em>limonene.</em></strong>
        </li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-4dc882f8-7704-4ccf-9c69-01562961afa7"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-415b8620-5a1f-45a7-9167-3c0844465319"
      >
        So our aim is to recreate this chemical composition by choosing oils
        high in those components.
      </div>
      <div
        class="ql-block"
        data-block-id="block-a8259a0e-84dc-4291-beff-99961ea10fa2"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-82ad1e56-f2d0-43c9-9aa6-8ea9a7dfcf0c"
      >
        In Dropsmart we have a feature that allows us to search across specific
        components.
      </div>
      <div
        class="ql-block"
        data-block-id="block-4da84d55-77c0-4350-8ec2-397271dc85cc"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-58dca1e6-0071-4785-8e39-c6860a5a7bb0"
      >
        So first, we will search for an oil that is dominant in
        <strong><em>linalyl acetate&nbsp;</em></strong
        >(at least 50%).
      </div>
      <div
        class="ql-block"
        data-block-id="block-89220856-0223-4288-baf3-e525541585b9"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-c0a627ab-7912-4eff-a55e-21d481e56179"
      >
        To cover that component (oil dominant in linalyl acetate), we opted for
        <a
          class="ql-link"
          href="http://app.dropsmart.io/oil/449"
          rel="noopener noreferrer"
          target="_blank"
          >Clary Sage</a
        ><em
          ><a
            class="ql-link"
            href="https://app.dropsmart.io/oil/1004"
            rel="noopener noreferrer"
            target="_blank"
            >&nbsp;</a
          ></em
        ><a
          class="ql-link"
          href="https://app.dropsmart.io/oil/1004"
          rel="noopener noreferrer"
          target="_blank"
          >(</a
        ><em
          ><a
            class="ql-link"
            href="https://app.dropsmart.io/oil/1004"
            rel="noopener noreferrer"
            target="_blank"
            >Salvia sclarea</a
          ></em
        ><a
          class="ql-link"
          href="https://app.dropsmart.io/oil/1004"
          rel="noopener noreferrer"
          target="_blank"
          >)</a
        >.
      </div>
      <div
        class="ql-block"
        data-block-id="block-e491241b-6aa4-48fa-9eb7-66e40b7d77ae"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-43203cd2-0e8a-430e-87a7-69281e1992da"
      >
        The following constituent, which is dominant in Neroli, was<strong
          ><em>&nbsp;linalool</em></strong
        >
        - so this is exactly what we&apos;ll be seeking.
      </div>
      <div
        class="ql-block"
        data-block-id="block-19e26a8d-73d8-4465-9e40-b4b6a33be4ca"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a74a7101-2dc4-47b6-99e8-fc5fae49ff4b"
      >
        In this case, we opted for
        <a
          class="ql-link"
          href="https://app.dropsmart.io/oil/670"
          rel="noopener noreferrer"
          target="_blank"
          >Ho wood&nbsp;(</a
        ><em
          ><a
            class="ql-link"
            href="https://app.dropsmart.io/oil/670"
            rel="noopener noreferrer"
            target="_blank"
            >Cinnamomum camphora</a
          ></em
        ><a
          class="ql-link"
          href="https://app.dropsmart.io/oil/670"
          rel="noopener noreferrer"
          target="_blank"
          >)</a
        ><em>&nbsp;</em>oil.
      </div>
      <div
        class="ql-block"
        data-block-id="block-f65f456a-0cb0-457b-b51a-0b28a8acc7b1"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-c4707604-6e4f-4d5c-b863-88ba8c00e620"
      >
        It&apos;s cheap, affordable, and relatively accessible - so we added
        this oil into the blend we&apos;re recreating.
      </div>
      <div
        class="ql-block"
        data-block-id="block-f66e560a-2ecd-44ea-8fbc-fccc1e75641a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-6cdd7b3d-908b-42fd-a8f5-e44f4b31751d"
      >
        The next chemical constituent we&apos;re seeking is<strong
          ><em>&nbsp;limonene.</em></strong
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-df47b15f-19b3-4981-b844-f2a2ffa14275"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-43f0fdcb-cced-47e5-b820-ef2cd4a1bea1"
      >
        The oil that is rich in this constituent is
        <a
          class="ql-link"
          href="https://app.dropsmart.io/oil/1112"
          rel="noopener noreferrer"
          target="_blank"
          >Grapefruit&nbsp;(</a
        ><em
          ><a
            class="ql-link"
            href="https://app.dropsmart.io/oil/1112"
            rel="noopener noreferrer"
            target="_blank"
            >Citrus x paradisi</a
          ></em
        ><a
          class="ql-link"
          href="https://app.dropsmart.io/oil/1112"
          rel="noopener noreferrer"
          target="_blank"
          >)</a
        ><em>,&nbsp;</em>so it was an obvious choice.
      </div>
      <div
        class="ql-block"
        data-block-id="block-6239758c-4fac-4ab1-a7c4-8afa4c7f68b8"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-1860bd9f-82c5-4c03-953c-66be0f6b0b73"
      >
        Lastly, to fully recreate Neroli&apos;s chemical composition, we&apos;re
        only missing the <strong>beta-pinene</strong> chemical constituent.
      </div>
      <div
        class="ql-block"
        data-block-id="block-1f259e94-f4e6-44b4-88a8-21cc5235801b"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-575e7759-6cbd-4da6-b5a1-cf5a0927ee23"
      >
        This time we opted for
        <a
          class="ql-link"
          href="https://app.dropsmart.io/oil/256"
          rel="noopener noreferrer"
          target="_blank"
          >Galbanum&nbsp;(</a
        ><em
          ><a
            class="ql-link"
            href="https://app.dropsmart.io/oil/256"
            rel="noopener noreferrer"
            target="_blank"
            >Ferula gummosa</a
          ></em
        ><a
          class="ql-link"
          href="https://app.dropsmart.io/oil/256"
          rel="noopener noreferrer"
          target="_blank"
          >)</a
        ><em>&nbsp;,&nbsp;</em>which is friendly to use not only due to its
        affordability and accessibility but also singularity in its chemical
        composition.
      </div>
      <div
        class="ql-block"
        data-block-id="block-d1d409aa-3fcf-4690-b214-5cd35bbe8998"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-2597dc45-c21c-4297-af98-d261254ddbd0"
      >
        It&apos;s a rather simple oil with a straightforward composition.&nbsp;
      </div>
      <div
        class="ql-block ql-align-center"
        data-block-id="block-73841731-211c-4b88-81fc-5397f0e778e8"
      >
        <br />
      </div>
      <p class="text-center">
        Now let&apos;s proceed with creating
        <strong>&quot;Fake Neroli&quot;</strong> in our virtual blending
        simulator.
      </p>
      <div
        class="ql-block"
        data-block-id="block-662d26e0-9464-4a55-808f-5fd863531d1e"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-31402544-c9de-4099-84f2-4c4e05e440f6"
      >
        Good thing is that Dropsmart&apos;s simulator allows us to be extremely
        specific in amounts, colors, and percentages.
      </div>
      <div
        class="ql-block"
        data-block-id="block-c45877c8-3943-4d89-aed8-8863930cf453"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-586a10c4-f89d-44ec-9bfa-60225af4aa42"
      >
        As we&apos;ve seen that the most dominant component is linalool - we
        wanted to make sure it dominates in our recreated blend too!
      </div>
      <div
        class="ql-block"
        data-block-id="block-da25bedc-33c9-4b78-aa3f-585740be4395"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-808031ac-8b49-4bb8-b5ae-643d98a6eba4"
      >
        The blend we recreated contains 1 drop of Galbanum, 1 drop of Clary
        sage, 2 drops of Hoo wood &amp; 1 drop of Grapefruit.
      </div>
      <div
        class="ql-block"
        data-block-id="block-d6e0965d-b7c6-462a-b554-eca8050e2fd2"
      >
        <br />
      </div>
      <div
        class="ql-block ql-align-center"
        data-block-id="block-00a44e77-a84c-4810-a3ce-f18626de18e3"
      >
        We then save it - in order to compare our reconstructed oil (fake
        Neroli) with the real Neroli oil.
      </div>
      <div
        class="ql-block"
        data-block-id="block-8e939de0-fe31-4fb1-8ce4-3dc2a5a6ae4b"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-cf731e10-268b-463b-86a0-ae67d76a3f19"
      >
        By observing the chemistry, we noticed that &quot;fake Neroli&quot; has
        higher amounts of beta-pinene, limonene, and linalool even than real
        Neroli oil while keeping the linalyl acetate percentage high enough.
      </div>
      <div
        class="ql-block"
        data-block-id="block-ddad74f6-db89-4b03-9548-4511a181d881"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-33edce0d-e442-45f6-8a0a-ab8691edd223"
      >
        This clearly shows that we created a blend that we can comfortably and
        safely use as an antidepressant, sleep-inducing, antistress, and
        sedative oil at a far lower price than we would pay for if we&apos;d
        chosen Neroli oil instead.
      </div>
      <div
        class="ql-block"
        data-block-id="block-ed614157-eba6-4deb-930b-8dbf8062243c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-d60b2707-f68c-4172-954d-42ca20e6ed6c"
      >
        This targeted and controlled blending technique allows us to recreate
        blends repeatedly - always with complete certainty that they will do
        exactly what they are <strong><em>supposed to.&nbsp;</em></strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-89efc204-7930-4bcc-9e10-129c006ce5bf"
      >
        <br />
      </div>
      <p>
        We hope this was interesting and educational and inspired you to try
        yourself out in creating &amp; re-creating different blends - while
        enjoying the benefits of the online virtual simulator!
      </p>
      <!-- ENDS HERE -->
      <p>
        We wish you a lovely day,
        <br />
        Dropsmart Team
        <br /><a href="https://dropsmart.io/">Dropsmart.io</a> - The most
        trusted essential oil resource center.
      </p>

      <p>
        <strong>P.S.</strong> Today, we shared how to re-create an essential oil
        that may be difficult to find, or is extremely expensive, or otherwise
        inaccessible.
      </p>

      <p class="text-center">
        <strong>
          Thanks for tuning in &amp; please continue your journey with the next
          step.
        </strong>
      </p>
    </article>

    <article v-else-if="stepNumber === 5">
      <p>
        Dear <span>{{ name }}</span
        >,
      </p>

      <div
        class="ql-block"
        data-block-id="block-b13613c6-50b0-4848-af33-5b3eeecd702f"
      >
        Hope you&apos;re well - and enjoying the ride! &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-8a5dd6d7-8c1a-4238-86f8-5c72d97d2b56"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-2351cb57-7781-41bb-9055-58b5f1266554"
      >
        In our previous step, we showed you how to create an adequate substitute
        for <strong>any essential oil,&nbsp;</strong>or even how to<strong
          >&nbsp;re-create it&nbsp;</strong
        >by using Dropsmart and power on the virtual blending simulator!
      </div>
      <div
        class="ql-block"
        data-block-id="block-ab386c9f-f186-4268-8496-e3516bd1e9af"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a6620106-3ae2-484c-bc00-9dddaa854c8a"
      >
        Today we&apos;ll share with you how to
        <strong
          >master the search button (and why you should do it).&nbsp;</strong
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-f7a7c43f-7ada-42ff-b8f5-802e3ee3ad3d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-16d4bde6-1529-44b8-9f10-d6ebb4f38dad"
      >
        We like to refer to the search button as
        <strong>a TIME SAVER.&nbsp;</strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-024026a9-42a3-444c-a5c8-a5aba2a57044"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-c0d5cea1-2655-4b49-af7d-9fae3cf37371"
      >
        This incredibly powerful feature is known for saving days, sometimes
        even months, for our team and students alike.
      </div>
      <div
        class="ql-block"
        data-block-id="block-91e78eff-3d40-4ff1-8ff9-0bd6e6b8913d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-4f762aa4-292a-4b6e-ab92-092e852e9c23"
      >
        Let&apos;s dive right into it!
      </div>
      <div
        class="ql-block"
        data-block-id="block-96de3fca-7be6-4a24-aca1-41059939dc9b"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-85880fe4-ea32-485b-81a6-ce4f6f401ffc"
      >
        The search feature is the main feature in our catalog.
      </div>
      <div
        class="ql-block"
        data-block-id="block-7b887dec-d2d7-456f-816f-c657b5dff080"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-5cbab71e-9399-433c-aa27-5eea0278858c"
      >
        The most frequent search is the one that refers to symptoms or issues -
        e.g., infection - in which case Dropsmart will offer a plethora of
        options regarding remedying oils.
      </div>
      <div
        class="ql-block"
        data-block-id="block-d85640eb-7b5a-46d4-90b4-6fa65f99709e"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-13fb92f5-3cd3-4f44-b233-869c6dbdd539"
      >
        However, problems aren&apos;t the only filtering options -
        desires/outcomes are also.
      </div>
      <div
        class="ql-block"
        data-block-id="block-9fadc676-4cc8-4479-9c1f-d3eaccc816d3"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-232ce473-823d-4b45-94e4-cb95b540afee"
      >
        For example, creating our own skin products has become immensely popular
        nowadays. So, browsing the term <strong>skin care&nbsp;</strong>in the
        catalog will result in many options related to the usage of essential
        oils for nurturing skin specifically.
      </div>
      <div
        class="ql-block"
        data-block-id="block-825bc348-2560-48b8-96e7-0d6ef6091e25"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-558d1169-083b-40cc-bef9-f509bbecd01e"
      >
        But - that&apos;s just the beginning since it turns out we can get even
        more specific than that!
      </div>
      <div
        class="ql-block"
        data-block-id="block-9d20672f-c7a8-4282-8990-af4d48ba6df2"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-7708e18e-1385-4e26-90b5-946edccbdb36"
      >
        We can search terms related to skin care such as - wounds, wrinkles, and
        dermatitis.
      </div>
      <div
        class="ql-block"
        data-block-id="block-f1d0deb0-56b9-403c-9a06-050a65a52cde"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-ae410b9b-2226-4ae0-9cb3-da8a825c9f67"
      >
        All oils recommended will be scientifically proven to work for a
        specific condition or situation.
      </div>
      <div
        class="ql-block"
        data-block-id="block-d737c77a-f309-4ed9-83d6-30199291e0b2"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-6bbc8c07-ad57-4979-841d-a1b4801db60c"
      >
        We can even address different emotional states such as:
      </div>
      <div
        class="ql-block"
        data-block-id="block-64c6e41e-6f98-4ea4-b075-64257d9d8ec2"
      >
        <br />
      </div>
      <ul>
        <li>worry,</li>
        <li>trauma,</li>
        <li>sleep,</li>
        <li>spiritual vulnerability,&nbsp;</li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-f3cc7133-f4d8-4d87-9eec-1ba6076f63a2"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-2f86b7cf-d0bf-4f8b-aa6f-21d663924e0e"
      >
        and others.
      </div>
      <div
        class="ql-block"
        data-block-id="block-7b7c8020-b663-4700-bf34-7a4a2d01608f"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-5a92fdad-b7a5-4408-adb3-7ee1935aa0cd"
      >
        Within our super-smart search section, you&apos;ll find glorious
        suggestions on how to overcome troubling occurrences: from
        lightheadedness and PMS to even over-heated feet!
      </div>
      <div
        class="ql-block"
        data-block-id="block-248fef22-3802-4728-8fd7-7c670c29f295"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-3124fb1f-b6c3-46bf-8c30-7778153dce31"
      >
        Learning which oils invoke inner sensuality and explore sexuality is
        also an option!
      </div>
      <div
        class="ql-block"
        data-block-id="block-6e0cd6c5-d598-494b-8453-82655fb0c164"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a22ef56e-ab5f-4c3e-83de-7661bd3df095"
      >
        We even have recommendations on aphrodisiacs - in case you&apos;re
        creating a unique Valentine&apos;s Day gift, as well as a variety of
        suggestions regarding boosting creativity, enhancing mindfulness,
        increasing spiritual enlightenment, etc.
      </div>
      <div
        class="ql-block"
        data-block-id="block-4e6872f3-03d0-4a79-8506-0365e8bf683e"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-83ddd264-e8e1-4e20-be76-98d4b56a6ed0"
      >
        Whatever you aim to create for your family, patients, clients, students
        - or perhaps just for yourself, Dropsmart surely has the recommendation
        for &nbsp;🙂 !
      </div>
      <div
        class="ql-block"
        data-block-id="block-c5324b13-1e1c-4709-a337-0476e3d78ac7"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-28cbf118-dae6-4806-a774-bcf270b5e916"
      >
        <strong
          >And you can easily find it by typing it into the search
          bar.&nbsp;</strong
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-81dc156e-8617-457b-89cd-d58bb17ff450"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a2bffa2a-4cd4-4486-b68d-c42df74a79e9"
      >
        As far as the real game-changer goes - searching can also be done within
        your own collection.
      </div>
      <div
        class="ql-block"
        data-block-id="block-7a308ed9-6ccd-4f52-8a8b-02f1c93dd342"
      >
        This step can only be done once you&apos;ve favored = or added a
        specific oil to your collection.
      </div>
      <div
        class="ql-block"
        data-block-id="block-84dcd7a2-bbf9-4517-be8a-e1e63b9051b4"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-510ddf36-38d1-4776-8df1-2cb984160dab"
      >
        Afterward, you can browse through your personal favorites - and perhaps
        get surprised later on.
      </div>
      <div
        class="ql-block"
        data-block-id="block-cb8fc2b3-f38c-444e-81f2-b157361ee093"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-d0b6a856-f149-440a-b64b-bc2024f91cef"
      >
        For example, our founder Melani put
        <a
          class="ql-link"
          href="https://app.dropsmart.io/oil/204"
          rel="noopener noreferrer"
          target="_blank"
          >Southwestern white pine needle&nbsp;(</a
        ><em
          ><a
            class="ql-link"
            href="https://app.dropsmart.io/oil/204"
            rel="noopener noreferrer"
            target="_blank"
            >Pinus strobiformis Engelm</a
          ></em
        ><a
          class="ql-link"
          href="https://app.dropsmart.io/oil/204"
          rel="noopener noreferrer"
          target="_blank"
          >)</a
        ><em>&nbsp;</em>into her collection quite some time ago - and completely
        forgot about it.
      </div>
      <div
        class="ql-block"
        data-block-id="block-15098eef-985a-4924-9f54-c60b525c9da2"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a792bdb7-ac87-476e-a9cc-25099cd8b457"
      >
        Then, as she was seeking oil that helps with the elevation of
        mindfulness during meditation, she saw this oil as one of the
        recommended ones - something she wouldn&apos;t think of herself.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b3867d97-a13a-4abe-987b-40381df796e3"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-76a6d8a7-08e0-4ac8-aff0-7c963aacbe6f"
      >
        One of the biggest advantages of creating a private collection within
        Dropsmart is that it helps us be environmentally friendly - by reminding
        us of the oils, we have and should use (otherwise, they&apos;ll
        oxidize).
      </div>
      <div
        class="ql-block"
        data-block-id="block-531b001b-dd4b-4271-a566-ea1e0e0c7c55"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-fac77b4d-04f5-4d3b-8467-2ddd8fcf53da"
      >
        We tend to reach out for the same oils most of the time - so why not try
        to use the ones which will oxidate quickly - and potentially learn
        something new in the process?
      </div>
      <div
        class="ql-block"
        data-block-id="block-cbb74cd6-e7d7-4bae-b99a-b8d08b9aa536"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-1ecccc93-2315-430c-af06-dec19a34e96f"
      >
        That&apos;s why having your oil collection is priceless - since you can
        browse through it!
      </div>
      <div
        class="ql-block"
        data-block-id="block-49d5fe64-fedc-4c1e-a73c-9ea358f5c529"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-2b992003-c3e7-4a05-a6fb-6ebe2b263ee4"
      >
        By simply clicking on the little heart icon next to the specific oil -
        you can add it to favorites and use the maximal potential of the oil in
        the safest yet most creative way.
      </div>
      <div
        class="ql-block"
        data-block-id="block-974b761a-62a9-43bb-ad02-01c5523e69d5"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-44294d51-2400-4fb7-8e85-dee874d57211"
      >
        Once you&apos;ve spent an oil all the way through - it&apos;s fairly
        easy to delete it from favorites (or replace the bottle) 🙂.
      </div>
      <div
        class="ql-block"
        data-block-id="block-24f11d28-db3f-426e-9bcc-112dcbefb17b"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-1c7f6c26-c0b3-436d-a771-9e15835558e7"
      >
        We hope this was useful to you - thank you for your time, focus and
        attentiveness!
      </div>
      <div
        class="ql-block"
        data-block-id="block-f5e3a190-fe82-402b-9fd2-45fc36972dd9"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-5511c03f-5598-4bdf-a9d0-85609d589830"
      >
        We wish you a lovely day,
      </div>
      <div
        class="ql-block"
        data-block-id="block-1a146d76-bf4c-43f4-a82f-f060295363e4"
      >
        Dropmart Team
      </div>
      <div
        class="ql-block"
        data-block-id="block-6ad31a5d-c370-47f4-96c3-576e9e103d65"
      >
        <em
          ><a
            class="ql-link"
            href="http://dropsmart.io/"
            rel="noopener noreferrer"
            target="_blank"
            >Dropsmart.io</a
          >
          - The most trusted essential oil resource center.</em
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-8df26964-309d-4104-a874-fa1c7986313e"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-636dd24a-96a8-43d7-9cd1-ca0952a052db"
      >
        <strong>P.S.</strong> Today, we shared the importance of the Search
        button - a fantastic feature that saves us time &amp; allows us to use
        oils we have in a different, new &amp; exciting way.
      </div>
      <div
        class="ql-block"
        data-block-id="block-95099945-0621-42fa-9d32-43bdffa9e172"
      >
        <br />
      </div>
      <div
        class="ql-block ql-align-center text-center"
        data-block-id="block-35011854-1217-4c5d-8a6e-6982819529c0"
      >
        <strong
          >Thanks for tuning in &amp; please continue your journey with the next
          step.</strong
        >
      </div>
    </article>

    <article v-else-if="stepNumber === 6">
      <p>
        Dear <span>{{ name }}</span
        >,
      </p>
      <div
        class="ql-block"
        data-block-id="block-a1184225-7495-474f-bf74-358c47957073"
      >
        We hope your journey with us has been educational (&amp; valuable) so
        far!
      </div>
      <div
        class="ql-block ql-align-center"
        data-block-id="block-d799d73d-cfbb-4c6e-910d-c026c71899fb"
      >
        <br />
      </div>
      <div
        class="ql-block ql-align-center text-center"
        data-block-id="block-8baeb5f9-6106-4bf9-a187-bf1048c84040"
      >
        <strong>And enjoyable too!</strong>&nbsp; 🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-46d65497-ffbc-4a85-84f1-5b7a2808f967"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-04925e42-c59e-4d41-b5e3-b61de9aa4318"
      >
        If you remember, the last time we spoke about getting the most out of
        the Search Button.
      </div>
      <div
        class="ql-block"
        data-block-id="block-175d7d78-da12-452a-8c93-dcddaff00b6d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-68c41656-5d4b-4cdf-9d8e-11b05eb28d55"
      >
        Today though, we&apos;re going to dive into something rather exciting -
        an answer on
        <strong
          ><em>how you can get the most of the rare essential oils</em></strong
        >
        (and how to use them properly).
      </div>
      <div
        class="ql-block"
        data-block-id="block-48123b19-4714-4207-a05a-28daaaabc258"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-10cc1cf6-1678-4a3c-9662-a77fe12aafed"
      >
        As you undoubtedly know, new oils are popping up every day as more and
        more oils are being distilled - which makes us exhilarated!
      </div>
      <div
        class="ql-block"
        data-block-id="block-3919fcf9-9c41-4222-ac38-b422643653c8"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-79b53821-f147-421d-accd-387ff6867c4d"
      >
        We are magnetically pulled to them - we want to buy them, have them,
        smell them!
      </div>
      <div
        class="ql-block"
        data-block-id="block-365b38fa-65e8-43de-9605-8fd344e10812"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-6b9a674f-42de-4b68-972b-7e970cc173a6"
      >
        They usually do smell divine, don&apos;t they?
      </div>
      <div
        class="ql-block"
        data-block-id="block-b69023e6-9930-40bb-9ff0-60464f19d77d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-3bd2a81f-f5e9-48b6-b00c-5e4141ce1c54"
      >
        But what do we <strong>DO</strong> with those exotic &amp; rare oils?
      </div>
      <div
        class="ql-block"
        data-block-id="block-e979ca48-7565-41d1-a73b-2731b9bbef2c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-46c9f5a2-18e4-47dd-9d58-02bf0d78877c"
      >
        How can we use them for the greatest good?
      </div>
      <div
        class="ql-block"
        data-block-id="block-0af9ad31-26ec-45dc-9384-ccf51186cbb6"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-e8fbc8e0-0db4-4eff-8289-742ea04b15b5"
      >
        And make sure we&apos;re getting the best result possible?
      </div>
      <div
        class="ql-block"
        data-block-id="block-070a5cea-a9f5-406e-943e-56f4a39acceb"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-c90f8c06-7cb3-4794-aa8a-d63fa2d1906d"
      >
        <strong><em>When, where, and what for?</em></strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-09e62d0d-01b5-4925-b04a-c5f83805d00b"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b710f8ab-4914-4469-9adf-96ffa64e0b99"
      >
        Our founder, Melani, enjoys collecting oils on her travels - whether
        she&apos;s visiting distillers or joining conferences - which usually
        results in her ending up with a handful of oils she has no usage ideas
        for.
      </div>
      <div
        class="ql-block"
        data-block-id="block-9b2eb72f-d7f2-47b5-bc91-a9c8e793be94"
      >
        <br />
      </div>
      <div
        class="ql-block ql-align-center text-center"
        data-block-id="block-3ac428aa-c230-4225-a119-1ad55ba29fac"
      >
        <em>Sounds familiar?</em>
      </div>
      <div
        class="ql-block"
        data-block-id="block-1c1c69f8-d62b-42fd-9154-be97649bb7a9"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-55cf070f-be87-4baf-aee1-e27521b67940"
      >
        To dive into the topic properly - we decided to present an exotic
        distiller from Ecuador that produces quite a handful of unique oils.
      </div>
      <div
        class="ql-block"
        data-block-id="block-d7caf2b7-8ce4-41e6-abdd-2663d8a6a1f5"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-d7cb71f7-011b-481b-abf1-2cf530df1129"
      >
        We&apos;re taking a rather interesting sub-species of Eucalyptus
        Globulus as an example - Eurabbi
        <a
          class="ql-link"
          href="https://app.dropsmart.io/oil/958"
          rel="noopener noreferrer"
          target="_blank"
          >(</a
        ><em
          ><a
            class="ql-link"
            href="https://app.dropsmart.io/oil/958"
            rel="noopener noreferrer"
            target="_blank"
            >Eucalyptus globulus subsp. bicostata</a
          ></em
        ><a
          class="ql-link"
          href="https://app.dropsmart.io/oil/958"
          rel="noopener noreferrer"
          target="_blank"
          >)</a
        >
        oil.
      </div>
      <div
        class="ql-block"
        data-block-id="block-e131528b-0603-4d34-9b41-98e6f6947c8b"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-d6ba460c-7b9b-4aa5-afb1-369405e712b0"
      >
        As visible from the dashboard, there has been little research done for
        this oil, without a single application &amp; safety recommendation, and
        as few as only three (3) researched properties have been listed.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b2541d54-43d0-493b-a23f-0eee6200aed4"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a74ee618-21a2-4092-b8e3-2e53270426da"
      >
        And this is where <strong>a detailed report&nbsp;</strong>helps
        tremendously!
      </div>
      <div
        class="ql-block"
        data-block-id="block-ab7fa7bd-98a4-49eb-868a-3d390756f1cb"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-0e45bffb-e796-4a4b-9a8c-716e4f1bcd4f"
      >
        If we scroll down to the GC report, it&apos;s easy to notice that this
        exotic oil has common chemical constituents.
      </div>
      <div
        class="ql-block"
        data-block-id="block-0806565c-04dc-4ad2-9359-3d6fad4d70f4"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b4c94e99-f979-41b2-9597-3f1cf207b3a4"
      >
        There&apos;s already mentioned &amp; well-researched alpha-pinene,
        beta-pinene &amp; cineol, which most of us aren&apos;t only extremely
        well acquainted with - but we tend to have quite a handful of experience
        in using essential oils heavy in those components.
      </div>
      <div
        class="ql-block"
        data-block-id="block-160429f0-2c85-4496-9f28-86056b89ceb8"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-ab088d68-cc05-4c58-a66b-48fbd912f200"
      >
        The best part is that Dropsmart is calculating chemical components
        percentages &amp; ratios for us! So, upon wanting to use rare essential
        oils with little to no research on them - we can turn to the properties
        and application suggestions for their main components instead!
      </div>
      <div
        class="ql-block"
        data-block-id="block-ea067a9d-6133-4736-a54a-bd2bfd502ba1"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-72b12971-4918-42d4-ba13-973b82a2f204"
      >
        In the case of Eurabia essential oil, we can clearly see that over 90%
        of its chemical constituents are antibacterial, anti-inflammatory,
        insecticidal, antifungal, and so much more.
      </div>
      <div
        class="ql-block"
        data-block-id="block-ee2fe792-f6c9-4436-b475-b993883a4f00"
      >
        <br />
      </div>
      <div
        class="ql-block ql-align-center"
        data-block-id="block-5f0207f9-477b-41ce-859e-03ad4a144649"
      >
        This provides a solid rationale for usage - in multiple aspects &amp;
        ways.
      </div>
      <div
        class="ql-block"
        data-block-id="block-976b724f-6766-4826-9d15-9c6d62bd199d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f6fa6db2-9b48-4547-8485-7c212aaca3a6"
      >
        And this is by far the best &amp; easiest way to get the most of the
        rare oils collecting dust in our cupboards because we have no idea how
        to use them.
      </div>
      <div
        class="ql-block"
        data-block-id="block-f452d7b7-b78b-4a1b-aa92-9bd3f989653c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b7fa82d5-d307-4cfa-beb3-cc5f1b4013c0"
      >
        Let&apos;s take
        <a
          class="ql-link"
          href="https://app.dropsmart.io/oil/956"
          rel="noopener noreferrer"
          target="_blank"
          >Fringed Lavander (</a
        ><em
          ><a
            class="ql-link"
            href="https://app.dropsmart.io/oil/956"
            rel="noopener noreferrer"
            target="_blank"
            >Lavandula dentata</a
          ></em
        ><a
          class="ql-link"
          href="https://app.dropsmart.io/oil/956"
          rel="noopener noreferrer"
          target="_blank"
          >)</a
        >
        as another example.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b66ace3e-1ba5-4442-bc97-46dee3563ad1"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-66d1d466-3408-497a-a994-df0a0fc4bc9e"
      >
        Although we have a bit more information on the idea for usage and
        application methods, we can retrieve so much more valuable information
        if we <strong><em>look at the GC report!</em></strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-dd603cab-ff62-423d-ae01-a5d0280230fc"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-3b428fe0-cbb9-4786-a699-37cd5c69aeca"
      >
        As you already know, the scientific properties of the chemical
        components are heavily researched by our team - and specific amounts of
        those components present within an oil are calculated too!
      </div>
      <div
        class="ql-block"
        data-block-id="block-68119aff-1b08-4b19-9625-66c7f87aaf39"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b9677c17-73aa-42be-969e-b18aa0dd8b9b"
      >
        This makes it relatively easy to conclude <strong>why</strong> Fringed
        Lavander is best used upon needing to treat inflammation, address a
        specific bacterial infection, or lower the pain.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b58171b2-a801-42c5-8d48-73ceb7503688"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-e8093f65-4e7c-496c-8747-2981d496a438"
      >
        We can also see that penetration-enhancing properties will help us to
        blend better (with other oils) since it will allow bigger oil molecules
        to absorb faster.
      </div>
      <div
        class="ql-block"
        data-block-id="block-2c1be5a1-d7cb-4d47-bd14-f69c389e1054"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-e7af871a-19ea-4c6e-8edd-dabcebf086f9"
      >
        And this is merely scratching the surface of
        <strong><em>what</em></strong> &amp; <strong><em>how</em></strong> can
        this rare oil be used for.
      </div>
      <div
        class="ql-block"
        data-block-id="block-a6de8686-419a-4ded-a464-f95128a404df"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-42de3b4a-4c6c-47fb-98d1-77f8a152a0ad"
      >
        After a while, merely glancing at the pie charts will be sufficient for
        us to understand what a specific oil can do.
      </div>
      <div
        class="ql-block"
        data-block-id="block-85ceb9c3-31ca-4584-abae-822147284f21"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f5b24642-caa2-4ee0-ad7e-6034cd56e6f0"
      >
        For example, you&apos;ll notice that the orange color represents
        monoterpenes - tiny molecules which evaporate quickly (high notes). For
        the same reason - they <strong><em>oxidate quickly</em></strong> &amp;
        quicker than most essential oils. They also
        <strong><em>penetrate the skin</em></strong>
        <strong><em>much faster,&nbsp;</em></strong
        >so they&apos;re best when used with penetration-changing oils.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b33e3993-d2cc-4369-b3f5-02f10cbccc00"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-4ef0ceb7-173e-43b9-87f3-7266d8b188c8"
      >
        So now, for example, simply by skimming through the dashboard and
        noticing that Eurabbi &amp;
        <a
          class="ql-link"
          href="https://app.dropsmart.io/oil/996"
          rel="noopener noreferrer"
          target="_blank"
          >Peruvian Pepper (</a
        ><em
          ><a
            class="ql-link"
            href="https://app.dropsmart.io/oil/996"
            rel="noopener noreferrer"
            target="_blank"
            >Schinus molle</a
          ></em
        ><a
          class="ql-link"
          href="https://app.dropsmart.io/oil/996"
          rel="noopener noreferrer"
          target="_blank"
          >)</a
        >
        are high in monoterpenes (since the majority of their pie chart is
        yellow), we will know that storing them needs to be done with
        extra-caution and that spending them sooner rather than later is
        probably the proper choice.
      </div>
      <div
        class="ql-block"
        data-block-id="block-13e0d968-afa4-4928-ab3e-ec44be3c9902"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-95a96bc5-f28c-4ea8-abd8-815c21e90c86"
      >
        We can also observe phenols - extraordinarily aggressive and pungent
        molecules which need to be handled with carefulness.
      </div>
      <div
        class="ql-block"
        data-block-id="block-35fe30ac-91cb-42bc-88bb-82d83bd2b621"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-1ab56d30-6cd1-4678-b343-9ed7c1e1fc10"
      >
        Let&apos;s take
        <a
          class="ql-link"
          href="https://app.dropsmart.io/oil/991"
          rel="noopener noreferrer"
          target="_blank"
          >Wild Bergamot (</a
        ><em
          ><a
            class="ql-link"
            href="https://app.dropsmart.io/oil/991"
            rel="noopener noreferrer"
            target="_blank"
            >Monarda fistulosa</a
          ></em
        ><a
          class="ql-link"
          href="https://app.dropsmart.io/oil/991"
          rel="noopener noreferrer"
          target="_blank"
          >)</a
        >
        as an example.
      </div>
      <div
        class="ql-block"
        data-block-id="block-ecf5430e-e552-4257-958b-2ff9e2ca4b4a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-314a9c55-f6f3-488f-b479-37a41687f02f"
      >
        We can see a low risk of skin sensitization upon using this oil -
        because of the portion of phenols within this oil. We can go as far as
        reading which phenols are represented and in what amount.
      </div>
      <div
        class="ql-block"
        data-block-id="block-abcff482-6260-49db-a57a-f386c0af9dec"
      >
        At the same time, the existence of these components gives incredible
        antimicrobial properties to this oil!
      </div>
      <div
        class="ql-block"
        data-block-id="block-085f702d-cba2-487e-ab68-46158c15ad07"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f6b07097-b986-4dbd-ba8a-6c676bb5c4e7"
      >
        The more we understand Dropsmart, the more we study it, and the more
        we&apos;re getting familiarized with essential oils components and
        colors - we will be extremely quick in recognizing what those oils are
        capable off &amp; how to get the most out of them!
      </div>
      <div
        class="ql-block"
        data-block-id="block-6866e3f1-6c7b-43f7-846b-5e1f81ec0e57"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-d1f42884-433b-40a3-8fd8-bb30a61bf617"
      >
        And this is where <strong>the true power of Dropsmart</strong> is
        unraveled!
      </div>
      <div
        class="ql-block"
        data-block-id="block-132e0123-5b33-47a7-8c0c-d87cf5dfb0d7"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-7f583c4a-9a15-43f0-b914-1cc0bb8fc9a8"
      >
        It stems from the fact that we don&apos;t only learn
        <strong>what&nbsp;</strong>but we also understand
        <strong>why</strong> behind all those properties we heard of before -
        but perhaps didn&apos;t fully acknowledge nor paid attention to.
      </div>
      <div
        class="ql-block"
        data-block-id="block-6237b0f6-9e32-4237-9da9-291f0461e7cd"
      >
        And this time, paying attention pays off! &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block ql-align-center"
        data-block-id="block-fadd7ac7-2b5e-4323-aa0c-1f8dfa7f1eb8"
      >
        <br />
      </div>
      <div
        class="ql-block ql-align-center text-center"
        data-block-id="block-30075fcb-08a1-48aa-8349-c7e05a1600d9"
      >
        To truly master this - we recommend
        <a
          class="ql-link"
          href="https://file.ontraport.com/media/891a138803ea4f2db7b3e07051f4bea5.phpyzdaju?Expires=1821530301&Signature=LwqDcARCLL06Ksbdl1AyzsiQzCsa9IKOijxljPyM2IG~Kv~mHP7PMtvEGCeXV0GGsY1KPfdwDr~3hTqpAfukxL5cG3aaNI-YWg2DKZOab0RN~V7KA1-mwc7FbZQrpVdrc-GwErVwWEIMdz3KR6LxfJkCkU62yBCwbly0WagOVQkCF3-~wFmM6MTvrZq~0l3k-jM4moP-7jmNT8HU8uYsecqEu9rpw9s5lKnwAykB-2YOh~8jJdMu9e-GLv0roogtGSmVtqnK0cEaJ3mKB41Zi9sVa8m-hU2Eq0Lj9VSIs1KwT0QmUVaQ6RQ4zYnczKGYgTqCOJ66-CJYqIxzggfrtA__&Key-Pair-Id=APKAJVAAMVW6XQYWSTNA"
          rel="noopener noreferrer"
          target="_blank"
          >DOWNLOADING BASIC GUIDE TO ESSENTIAL OILS CHEMISTRY</a
        >
        we prepared for you - complimentary, of course!
      </div>
      <div
        class="ql-block"
        data-block-id="block-71d1779e-21d0-45f1-8a3d-3b60c2aaf486"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-90487a25-5bc3-4065-baff-00929655185f"
      >
        We hope this step has uplifted you to the path of creativity,
        expression, and freedom with choosing and using your essential oils -
        and that all the next steps will continue.
      </div>
      <div
        class="ql-block"
        data-block-id="block-ecbaac02-1fd3-4d7f-95c3-46d7a38ff4cf"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-7fb2a572-0103-4f04-81bf-85b759777a90"
      >
        After all - we are doing the research, so you wouldn&apos;t have to.
        &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-bb7e7b19-c5fd-4523-a8d3-18116155a566"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a6cbfc6c-7d56-449c-ac5e-23787998118a"
      >
        We hope this was useful to you - thank you for your time, focus and
        attentiveness!
      </div>
      <div
        class="ql-block"
        data-block-id="block-8d5c33f7-f8d6-4522-8923-6c3d1c196ab4"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-6b14c4b7-de30-45be-ac8c-19550d25b23d"
      >
        We wish you a lovely day,
      </div>
      <div
        class="ql-block"
        data-block-id="block-717f754e-b51d-4919-a25e-90f949019326"
      >
        Dropmart Team
      </div>
      <div
        class="ql-block"
        data-block-id="block-a2a29eda-1507-4bbb-8d9c-7a6e22d7780e"
      >
        <em
          ><a
            class="ql-link"
            href="http://dropsmart.io/"
            rel="noopener noreferrer"
            target="_blank"
            >Dropsmart.io</a
          >
          - The most trusted essential oil resource center.</em
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-02820ce2-1ec9-4244-a609-9654ce17a1fa"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-325b2f3c-dba6-401f-bbce-eb8b81e9ca4a"
      >
        <strong>P.S.</strong> Today, we shared how we can use Dropsmart to get
        the most out of unusual, rare &amp; exotic essential oils that have
        little to no scientific references. As it turned out, by understanding
        chemical components, we&apos;re creating comprehension shortcuts - and
        are obtaining rationale for using a specific oil.
      </div>
      <div
        class="ql-block"
        data-block-id="block-3c305f6b-bb86-44c7-8a57-0544a509cfdf"
      >
        <br />
      </div>
      <div
        class="ql-block ql-align-center text-center"
        data-block-id="block-39af2352-b6b4-49a1-91c4-a44f384c0367"
      >
        <strong
          >Thanks for tuning in &amp; please continue your journey with the next
          step.</strong
        >
      </div>
    </article>

    <article v-else-if="stepNumber === 7">
      <p>
        Dear <span>{{ name }}</span
        >,
      </p>
      <div
        class="ql-block ql-align-center text-center"
        data-block-id="block-d2a8c26f-1399-4c17-ba1b-5ce667f2aedf"
      >
        <strong
          >We hope you&apos;re enjoying &amp; learning valuable things on this
          journey with us! &nbsp;🙂 &nbsp;</strong
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-5473dbf7-0402-435e-99fc-a38c99cca7db"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-2c326190-41b1-4a12-815c-23298b9bb18c"
      >
        In our previous step, we explained in depth how to use rare oils with
        little to no scientific data on them, and how to ensure we&apos;re
        getting the most out of their usage!
      </div>
      <div
        class="ql-block"
        data-block-id="block-7c8a1e8c-7ba1-4139-ad4c-aaccaeaaec06"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-9a2952a5-c133-4462-b924-c15f611d76b8"
      >
        Today we&apos;re continuing our journey by explaining why using fewer
        oils often presumes having more control.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b9026b32-47bd-45af-818a-cfdefac46d44"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-fedaadad-1ae6-4ba4-a2dc-5e159e0aa43a"
      >
        This exciting topic will unravel how using fewer oils brings us more
        control and how we can be more efficient by using fewer oils!
      </div>
      <div
        class="ql-block"
        data-block-id="block-61cd4e19-167f-42b2-95dc-fdf24b6aed8a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-26c97d92-a3ac-440f-8905-023a8d58a250"
      >
        What&apos;s quite funny but also worrying at the same time is that in
        the aromatherapy world, an idea persists, an idea which leads us to
        believe that the more oils we use, the more outstanding results
        we&apos;ll achieve.
      </div>
      <div
        class="ql-block"
        data-block-id="block-7e40841f-932e-4311-a6bd-5fa9c7274b51"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-76ef53a3-654f-492c-a9a3-18633bf8572a"
      >
        <strong>Which doesn&apos;t makes much sense.</strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-d2205ecc-333d-453f-9ac8-1946cbd009b0"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-d230d9ea-ffdb-480a-8b11-a7d0b36a58ee"
      >
        Mainly because by using more oils, more often than not, we&apos;re being
        pretty wasteful in many ways - environmentally, monetarily, and
        time-wise.
      </div>
      <div
        class="ql-block"
        data-block-id="block-df12913e-edbb-4400-8476-daa8265c1023"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b4282449-1ccc-4497-b636-c2cd8c518506"
      >
        But where does this idea even comes from?
      </div>
      <div
        class="ql-block"
        data-block-id="block-0694add9-3a0c-48ee-8fa8-0485dfca8cc1"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-6888fb49-5f7b-41c8-8c36-9fc7d614e6a0"
      >
        This idea is taught to us by the traditional (old) approach to
        aromatherapy.
      </div>
      <div
        class="ql-block"
        data-block-id="block-a421495f-3178-4904-8c55-ea5752385e6f"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-5c2f327e-83e3-4ca1-83f2-32e57611b260"
      >
        The approach which presumes to memorize what essential oils are for
        instead of understanding why they work the way they do.
      </div>
      <div
        class="ql-block"
        data-block-id="block-165ed946-f2bd-43ac-8fc0-bef70627715d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-d14ef100-d92b-483a-b71c-fbcd500492e2"
      >
        This model is outdated and non-effective simply because it makes us
        memorize information without truly understanding it.
      </div>
      <div
        class="ql-block"
        data-block-id="block-c8533631-8301-4bc5-a3bf-a2e76ce7dae2"
      >
        <br />
      </div>
      <div
        class="ql-block ql-align-center text-center"
        data-block-id="block-619e5d31-4ec8-44ba-8383-933c47280003"
      >
        <strong
          ><em
            >Hopefully, after following the previous steps, you understand why
            essential oils work the way they do, and you understand how knowing
            this makes a world of difference in your practice and life.</em
          ></strong
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-00f31720-26e3-40ea-952c-5ed580f0c487"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-fc0446d8-6993-450c-bcc4-12e0d6af8980"
      >
        Let&apos;s exemplify this with a typical blend you&apos;re likely to
        find in numerous blogs &amp; social media channels.
      </div>
      <div
        class="ql-block"
        data-block-id="block-d6d5c60b-7a98-4f6e-a978-2d85d154175f"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-d742929e-2093-41ad-9d0c-c746db853edb"
      >
        This time we analyzed a multi-purposed mixture named
        <strong>respiratory blend -</strong> a blend of essential oils we
        furthermore use in various products.
      </div>
      <div
        class="ql-block"
        data-block-id="block-9f137379-0423-47ea-bed7-65f40803dbb3"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-73a3207c-735c-425f-974f-43b68621c1f2"
      >
        This blend consists of:
      </div>
      <div
        class="ql-block"
        data-block-id="block-c0a15eaa-8999-4aa1-8285-178f4214e6c3"
      >
        <br />
      </div>
      <ul>
        <li>10 drops of Rosemary oil (<em>Rosmarinus officinalis</em>),</li>
        <li>10 drops of Lemon oil <em>(Citrus limon),</em></li>
        <li>
          20 drops of Peppermint oil <em>(Mentha &times; piperita), &amp;</em>
        </li>
        <li>10 drops of Eucalyptus Globulus <em>(Eucalyptus globulus).</em></li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-53dad45f-b976-428b-937b-31d424e7a666"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-51397194-bd90-4b68-affa-5f8e3af64be8"
      >
        In our previous step, we explained how mixing Eucalyptus Globulus with
        Rosemary doesn&apos;t make much sense due to the similarity in chemical
        constituents - and how it dilutes Rosemary&apos;s power.
      </div>
      <div
        class="ql-block"
        data-block-id="block-34f9826e-ef51-422c-9bdc-662d296bc3fa"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-2145359c-f3a3-44d9-99d8-95e7d2cc8322"
      >
        But, let&apos;s take a step-by-step approach with this one to avoid
        wasting money, time, and the environment.
      </div>
      <div
        class="ql-block"
        data-block-id="block-18a0576a-b766-40c8-a6f2-4c3b30c702b3"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-2dd02de3-372a-4496-b4eb-57b2aecc80d5"
      >
        Despite their healing properties and variety of application suggestions,
        if we truly analyze this blend (starting with the colors), we can easily
        see that it&apos;s over the top - and not in a good way!
        <span
          class="ql-emoticon"
          data-emoticon='{"code":"1f62e","name":"Face with Open Mouth"}'
        >
          <span contenteditable="false"
            ><span class="ql-emoticon-icon" style="font-family: initial;"
              >😮</span
            ></span
          > </span
        >&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-c5565d43-3888-4434-973f-11abc8553ff5"
      >
        <br />
      </div>
      <div
        class="ql-block ql-align-center text-center"
        data-block-id="block-e36c3e1f-40f8-4132-956f-ea2eaea1e007"
      >
        Why? What&apos;s an unneeded extra?
      </div>
      <div
        class="ql-block"
        data-block-id="block-0a895276-fe2c-4cfe-bbc0-aa6629101699"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-59bb1863-73f2-494b-8fbb-e993eeed7950"
      >
        Let&apos;s start with the high presence of monoterpenes in both Rosemary
        and Lemon.
      </div>
      <div
        class="ql-block"
        data-block-id="block-60d98830-a85d-45d6-b411-55c453ccf288"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-3aceb7ef-6e51-48ab-bed4-62187c71506d"
      >
        Are high quantities of these constituents needed in both oils we&apos;re
        blending?
      </div>
      <div
        class="ql-block"
        data-block-id="block-9edb89bd-de2b-4eb1-9c32-78e1c4578ab9"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f2ee8266-a5d2-4a5b-a04c-213211262162"
      >
        Not really.
      </div>
      <div
        class="ql-block"
        data-block-id="block-05c1c99d-03c7-4a1e-b33f-c34da7e20acc"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-6716d0c1-e6bc-4a6c-8f5f-39f1834617ec"
      >
        Then let&apos;s take a look at the presence of 1,8 cineole in Eucalyptus
        Globulus, Rosemary, and Peppermint.
      </div>
      <div
        class="ql-block"
        data-block-id="block-6c1f11d7-c5d9-497d-850d-5f9628741cfe"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-fdb882e0-701f-4e93-8db6-433d6fee9e5e"
      >
        Do we need its presence in all three oils in these amounts?
      </div>
      <div
        class="ql-block"
        data-block-id="block-1a9687e7-608c-4b50-9c8a-5e18b52bed39"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-d47bd7c5-679b-4904-bca1-41d47da928d2"
      >
        Mostly definitely not.
      </div>
      <div
        class="ql-block"
        data-block-id="block-2537be6e-dfd6-4f54-a3b4-b83bd6b4f06e"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a9692b4f-55e4-4bd2-8007-973cd37557ac"
      >
        Before you start feeling uncomfortable because you don&apos;t know all
        this information by heart - put your heart at ease because we
        <strong>have a solution&nbsp;</strong>within Dropsmart, called a
        Comparison Tool.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b4d61c5a-6a70-469f-a010-6f785144d1cc"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-af8f1ff6-30a9-448b-9847-3ff27a8c85cb"
      >
        The Comparison Tool, in line with the new age method we stand for,
        doesn&apos;t force you to memorize constituents of various essential
        oils by heart just because that&apos;s quite the opposite of what we
        advocate.
      </div>
      <div
        class="ql-block"
        data-block-id="block-c7171dfd-dcdc-4e6c-b1c1-5623adf486c4"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-384ac4c0-ff24-4e91-b8e6-f0bc525d51a4"
      >
        The Comparison Tool allows you (amongst other things) to quickly and
        efficiently compare chemical constituents of different essential oils to
        spot similarities and avoid repetitiveness.
      </div>
      <div
        class="ql-block"
        data-block-id="block-947e596c-2942-4971-bcfc-03326bc9b68a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-95897906-0ff2-44f6-bb06-c6f7cf884a21"
      >
        Now, back to the respiratory blend.
      </div>
      <div
        class="ql-block"
        data-block-id="block-16751c99-36b0-49d4-b532-02c9865879e8"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-42626e65-eb78-4e1a-928c-d351178dff9e"
      >
        To explain its wastefulness of it, we&apos;re going to, once again, use
        chemistry.
      </div>
      <div
        class="ql-block"
        data-block-id="block-677a8d1d-85cd-4240-8569-89f267613676"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-14f89fa4-3148-491a-9f23-1724e67699e3"
      >
        Upon comparing the chemical constituents of these 4 essential oils, we
        can automatically notice 2 main issues with this blend.
      </div>
      <div
        class="ql-block"
        data-block-id="block-f82cf94e-eed6-4b0f-b140-a99fbdf0d54d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-c0238f36-9c68-448d-a920-f41d174d42ea"
      >
        Monoterpenes, especially alpha-pinene, is repeated in all four essential
        oils, which isn&apos;t necessary <strong>at all.&nbsp;</strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-b36dd179-6111-4426-8865-abfe5300a8f6"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-1a21ab02-5352-439c-8fe2-c8d2507e21cd"
      >
        As stated before, Rosemary has everything that Eucalyptus has as well.
      </div>
      <div
        class="ql-block"
        data-block-id="block-2f8dddc4-ab87-4425-9e50-7b323a1e3c75"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a420b6ce-5986-4b4e-95bc-7832de56cdad"
      >
        The next repetitive component is each oil limonene. Which, once again,
        has no &quot;higher purpose&quot;. Or purpose (in repetition) to begin
        with.
      </div>
      <div
        class="ql-block"
        data-block-id="block-59143249-2447-44e9-85d2-cc72e7136de3"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b6aa766b-392d-4018-ba65-e74cac2d6f6e"
      >
        Especially by understanding that limonene is far from being the more
        efficient chemical component for the respiratory system.
      </div>
      <div
        class="ql-block"
        data-block-id="block-bec6d324-0a81-4cf2-b947-3ab643898de8"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a4cc37ca-cafc-4b4a-8cde-0c4ee8640f00"
      >
        The presence of 1,8 cineole is also observed in all oils enlisted - once
        again, without much point to it.
      </div>
      <div
        class="ql-block"
        data-block-id="block-dd48fe35-78b9-42df-990d-da07a02a2a3a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f4626723-3529-403c-9373-a3e73e1ca8bd"
      >
        To make this even more interesting, we have created a
        <strong>simplified version of this respiratory blend.&nbsp;</strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-6d4a1c67-b998-4ea6-9aea-19beb816f7e3"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-d1d4edf3-1539-4f8f-ab7e-a635a2fa1d67"
      >
        Our version consists of 2 essential oils only: 30 drops of Rosemary
        &amp; 20 drops of Peppermint - but it has the same (if not more
        efficient) healing properties as well as the number of suggested
        application methods.
      </div>
      <div
        class="ql-block"
        data-block-id="block-170d9172-eda1-489b-911a-34c69768b703"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a336c7a3-a2a1-42c1-a890-71090cd25994"
      >
        So we&apos;re saving time, money &amp; environment with this blend - not
        something we can say for the &quot;original&quot; one.
      </div>
      <div
        class="ql-block"
        data-block-id="block-09894347-27c1-4243-828e-6ddfa594b7ba"
      >
        <br />
      </div>
      <div
        class="ql-block ql-align-center text-center"
        data-block-id="block-9c4cc407-d15d-4700-b39f-4ad75a6dd219"
      >
        But let&apos;s convince you even further - by outlining the pie chart of
        this blend! &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-7eb9cc1c-597c-4878-9c2d-cd96b6b415db"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-35147c45-59e4-4af5-b9d7-43bbf24c9a12"
      >
        The example presented in the video shows that those two pie charts are
        almost identical.
      </div>
      <div
        class="ql-block"
        data-block-id="block-89bb061f-c348-404f-88e3-ca931813c91c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-374a31c9-cdab-4785-8a64-18c30c09902c"
      >
        Even though one contains 4 essential oils and another &quot;just
        2.&quot;
      </div>
      <div
        class="ql-block"
        data-block-id="block-018b114c-ba96-4c6c-aff0-701b33c9f4b0"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-efa21f02-13b8-451a-be0a-d5a655839ae7"
      >
        Even more so, in the second blend (our blend), we have more constituents
        effective for the respiratory system after cleaning up the unnecessary
        ones (such as ketones, which make this blend more dynamic).
      </div>
      <div
        class="ql-block"
        data-block-id="block-0680bf62-1fa9-44fa-842e-210ac72fafb9"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-5bd2971f-af8c-4014-b8cd-5600d7df3922"
      >
        This leads us towards a true understanding that the less is more - and
        that with fewer essential oils, we can gain both: more control &amp;
        better results.
      </div>
      <div
        class="ql-block"
        data-block-id="block-ded30a22-482f-41e9-b65f-edf1db9c79e4"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-21f38c28-df07-4463-9ebe-510ebbcd492a"
      >
        <strong>How so?&nbsp;</strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-acf6a4cd-918e-4845-b995-8585b95bcaf2"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-3ca9fb6e-9620-4136-ada0-0d396c933f13"
      >
        Let&apos;s imagine we desire to improve our initial blend because, for
        example, our client&apos;s results are relatively mellow or sensitive to
        the phototoxic component found in lemon.
      </div>
      <div
        class="ql-block"
        data-block-id="block-f88a8ce4-14ea-407b-9e14-5d40626529c7"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-e1f9812c-aae5-4264-ac3b-a1198fe2be95"
      >
        By merely using common sense, it&apos;s simple to conclude that if a
        blend isn&apos;t working as we&apos;d hope it will, it&apos;s much
        easier to deduce which essential oil should be replaced in a blend
        consisting of 2 oils than in a blend consisting 4.
      </div>
      <div
        class="ql-block"
        data-block-id="block-d5da6175-3940-4339-9760-ec1078e5dfcb"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-bda1fe17-ee4a-4f60-ba54-b4d39faba821"
      >
        Perhaps we decide to add another essential oil to the blend, which will
        boost the efficiency of this blend, for example, Lavender, which
        won&apos;t be repetitive respectfully to the oils we already have.
      </div>
      <div
        class="ql-block"
        data-block-id="block-c2e172ca-0358-44fb-9f73-1cd07dff0129"
      >
        As you surely know, more essential oils result in more complexity
        product-wise.
      </div>
      <div
        class="ql-block"
        data-block-id="block-96e5b7af-96b5-4b64-8870-9d4a854c200e"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-560377cc-3726-4ff9-ba07-49e052595929"
      >
        If we, on top of it, add the fact that each batch is different, we risk
        bringing even more confusion into this &quot;understanding
        protocol.&quot;
      </div>
      <div
        class="ql-block"
        data-block-id="block-52b7f85b-1485-4f8e-9ad8-49fa049f3701"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-20c601dc-e331-443d-bc73-685c8a9f643e"
      >
        Ideally, this step has also showcased how relying on other people&apos;s
        opinions, materials, and perspectives (e.g., blogs, articles, posts,
        etc.) is a double-edged sword as opposed to truly understanding the
        dynamics of a particular essential oil, which is, almost certainly, a
        win-win scenario.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b1c75a1a-713b-4680-826e-c0c2d303d4e0"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-21a00b91-854a-4dc4-8f9a-474d145b9ec5"
      >
        Upon understanding how to read the detailed report and taking the extra
        mile of analyzing it, we notice if constituents are repetitive, we
        understand the percentage of ratios &amp; at the end of the day; we have
        freedom of choice when it comes to blending, recommending, and proving
        efficiency.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b3cf0883-f56b-4598-9e22-c51333fb264d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-63183886-c1a5-490d-b420-ddd4a0d39d93"
      >
        We hope this was useful to you - thank you for your time, focus and
        attentiveness!
      </div>
      <div
        class="ql-block ql-align-center"
        data-block-id="block-d9db943b-03a1-4425-824b-d9f950620280"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-d207b2b3-0e2a-45e7-abbf-75ec92401506"
      >
        Also, don&apos;t miss out on the chance to learn more with us🙂!
      </div>
      <div
        class="ql-block ql-align-center"
        data-block-id="block-d6bb2539-1bc1-493b-a69e-fa84ae13fb59"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-178e5c2d-0096-446f-a0ca-56f2b7cfb74b"
      >
        We wish you a lovely day,
      </div>
      <div
        class="ql-block"
        data-block-id="block-c10d3c32-6339-4fb1-833c-114563f61f90"
      >
        Dropmart Team
      </div>
      <div
        class="ql-block"
        data-block-id="block-e11ddf93-a2f1-47e9-a66d-7d06695695f5"
      >
        <em
          ><a
            class="ql-link"
            href="http://dropsmart.io/"
            rel="noopener noreferrer"
            target="_blank"
            >Dropsmart.io</a
          >
          - The most trusted essential oil resource center.</em
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-279c370c-b2d3-4cea-8934-449ef091ac42"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-7b45a33a-988c-4072-a4be-0ff6524cda94"
      >
        <strong>P.S.</strong> Today, we shared less is more and how you can
        obtain more control over your blends if you combine fewer oils (compared
        to many).
      </div>
      <div
        class="ql-block"
        data-block-id="block-363b5ac1-52a9-4d36-aa6d-fa99bf64d891"
      >
        <br />
      </div>
      <div
        class="ql-block ql-align-center text-center"
        data-block-id="block-329872cc-d5c6-43cf-a429-eb26257f51d4"
      >
        <strong
          >Thanks for tuning in &amp; please continue your journey with the next
          step.</strong
        >
      </div>
    </article>

    <article v-else-if="stepNumber === 8">
      <p>
        Dear <span>{{ name }}</span
        >,
      </p>

      <div
        class="ql-block"
        data-block-id="block-99344e39-f936-4cc2-966a-b9d877371089"
      >
        In our previous step, we showed you how less is more and how by
        combining (blending) fewer oils, you are saving time &amp; money while
        being environmentally friendly.
      </div>
      <div
        class="ql-block"
        data-block-id="block-cb4c43d5-e753-4568-81cf-fd6dfac92585"
      >
        <br />
      </div>
      <div
        class="ql-block ql-align-center text-center"
        data-block-id="block-f1322c42-14cf-4677-a941-6dbf48f07691"
      >
        <strong
          >We hope you&apos;re enjoying &amp; learning valuable things on this
          journey with us! &nbsp;🙂 &nbsp;</strong
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-9c15b1d2-b17d-4907-bc9c-5d5359b5404d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b11b1ace-cd4f-497c-8007-de510da5245a"
      >
        Today we&apos;re continuing with our journey by leading you from
        guesswork to certainty, so you can feel empowered to explain
        <strong>why your blends work</strong> and
        <strong>your formulas are successful!&nbsp;</strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-b3a47c04-4fc2-4ba2-8a78-ebfba97d3486"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-be4bba0f-037b-46b2-b20b-a23be0ff8210"
      >
        To do that, we will use a study that went wrong as an example.
      </div>
      <div
        class="ql-block"
        data-block-id="block-c4ba6adf-fc2c-41f5-a5d8-34d2807c872d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-78df38cd-d5b0-4434-b50a-3ed11293046c"
      >
        During this study, a specific blend was used to ease pain, induce sleep
        and increase the stride length.
      </div>
      <div
        class="ql-block"
        data-block-id="block-fa353812-db64-48aa-99ed-bec9c909047c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-37353cb7-98d1-4143-9bb1-0260ecc0ec79"
      >
        Automatically, we can notice a first red flag (as mentioned in the
        previous step) - whereas less is more.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b7b28329-b3b4-4450-a000-6cc2f26e6fe3"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-8028cb0e-8f6f-4a94-a3f2-1be70d73427f"
      >
        In the same way, as using fewer essential oils gives us better control
        over them (and their efficiency), having fewer goals for a specific
        blend is recommendable too.
      </div>
      <div
        class="ql-block"
        data-block-id="block-ceb2b1f7-7ebe-4fe8-bed0-8a228abbeb89"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-55c62920-5d9c-4cd5-a7a6-a0fe65617822"
      >
        In this specific case, aiming at obtaining sleep-inducing properties
        while at the same time aiming to increase the stride length are two very
        much contradictory goals.
      </div>
      <div
        class="ql-block"
        data-block-id="block-2dbdebdf-fc58-41e4-86ff-4224c321414a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-9454d11c-66a5-4579-8ea5-fff7839bdaeb"
      >
        So here, we can automatically conclude that what should&apos;ve been
        done is to create one blend for sleep and another one for stride length,
        as trying to bind them together was a great mistake.
      </div>
      <div
        class="ql-block"
        data-block-id="block-5f7833c6-8983-484c-8dd1-e0416c7b4385"
      >
        Upon observing oils used in this study:
      </div>
      <div
        class="ql-block"
        data-block-id="block-33a652c8-04d1-4184-b3f1-856f6d3facd9"
      >
        <br />
      </div>
      <ul>
        <li>Rosewood&nbsp;(<em>Aniba rosaeodora</em>),</li>
        <li>Eucalyptus Radiata (<em>Eucalyptus radiate</em>), &amp;</li>
        <li>Wild Mint (<em>Mentha arvensis</em>).</li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-2c4b40b5-7cb7-4f9f-aa4e-a63e61e34c0e"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-2bffbfda-7d33-470c-993a-14109d5f03a4"
      >
        We can understand why Rosewood was used - to cover pain and sleep. In
        addition, Eucalyptus Radiata does cover pain and stride length, hence
        being part of this blend. The same applies to the Wild Mint - regarding
        addressing pain and stride length.
      </div>
      <div
        class="ql-block"
        data-block-id="block-7a275ff1-6b68-4e19-aec0-39fd26f7d688"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-4573b013-b406-43cc-a31f-dc0d5fe0b182"
      >
        However, many mistakes are made due to memorizing essential oils instead
        of understanding the dynamics behind them and not understanding the
        <strong>why</strong> behind an oil or a blend.
      </div>
      <div
        class="ql-block"
        data-block-id="block-104bef93-a7a3-4d87-86bb-b8286eeadbd5"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-bb3eb46a-7085-456d-94de-1b20ac169bd7"
      >
        In this case of this example, the idea existed that by adding several
        different types of essential oils with different properties (sleep,
        pain, endurance), a superb blend that addresses all of the issues
        connected to the properties will be created.
      </div>
      <div
        class="ql-block"
        data-block-id="block-5fd074c7-3dfb-4893-aaf5-fdff74080b50"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-56583c8e-de69-4d1b-9955-af470d99981f"
      >
        Which cannot be farther from the truth since applied chemistry
        <strong>doesn&apos;t work that way.&nbsp;</strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-5f4f752b-873f-4bad-b5e0-bb21ba0bc05e"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-33ca5100-8411-495d-995f-9f51063b9e1c"
      >
        In other words, it&apos;s necessary to know why something works the way
        it does - for example, why the essential oil we use for pain works on
        pain.
      </div>
      <div
        class="ql-block"
        data-block-id="block-5ae7d963-745e-4501-9ce9-6794806cf8a6"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-07c82245-e110-400a-8c32-ab767cd4033e"
      >
        In this case, not only will we know why (or not) to use a specific oil,
        but we&apos;ll also learn how much of it we need.
      </div>
      <div
        class="ql-block"
        data-block-id="block-335ab366-9c6d-4960-acee-cbf83cbb32b8"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-34f96277-f0c3-474c-9fa4-ef6fc8e33135"
      >
        This can be explained additionally in the Comparison tool, especially if
        we compare Rosewood, Eucalyptus Radiata &amp; Wild Mint.
      </div>
      <div
        class="ql-block"
        data-block-id="block-089419ae-0df1-4c9d-ad0c-a7f1d42a6492"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f17f0558-fe0e-4a56-88bd-d061782b3dfd"
      >
        For example, Rosewood is the only oil in this blend that has been
        researched and has references confirming its sedative properties due to
        the high ratio of linalool present. And linalool is, as we mentioned
        earlier, a relatively powerful sedative chemical constituent.
      </div>
      <div
        class="ql-block"
        data-block-id="block-e5123ed8-ce90-4fea-93c1-de2be462266d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-da3a4fd0-0d9d-4487-bf98-67567ef1e400"
      >
        It&apos;s good to remember that the Comparison tool &amp; virtual
        blending simulator can be exquisite allies in our practice - since we
        can check what chemistry tells us before we even create a blend in real
        life.
      </div>
      <div
        class="ql-block"
        data-block-id="block-f6d9d790-8238-455b-9519-8532983703f2"
      >
        But going back to the first blend mentioned - and defining where it went
        wrong, the answer is, as always, in the chemical constituents.
      </div>
      <div
        class="ql-block"
        data-block-id="block-e14d4bdd-3590-45c4-959c-33ab5aef6537"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f03f27b9-e948-4771-a086-eba30fb8de97"
      >
        Upon comparing the properties, it has been clear that the sedative
        properties of linalool found in Rosewood will fight against the
        activation properties of menthol present in the Wild Mint.
      </div>
      <div
        class="ql-block"
        data-block-id="block-8edff2c3-94d6-4d4a-b0f9-17a38d7b341d"
      >
        So what can we do to change that and create a powerful and efficient
        blend?
      </div>
      <div
        class="ql-block"
        data-block-id="block-97c1476b-d61c-4067-8b43-468773bf8c7d"
      >
        We want to go back to basics - and observe the initial goals.
      </div>
      <div
        class="ql-block"
        data-block-id="block-35a73ef8-8e8c-4577-a886-acbfb2bf8ec3"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-de3b17eb-aa50-46eb-9d67-905fe9004cd5"
      >
        The main goals were to tackle:
      </div>
      <div
        class="ql-block"
        data-block-id="block-405a3cff-957d-4227-99e6-ce110496f0ae"
      >
        <br />
      </div>
      <ul>
        <li>pain,</li>
        <li>sleep, &amp;</li>
        <li>stride length</li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-5e920317-c2dd-46dd-b742-319e2bc35dc7"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-3e1b3c55-65f8-4b09-bdd9-4aba4e6e9011"
      >
        with this blend.
      </div>
      <div
        class="ql-block"
        data-block-id="block-7f8a0485-eabc-41bb-acab-1ef8b89a0ab7"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-9ad54ba7-ea6a-4996-9e08-1a63322c867e"
      >
        So our first step is to go into Dropsmart and search for oils
        recommended for sleep.
      </div>
      <div
        class="ql-block"
        data-block-id="block-d3e737e7-f12b-4fbf-9ff5-10d639cb5608"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-81fbb138-d4af-4a92-b284-5dc620b0aecc"
      >
        Upon the plethora of options, we filter them by trying to get a
        selection of essential oils exclusively high in linalool - one of the
        main sedative constituents in the Rosewood essential oils.
      </div>
      <div
        class="ql-block"
        data-block-id="block-88c9378c-7af7-4ef3-87d2-37e8c8ad3edd"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b75deb72-b12f-4047-8a53-12b40a364805"
      >
        By doing this, we narrowed our choice down to 45 recommendations.
      </div>
      <div
        class="ql-block"
        data-block-id="block-86cd37fe-bd3a-4a94-b60f-95d6eaf11403"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-c6f75ba6-db33-4b36-a5a3-8b6620130c54"
      >
        In addition to this filtering method, we&apos;re going to search for a
        combination of linalool &amp; linalyl acetate since this mix is very
        well researched and often used for sleep and pain. The combination is
        present in some of the more popular oils such as Bergamot (<em
          >Citrus bergamia),</em
        >
        Lavander (<em>Lavandula angustifolia</em>) &amp; Neroli (<em
          >Citrus &times; aurantium).&nbsp;</em
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-f03b834b-646a-4df9-b895-e351a3333d20"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-09e9e77c-4a40-469e-bf87-834818b700c4"
      >
        To spice the search and be a tad more creative &amp; bold, we&apos;re
        going to opt for the Linaloe berry
        <strong
          ><em
            ><span
              class="ql-comment"
              data-comment-ids="1201468533"
              data-comment-unresolved-ids=""
              >Bursera linanoe</span
            ></em
          ></strong
        ><span
          class="ql-comment"
          data-comment-ids="1201468503"
          data-comment-unresolved-ids=""
          >.</span
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-0c886173-c828-4f6b-8fc6-8ae4cdca40e4"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-424d9b45-c3fb-40ea-90bb-2a57f6f55e8a"
      >
        Although this essential oil isn&apos;t very well-researched and no one
        has written about it, there are no safety hazards or recommendations,
        which makes it quite safe to use.
      </div>
      <div
        class="ql-block"
        data-block-id="block-c9714a28-c0a2-4a92-a9a7-c66f77ecd8db"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-949d6b9a-3c76-4716-83c0-44f4d0ef3d8d"
      >
        By simply glimpsing through the colorful pie chart, we can notice quite
        a high amount of monoterpenes alcohols &amp; monoterpene esters, as well
        as the highly dominating amount of linalool &amp; linalyl acetate -
        which makes it a fantastic choice for a sedative and analgesic
        properties both.
      </div>
      <div
        class="ql-block"
        data-block-id="block-4868fe1d-2353-4333-8b4d-cfbf4d2d173c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-cf3e0906-5637-4e7c-9808-f47d57e007fc"
      >
        So we&apos;ll use this incredible oil with certainty it will work like a
        charm - for sleep &amp; pain alike.
      </div>
      <div
        class="ql-block"
        data-block-id="block-98914054-a94c-4a28-a64d-2f876472aa5e"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-cda5d1db-45ed-491e-85ac-fab38f565745"
      >
        And this is how we choose the oils - and make the right choice.
      </div>
      <div
        class="ql-block"
        data-block-id="block-a3e7d62d-ce89-4786-80ec-65c3915a25df"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-45a764d3-dbed-4fde-a77b-e69c3f8817e6"
      >
        Once we look at what essential oil is made from, we will know exactly
        how to use it.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b592ccbb-9653-43ab-be6c-d419fd10a9b3"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-12b43264-03f2-49ca-beb3-0fff37fb983e"
      >
        We hope this will help you to use essential oils with confidence and
        success, as well as to build from one oil to the blend, and so forth.
      </div>
      <div
        class="ql-block"
        data-block-id="block-d3fddc62-e6c9-4dd7-8bcf-25e211f502cb"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-8fe6720e-9e8e-4e71-88ef-b8330ddbf314"
      >
        Thank you for your time, focus and attention.
      </div>
      <div
        class="ql-block ql-align-center"
        data-block-id="block-98b1b8cd-0fb6-43e1-9096-bb55ed0a1ae8"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-c7a70b2e-2c63-4750-91fa-71d7763f07e2"
      >
        We wish you a lovely day,
      </div>
      <div
        class="ql-block"
        data-block-id="block-8982533f-6863-4613-9a45-c7586aa757be"
      >
        Dropmart Team
      </div>
      <div
        class="ql-block"
        data-block-id="block-6e14c870-6c7e-4efc-b9d4-caac2ac43705"
      >
        <em
          ><a
            class="ql-link"
            href="http://dropsmart.io/"
            rel="noopener noreferrer"
            target="_blank"
            >Dropsmart.io</a
          >
          - The most trusted essential oil resource center.</em
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-b96b9ebc-754b-4cd5-997a-fa347b7f07f0"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-79eab274-0a5a-4bc4-a72f-63bfeeeff6e4"
      >
        <strong>P.S.</strong> Today, we used a non-successful case study to
        emphasize the importance of understanding why behind the what &amp; how
        factors to make sure you create the best blends ever!
      </div>
      <div
        class="ql-block"
        data-block-id="block-25c2c889-3f19-4e8b-8a74-f683b52b1cc8"
      >
        <br />
      </div>
      <div
        class="ql-block ql-align-center text-center"
        data-block-id="block-13a77c0d-cc9d-4db4-88c5-75555f11fdab"
      >
        <strong
          >Thanks for tuning in &amp; please continue your journey with the next
          step.</strong
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-c8137894-4df4-4587-85fb-118a0ba83613"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-dc655539-dde8-4b14-82ac-bf6cd10c8d54"
      >
        <strong>References:</strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-7ab06434-aa1c-4368-8064-bb5c23f653b3"
      >
        <br />
      </div>
      <ul>
        <li>
          De Almeida RN, Ara&uacute;jo DA, Gon&ccedil;alves JC, Montenegro FC,
          de Sousa DP, Leite JR, Mattei R, Benedito MA, de Carvalho JG, Cruz JS,
          Maia JG. (2009) Rosewood oil induces sedation and inhibits compound
          action potential in rodents, Journal of ethnopharmacology,
          124(3):440-443.
        </li>
        <li>
          De Siqueira RJ, Rodrigues KM, Da silva M.T., et al. (2014)
          Linalool-rich rosewood oil induces vago-vagal bradycardic and
          depressor reflex in rats. Phytother Res. 28(1):42-8.
        </li>
        <li>
          Dos santos &Eacute;RQ, Maia CSF, Fontes junior EA, Melo AS, Pinheiro
          BG, Maia JGS. (2018) Linalool-rich essential oils from the Amazon
          display antidepressant-type effects in rodents. J Ethnopharmacol.
          212:43-49.
        </li>
        <li>
          Sampaio Lde F, Maia JG, De parij&oacute;s AM, De Souza RZ, Barata
          LE.(2012) Linalool from Rosewood (Aniba rosaeodora Ducke) oil inhibits
          adenylate cyclase in the retina, contributing to understanding its
          biological activity. Phytother Res. 26(1):73-7.
        </li>
        <li>
          De Almeida RN, Ara&uacute;jo DA, Gon&ccedil;alves JC, et al. (2009)
          Rosewood oil induces sedation and inhibits compound action potential
          in rodents. J Ethnopharmacol. 124(3):440-3.
        </li>
        <li>
          Katsuyama S, Kuwahata H, Yagi T, Kishikawa Y, Komatsu T, Sakurada T,
          et al. (2012) Intraplantar injection of linalool reduces
          paclitaxel-induced acute pain in mice. Biomed Res, 33(3):175&ndash;81.
        </li>
        <li>
          Ghelardini C, Galeotti N, Salvatore G, Mazzanti G. (1999) Local
          anesthetic activity of the essential oil of Lavandula angustifolia.
          Planta Med 65:700-703.
        </li>
        <li>
          Ou MC, Hsu TF, Lai AC, Lin YT, Lin CC. (2012) Pain relief assessment
          by aromatic essential oil massage on outpatients with primary
          dysmenorrhea: a randomized, double-blind clinical trial. J Obstet
          Gynaecol Res, May, 38(5):817-22.
        </li>
        <li>
          Buchbauer G, Jirovetz L, J&auml;ger W, Dietrich H, Plank C. (1991)
          Aromatherapy: evidence for sedative effects of the essential oil of
          lavender after inhalation. Z Naturforsch C, Nov-Dec,
          46(11-12):1067-72.
        </li>
      </ul>
    </article>

    <article v-else-if="stepNumber === 9">
      <p>
        Dear <span>{{ name }}</span
        >,
      </p>
      <div
        class="ql-block ql-align-center text-center"
        data-block-id="block-806a0f70-c84f-44f4-8f04-55adb50ac75d"
      >
        <strong
          >Hopefully, you&apos;re having as much fun as we do on this
          exploratory journey! &nbsp;🙂 &nbsp;</strong
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-8502631e-e7dc-41e0-b98a-07c2852a9fac"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-5ec2f540-6bb6-4042-9015-ea6915dbb555"
      >
        In our previous step, we discussed how and why we should cut out the
        guesswork and gave an example of a study that didn&apos;t work out to
        highlight the outdated thinking method, which is best left forgotten
        &amp; suggests an incredible alternative!
      </div>
      <div
        class="ql-block"
        data-block-id="block-5cce7074-efd1-4e7a-bade-d69504175e60"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-62785c97-7305-4a2a-8365-2df7c97b8259"
      >
        Today we&apos;re going to explain how one can recognize smell through
        color (and how to do that). We can are going to link colorful chemistry
        with astounding healing properties, and close-up how can you see that
        yourself by simply looking at the pie charts in Dropsmart.
      </div>
      <div
        class="ql-block"
        data-block-id="block-445e9890-73dc-499f-8a30-375c6fa2713a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-5dbc9393-fac0-40ab-aa3d-4815982110db"
      >
        Buckle up, Dropsmarter - since we have a fun trip ahead! 🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-5835a20f-1482-42a2-9339-1b8db0a41ce6"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-42bb55c9-f344-44ad-9d5d-93172e00e58a"
      >
        With prolonged usage of Dropsmart, you will become more familiar with
        colors and automatically connect them to chemical constituents.
      </div>
      <div
        class="ql-block"
        data-block-id="block-634ad145-abe5-4279-8d77-2ff39c87c4cd"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-ab2831bb-eafb-408a-8664-e00c18eb72a0"
      >
        For example, after a while, you&apos;ll instinctively connect the color
        orange with monoterpenes, purple with esters, blue with ketones, green
        with sesquiterpenes, and so on.
      </div>
      <div
        class="ql-block"
        data-block-id="block-9874015e-72ad-46fc-9ce1-597979e42aed"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-13454955-d0a4-4726-9905-7b6c3c35b35b"
      >
        Suppose you&apos;ve already become familiar with these constituents and
        their belonging colors. In that case, you&apos;ll love the following
        content, but if not, you&apos;ll also appreciate it - since we&apos;re
        going to be as simplistic and direct as possible.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b751d46f-3237-4be1-bdb0-748be40793c7"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-d0306e6a-ca57-460c-a926-0363d05be49a"
      >
        The posed question is, how can we know which smell is connected to which
        color, and how can we use it in our practice quickly and efficiently?
      </div>
      <div
        class="ql-block"
        data-block-id="block-12c8399b-704d-4d63-b481-85b0aaa81287"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b9d7c447-4bd4-45d0-b66a-d174603e65f9"
      >
        First, we start by clicking on the Advanced Filter and opening the
        chemical groups &amp; components section, where all the main chemical
        constituents are neatly displayed.
      </div>
      <div
        class="ql-block"
        data-block-id="block-3ef6a4f7-c06b-4155-87ba-48054d315e56"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-5f4b87c5-0e40-42ed-a75f-a12c03d93ed9"
      >
        Clicking on the plus sign next to any major component will open a
        subcategory.
      </div>
      <div
        class="ql-block"
        data-block-id="block-1cfc86ba-bd81-418b-aafb-2b9e02c8a850"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b2500c78-662b-4448-ad8b-d3958ff05a6c"
      >
        E.g., Hydrocarbons - monoterpenes, sesquiterpenes, diterpenes, etc.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b19d206a-6b74-4bbf-ab2c-1d1bff6728ba"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-52bf7fbb-db41-4014-b398-0f14dfd30ea6"
      >
        The reason for this divination of categories lies in the division of
        functionality between primary and secondary components.
      </div>
      <div
        class="ql-block"
        data-block-id="block-7aacd536-c1a2-467d-990e-97de2fc060fb"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-12c57035-c110-4977-a6fa-369cb4fda283"
      >
        To get more details on this specific division, we recommend
        <a
          class="ql-link"
          href="https://file.ontraport.com/media/891a138803ea4f2db7b3e07051f4bea5.phpyzdaju?Expires=1821541031&Signature=Ibq99O3TklooRBEthTnZN345QFzVc91Cxb~FbQ4UGoq~sl33CGX8Y1oVz3Dh4uBZvjGU-oAS5-6fKBzP4Eiwl2UMw3DJh-ll5-rzfr8Z243UOz9ibjv4AC2h9uehjVMNn52xmB8vxOTpP6K7pRCG5RGE8uK1Zg81fSwRU9bnT2vTUpZEgoINJg8lMVuIR3vch-FzO3Xqo8Q0SAXTin6YJNcqblBVNp~4c1CUgsxknmbwu9-cOUrjLGi7kP1R0YpxnQc8X1O-f08tRYsxwgkca7i0O~mFmSAtXBVpwBe5HfzYqXrP-aVVmrNBiVm9EWKuRiOtW1EqSNrCWLIXUKfAsw__&Key-Pair-Id=APKAJVAAMVW6XQYWSTNA"
          rel="noopener noreferrer"
          target="_blank"
          >THE BASIC GUIDE TO ESSENTIAL OILS CHEMISTRY&nbsp;</a
        >we prepared for you (click the capital letters to start the download).
      </div>
      <div
        class="ql-block"
        data-block-id="block-502e8741-9de6-441b-b29c-c94c38d9041a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-177f911d-0ce2-4b1c-ace0-e224797eddb2"
      >
        But going back to the original answer on the color/smell connection -
        the first thing we want to look at is the molecule&apos;s size.
      </div>
      <div
        class="ql-block"
        data-block-id="block-7a40161f-7197-4df4-b702-71f5380d210b"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-54b08689-151d-4042-a36b-dc2fce08ffa5"
      >
        Let&apos;s start with Monoterpenes (Hydrocarbons).
      </div>
      <div
        class="ql-block"
        data-block-id="block-ecb1d52d-c6ec-47f5-ae26-0cf9aa0a4138"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-9a046fdf-c648-414d-96f2-bea210e1d67a"
      >
        What does that mean?
      </div>
      <div
        class="ql-block"
        data-block-id="block-689a4bb3-595e-4907-a93d-8f35b888b3c3"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-cbe19ab1-1db4-4884-a387-7306d1717a28"
      >
        They show us that this component has 10 carbons, which leads us to
        conclude that it is <strong>a light molecule,&nbsp;</strong>and a light
        molecule gives a higher note to essential oil.
      </div>
      <div
        class="ql-block"
        data-block-id="block-fab713f5-225e-4051-8dca-2c1107234a18"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f0215ea8-e2bc-4b90-a36f-14e1e9889fb6"
      >
        Then, whenever we see sesquiterpenes, we know that there&apos;s a
        presence of 15 carbons which leads us to the conclusion it is a heavier
        molecule, and a heavier molecule gives lower notes.
      </div>
      <div
        class="ql-block"
        data-block-id="block-f6bebd2a-e27d-4617-8b87-c064dd58469a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b6c4fd97-26c2-41d0-8baf-99030f7180ce"
      >
        Let&apos;s exemplify this.
      </div>
      <div
        class="ql-block"
        data-block-id="block-7a354889-b77c-4ae3-8f1f-910ac07a4b70"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-071cc146-451e-44d1-bfaf-f3ba2b5222d8"
      >
        Let&apos;s look at the Catnip oil (<em>Nepeta cataria</em> L.) in
        Dropsmart. First, we&apos;ll automatically notice the dominance of the
        <strong>color green</strong> - which tells us that over 60% of this oil
        is made of sesquiterpenes.
      </div>
      <div
        class="ql-block"
        data-block-id="block-40f17bef-b508-4730-9815-e452995af0c9"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-16c8081f-1508-46a1-b003-216057d18201"
      >
        Remember:
      </div>
      <div
        class="ql-block"
        data-block-id="block-6e89943e-e3aa-417a-838c-6b41b7509867"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-36c36b2a-b467-4301-972a-0a9fda34e61b"
      >
        orange = monoterpenes,
      </div>
      <div
        class="ql-block"
        data-block-id="block-62d9b394-5865-41b9-8cf9-fc28af2fa60e"
      >
        purple = esters,
      </div>
      <div
        class="ql-block"
        data-block-id="block-cbe0ff23-54be-4a44-9673-d3b77770a846"
      >
        blue = ketones,
      </div>
      <div
        class="ql-block"
        data-block-id="block-b1c24545-3aa8-4408-90a4-c191888d8b89"
      >
        green = sesquiterpenes,
      </div>
      <div
        class="ql-block"
        data-block-id="block-e64741b6-09c9-475b-bdcd-133924ec8866"
      >
        etc.
      </div>
      <div
        class="ql-block"
        data-block-id="block-4d24995f-9fba-4160-aabd-2e878ad69cb9"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-555a17a3-8a9e-4b8e-8eff-52226dbad144"
      >
        The high presence of sesquiterpenes also marks a low note. As we know,
        essential oils with a higher ratio of lower notes take much longer to
        evaporate, which makes them long-lasting.
      </div>
      <div
        class="ql-block"
        data-block-id="block-93e287b2-af82-4370-8df8-1c622cf4dc17"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-1bc90c8b-7fa7-40f2-ba79-b93e1ed193eb"
      >
        In comparison, if we observe Cypress (<em>Cupressus sempervirens</em>
        L.) or Scots Pine (<em>Pinus sylvestris</em> L.), we can see the
        dominance of the color orange (monoterpenes), which leads us to the
        conclusion that these oils have a higher ratio of higher notes, which,
        as we know, evaporate quickly &amp; are very volatile.
      </div>
      <div
        class="ql-block"
        data-block-id="block-d711b3a4-1ca0-4a71-85a0-ec5e35532a85"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-5e6c6913-af99-4cb8-acaa-bd80516415f7"
      >
        So, by connecting color to a smell, we see:
      </div>
      <div
        class="ql-block"
        data-block-id="block-b509c520-3e00-4225-81e4-aebb08c3f6ea"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b4c37e71-3ca2-41b6-a5fa-972d6ceea1c4"
      >
        (A lot of) Orange = high notes = a light smell which evaporates quickly
      </div>
      <div
        class="ql-block"
        data-block-id="block-d8579959-0175-4470-a00c-d9c90679d4a3"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-d22550b8-72be-4cc6-8a01-299ee70720bb"
      >
        (A lot of) Green = low notes = intense long-lasting smell
      </div>
      <div
        class="ql-block"
        data-block-id="block-07129645-01d0-46c7-9d13-ca4b0580d45c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f7da888b-72ad-4cbf-ab70-346baecc5688"
      >
        We also know that oils with a higher percentage of alcohol in their
        chemical components will overpower light notes, so in a blend consisting
        of, for example, Geranium (<em>Pelargonium graveolens)&nbsp;</em
        >&amp;<em>&nbsp;</em>Lemon <em>(Citrus limon),&nbsp;</em>Geranium will
        certainly overpower Lemon and dominate smell-wise.
      </div>
      <div
        class="ql-block"
        data-block-id="block-729605e9-654a-49dd-86df-54a76ad840f1"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-86eb8ae3-336c-4c2d-b2fb-fe66bec912cf"
      >
        After understanding monoterpenes, let&apos;s take a look at the
        alcohols.
      </div>
      <div
        class="ql-block"
        data-block-id="block-af92623b-bff0-4980-8786-d73875017acf"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-4ce95dcd-c313-48d4-9709-28f0cf5d16f3"
      >
        If we search for oils that have over 25% of monoterpene alcohols, we can
        automatically see that we&apos;re highly familiar with these oils.
      </div>
      <div
        class="ql-block"
        data-block-id="block-e1d06cc3-1f65-494d-a447-9dec43c6e612"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-442fb631-2c00-4049-be39-c8c3ff69906a"
      >
        Oils such as:
      </div>
      <div
        class="ql-block"
        data-block-id="block-f2ff4771-da85-4103-aec1-2df804564901"
      >
        <br />
      </div>
      <ul>
        <li>Rose (<em>Rosa x damascene),&nbsp;</em></li>
        <li>Lavender (<em>Lavandula angustifolia),&nbsp;</em></li>
        <li>Gingergrass (<em>Cymbopogon martini</em>), and</li>
        <li>Geranium (P<em>elargonium graveolens).</em></li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-052bd2ab-250f-43ad-8103-2367785b79c5"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-3710a951-859e-45f6-a98e-3d3f01a8a97f"
      >
        These are all oils rich in monoterpene alcohols, which means they have
        an abundance of middle notes, which gives them a rather intense &amp;
        potent smell, which means that Geranium, Gingergrass, or Lavender will
        overpower Lemon and citrus-dominant oils any day.
      </div>
      <div
        class="ql-block"
        data-block-id="block-140dbe93-d3b8-4ec6-96b9-c2a3ea6aa861"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-aacb27b1-0a5c-440c-b5cb-957ef61e4629"
      >
        Why?
      </div>
      <div
        class="ql-block"
        data-block-id="block-62a84bc2-9f0b-42a6-a86d-e2a449d68ffe"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-0bfd2f17-351a-4b29-bda0-a8412cfba9ea"
      >
        Because of the high percentage of monoterpene alcohols, which
        aren&apos;t only intense middle notes, fierce flowery scents linger and
        last for a few hours.
      </div>
      <div
        class="ql-block"
        data-block-id="block-6b7d6782-0976-4106-90a3-1f72b493549d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-18fc4d22-bafa-4fff-ba11-0050bed18dcc"
      >
        So - one drop of Geranium must be blended with a couple of drops of
        citruses even to smell citruses.
      </div>
      <div
        class="ql-block"
        data-block-id="block-e652f4c6-5b81-4fc0-835c-84a117cd5995"
      >
        The next component we want to take a look at is phenols.
      </div>
      <div
        class="ql-block"
        data-block-id="block-e5253713-799d-48e1-8438-dd5e9e93b845"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-933c79d9-73f9-4793-9540-3bdece90b660"
      >
        Phenols (color brown) are known for their Benzene ring - a structure of
        molecules that plays an enormous part safety-wise.
      </div>
      <div
        class="ql-block"
        data-block-id="block-1199c66a-6763-42b3-8a6a-1bba3fa64ff4"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-ac50ab9a-28fc-4e98-a1c9-d3c7e6b3b3c9"
      >
        So, oils over 30% of phenols should be <strong>extra cautious!</strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-2b96e9fb-9efe-4a12-bd31-b7b8880df7d6"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-72a4ee5a-40f1-4abc-9a52-5b586e33e9a0"
      >
        We&apos;re referring to the oils such as:
      </div>
      <div
        class="ql-block"
        data-block-id="block-e4acd58a-62ab-4e2f-8c15-f8c4932a1a45"
      >
        <br />
      </div>
      <ul>
        <li>Clove (<em>Syzygium aromaticum).</em></li>
        <li>Oregano <em>(Origanum vulgare).</em></li>
        <li>Winter savory <em>(Satureja montana).</em></li>
        <li>Cinammon leaf <em>(Cinnamomum verum).</em></li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-ef7b84ae-db93-4a98-9325-609c9f0fe990"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-e8b72991-bf01-4bb3-9b85-767b22b81736"
      >
        Extra caution should be executed on topically using any of these oils as
        the benzene ring makes them very spicy while giving them middle notes.
      </div>
      <div
        class="ql-block"
        data-block-id="block-79c2a881-c92a-442c-b78c-058e652be4bc"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-bec9e52e-acdd-4311-a1ba-1ac352c944e6"
      >
        Next, we will observe oils high in aldehydes (light green) - over 30% of
        the overall composition.
      </div>
      <div
        class="ql-block"
        data-block-id="block-8bc27449-f7e4-422d-a44e-0c62ac449e06"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-61cc343d-dcf9-4b2e-af07-6b14dc2bf12a"
      >
        Since aldehydes can be very dominating - their smell is the same too.
      </div>
      <div
        class="ql-block"
        data-block-id="block-5fb39970-6b15-4fff-a754-677cd7201e52"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-6a216259-1242-4fca-80c0-464b798d2ca7"
      >
        We are going to come across aldehydes in oils such as:
      </div>
      <div
        class="ql-block"
        data-block-id="block-21740460-a5b9-4a4b-9a93-478b130fb934"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-4ddf78d2-8748-494c-bebb-1448b06da14a"
      >
        Melissa <em>(Melissa officinalis)</em>
      </div>
      <div
        class="ql-block"
        data-block-id="block-0800a49c-ae3c-4b77-82b1-bef08a9b6265"
      >
        &amp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-d39fb178-5905-45b9-8cd5-731f8051ec3a"
      >
        Lemongrass (<em>Cymbopogon citratus)</em>
      </div>
      <div
        class="ql-block"
        data-block-id="block-2b180ff1-0f10-4540-8a62-aea41c30ea22"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b02edf49-0213-4605-b5f4-b0daf99c237f"
      >
        The scent is extremely fresh, reminds of Lemon but is a much lower note
        (evaporates slower and lingers longer). Since aldehydes (light green)
        are lower than monoterpenes (orange) also present in this oil - the
        oil&apos;s scent will vary between lower &amp; middle notes, with middle
        notes dominance.
      </div>
      <div
        class="ql-block"
        data-block-id="block-7349acec-f8dd-4f84-b9e3-fba2e1f0a21f"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-4f85a6a7-74c6-4104-9868-ff15edb782a7"
      >
        Although many reach out for these oils (especially Lemongrass) to
        replace Lemon, it is not recommended to do so since the chemical
        structures of these oils (aka their healing properties and application
        recommendations) are entirely different.
      </div>
      <div
        class="ql-block"
        data-block-id="block-60d21274-45d8-4d5d-a018-ef5537085c0d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-423f5a80-04a5-4bea-abb1-8f94fbf8e7a0"
      >
        Extra caution should be exercised here as well since oils high in
        aldehydes can be fairly irritating to the skin.
      </div>
      <div
        class="ql-block"
        data-block-id="block-de240b20-da82-4946-9def-d1c37ca70410"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-831cb838-9748-4f81-9f29-756872e6d012"
      >
        Next, we have ketones (blue color). It&apos;s very rare that an
        essential oil dominates in ketones, but any oil containing it should be
        handled with extra caution due to the fact that some are neurotoxic.
      </div>
      <div
        class="ql-block"
        data-block-id="block-7b647c8a-67d0-4731-a67b-c7bf7753320d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b57c1211-de02-4cb7-88d8-88b3cbcf0684"
      >
        Smell-wise, ketones fall into the category of the middle notes -
        they&apos;re not so pungent.
      </div>
      <div
        class="ql-block"
        data-block-id="block-918ed8bc-d0e8-4dce-8603-101111d5d6ab"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-5988704b-1694-4b66-a87f-9c6bf6b060ce"
      >
        Like Spearmint<em>&nbsp;(Mentha spicata),&nbsp;</em>as an example, we
        can notice its aroma but in the background.
      </div>
      <div
        class="ql-block"
        data-block-id="block-8afa9266-bc2c-4c2a-8726-787a9fe88734"
      >
        We also want to know whether the ketones are rich in monoterpenes or
        sesquiterpenes since this will decide the smell.
      </div>
      <div
        class="ql-block"
        data-block-id="block-48a6b508-31a8-434b-90d2-5522ddd91461"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f9173892-3863-4442-94ea-d38e44d25d25"
      >
        It&apos;s good to remember that essential oils are already a cocktail of
        chemical constituents.
      </div>
      <div
        class="ql-block"
        data-block-id="block-dafa290a-96d2-4d7f-b922-f76af70e48e0"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-907eff73-d186-4478-ba00-32cbc85fa4a3"
      >
        So one essential oil is most of the time well-rounded in smells - which
        is something that pie charts show us.
      </div>
      <div
        class="ql-block"
        data-block-id="block-511ac2ca-6b49-4b59-81d0-86b1cdf2b125"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-7a97a63a-b2d7-491e-b850-170dc1bd4b9d"
      >
        We&apos;re continuing our journey by observing esters.
      </div>
      <div
        class="ql-block"
        data-block-id="block-a6f9a5c2-d2b1-413c-b84a-2cda2bd66b8f"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-2b322fc9-daa0-44b2-ab3f-50dacca97948"
      >
        Esters are primarily oils you&apos;ll already be familiar with, such as
        Lavender, Roman Chamomile (<em>Chamaemelum Nobile),&nbsp;</em>and Clary
        Sage<em>&nbsp;(Salvia sclarea)</em>, and they are most often recognized
        by their flowery smell. Esters-dominant oils are mostly middle-note
        oils, sometimes leaning to lower notes.
      </div>
      <div
        class="ql-block"
        data-block-id="block-aeeeccef-99af-45da-96c7-eeb17087cd35"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-4f93fd57-9e7b-42eb-95e5-57dd426969dc"
      >
        Knowing that it&apos;s easy to see why Ylang Ylang
        <em>(Cananga odorata)&nbsp;</em>is somewhere between the bottom and
        middle notes due to its high percentage of esters and sesquiterpenes.
      </div>
      <div
        class="ql-block"
        data-block-id="block-f47488ac-3116-4ffb-9a4b-a4d9bcc47822"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-885ab638-7bc8-4880-bf55-3ad4e6a767f5"
      >
        Lavender, for example, it&apos;s a combination of esters &amp;
        monoterpenes - which gives it a higher note, which is why it would be
        nicely supported with Himalayan Cedarwood
        <em>(Cedrus deodara)</em> which would give it a bit more of a lasting
        time through the lower note presence.
      </div>
      <div
        class="ql-block"
        data-block-id="block-4bdc5f1a-1b73-4f06-9103-68e38a2825ff"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-2eb0e957-31ed-44a2-95c7-005fa235b2e4"
      >
        We are finishing our journey with oxides. One of the most important
        oxides is 1,8 cineole.
      </div>
      <div
        class="ql-block"
        data-block-id="block-a898b25c-c43f-4126-8d8d-c24fc806f42d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-7c8c7ac9-7f04-470d-bbd4-dc3c04570a3f"
      >
        Oils rich in 1,8 cineole are Eucalyptus (<em
          >Eucalyptus globulus),&nbsp;</em
        >Ravintsara<em>&nbsp;(Cinnamomum camphora),&nbsp;</em>Niaouli<em
          >&nbsp;(Melaleuca quinquenervia), etc.&nbsp;</em
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-8855e6bd-c0d6-45e4-aee0-d591c2094f15"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-03dfc5b1-43d0-47cf-a6e6-9c92b033a932"
      >
        The smell rich of the 1,8 cineole is a camphorous smell (medicinal
        smell) which is quite intense - middle, going to the high note.
      </div>
      <div
        class="ql-block"
        data-block-id="block-2842ab3a-6e4c-4adc-b405-b97f84ded506"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-6bd117e5-6dbf-45f2-9957-291a9ac6543a"
      >
        This makes it difficult to blend with - due to the ungrateful pungent
        smell.
      </div>
      <div
        class="ql-block"
        data-block-id="block-a10bb29e-38fc-41b5-b0bb-82d3ffaac675"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f6c559fd-ae4d-41ef-be7b-a4d132aef44f"
      >
        We&apos;re sizzling this journey with ethers, which aren&apos;t that
        common (color pink). However, they are highly distinguished sweet middle
        notes.
      </div>
      <div
        class="ql-block"
        data-block-id="block-614319c0-9075-4612-9209-23e3c45ef9f3"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-deaeefa0-ea91-4ae1-83b2-9e4e47fe261e"
      >
        When we&apos;re using oils rich with ethers, it&apos;s challenging to
        blend due to their intense smell, which is a hit or miss.
      </div>
      <div
        class="ql-block"
        data-block-id="block-7a46078f-9494-4dbd-8937-fbbea307fa40"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-566b76c0-62a1-484c-a9ad-0d3c1e6276c0"
      >
        Hopefully, this video has helped you to understand the abundance of
        relevant information Dropsmart has brought you and will keep bringing
        you (if you let it).
      </div>
      <div
        class="ql-block"
        data-block-id="block-95ef701c-d7c7-4d6c-b043-8fe3f057526c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-9c9d9d56-ae20-46e2-ba93-bcd2faf36c47"
      >
        We&apos;re sure you are ready to explore pie charts on your own - and we
        wish you a safe (and fun) journey.
      </div>
      <div
        class="ql-block"
        data-block-id="block-1269339a-b0d2-4873-b998-0d7b854218b1"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-1a4b9d02-55bc-4da0-b78d-8464487afada"
      >
        We wish you a lovely day,
      </div>
      <div
        class="ql-block"
        data-block-id="block-8bb73b60-9608-478f-a0c1-6879d1ce1363"
      >
        Dropmart Team
      </div>
      <div
        class="ql-block"
        data-block-id="block-4bef59ba-18ca-42af-8d80-92b9c5437eef"
      >
        <em
          ><a
            class="ql-link"
            href="http://dropsmart.io/"
            rel="noopener noreferrer"
            target="_blank"
            >Dropsmart.io</a
          >
          - The most trusted essential oil resource center.</em
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-ad7432c7-8a72-40ef-bb94-f9f1961ca80c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-c675e4de-2cb9-4dab-a94f-636c13971c5e"
      >
        <strong>P.S.</strong> Today, we closed up tactics &amp; techniques of
        recognizing smell through the color in the Dropsmart - and had a blast
        doing so! &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-3788c4ba-7108-4ead-9043-c2f39cb93804"
      >
        <br />
      </div>
      <div
        class="ql-block ql-align-center text-center"
        data-block-id="block-1f105b94-5852-4ef9-be0f-7b989c1c179e"
      >
        <strong
          >Thanks for tuning in &amp; please continue your journey with the next
          step.</strong
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-b1a61d7c-7e85-4af0-9446-e17646b9cd87"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-78f17038-926e-4147-8f69-48d7d96d4152"
      >
        <strong>References:&nbsp;</strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-37000f45-c1ab-46bd-8e63-2151508d782c"
      >
        <br />
      </div>
      <ul>
        <li>
          Baser K. H. C., &nbsp;Buchbauer G. (2010) Handbook of essential oils:
          science, technology, and applications Taylor and Francis Group, Boca
          Raton
        </li>
        <li>
          E. J. Bowles (2003) The chemistry of aromatherapeutic oils. Crows
          Nest, Allen&amp;Unwin.
        </li>
        <li>
          Dudareva, N., Klempien, A., Muhlemann, J. K., &amp; Kaplan, I. (2013)
          Biosynthesis, function and metabolic engineering of plant volatile
          organic compounds. New Phytologist, 198(1), 16-32.
        </li>
        <li>
          J. Clayden, &nbsp;N. Greeves, S., P. Wothers, Organic Chemistry (2000)
          Oxford University Press, Oxford.
        </li>
        <li>
          R. Tisserand and R. Young (2014) Essential Oil Safety 2nd Edition.
          Edinburgh: Churchill Livingstone.
        </li>
        <li>
          Vollhardt P. C., Schore N. E. (2014) Organic chemistry: Structure and
          function, 7th edition W. H. Freeman, New York
        </li>
        <li>
          Williams D.G. (2008) The Chemistry of Essential Oils: An Introduction
          for Aromatherapists, Beauticians, Retailers and Students (Second
          Edition). Micelle Press, Dorset.
        </li>
      </ul>
    </article>

    <article v-else-if="stepNumber === 10">
      <p>
        Dear <span>{{ name }}</span
        >,
      </p>
      <div
        class="ql-block"
        data-block-id="block-9d9e0c62-85f0-42c5-978f-676945ad987e"
      >
        <strong
          >We hope you enjoy this journey with us and have fun while learning!
          &nbsp;🙂 &nbsp;</strong
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-bc731527-7604-4287-b9b1-00e02d756984"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-58e8a1f3-c816-488b-94fa-f383ab64ecce"
      >
        In our previous step, we closed up tactics &amp; techniques of
        recognizing smell through the color of the pie charts in the Dropsmart -
        and had a blast doing so! 🙂
      </div>
      <div
        class="ql-block"
        data-block-id="block-70bdf153-5d12-4ee4-86d0-418af889a7f4"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-fb763d0f-8b39-45a0-8aed-d604c7a627a6"
      >
        Today we will respond to a common unanswered question -
        <strong><em>how to choose your top five oils?&nbsp;</em></strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-6600bb94-b672-4346-a05d-d730bd6b7307"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b4ace434-5d3f-4842-8b60-cf62cd4834ca"
      >
        Now that you have been with us for a while and hopefully
        <strong><em>have been using Dropsmart</em></strong
        >, you&apos;re probably closer to rethinking how to choose<strong
          >&nbsp;the top five oils.</strong
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-0587ba43-c2b6-40ba-8622-f86442cb9f36"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-eb66e941-44e7-4985-9c6e-a9028327d6da"
      >
        A part of the answer lies in the chemistry, pie charts &amp; having all
        notes (low, medium &amp; high) represented in our top favorites - as we
        discussed last time.
      </div>
      <div
        class="ql-block"
        data-block-id="block-6bfc9ff9-50d6-4ffc-abfe-c97c8ba71aea"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-ea7ce2e0-4dd4-4a79-8de9-3c0a0444a8e1"
      >
        We&apos;re starting with oils that have top (high) notes because having
        one main dominant component gives us more control. It&apos;s easy to
        blend with it, and it&apos;s easy to add it to other oils &amp; which
        provides us with more ideas on how to use it interchangeably.
      </div>
      <div
        class="ql-block"
        data-block-id="block-3cae7864-31a4-4291-afe4-c70e0daf804c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-07d04027-7005-4a57-a0ec-38ebbe4f13c7"
      >
        So, selecting a couple of oils singular in their chemistry &amp;
        covering all notes was our choice! &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-875e741d-7616-4445-964e-675d19f2d07a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-d38ffc20-6958-456b-8413-87149c081af6"
      >
        We&apos;re starting with citrus oils, and we opted for Grapefruit (<em
          >Citrus x paradisi),&nbsp;</em
        >which has over 90% of limonene and is super easy to add to, for
        example, Lavender (<em>Lavandula angustifolia)</em> or Ylang Ylang (<em
          >Cananga odorata)&nbsp;</em
        >to<em>&nbsp;</em>equip them with higher notes and create a more
        balanced ratio.
      </div>
      <div
        class="ql-block"
        data-block-id="block-82fb651b-5f27-4547-8f0b-4f8fe6845e96"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-d191129f-67b3-406d-a75c-a4220ac08510"
      >
        So we suggest that you choose citrus for your first oil. It can be any
        citrus - the one you like the most, ranging anywhere from Sweet Orange
        (<em>Citrus sinensis),&nbsp;</em>Clementine<em
          >&nbsp;(Citrus clementina),&nbsp;</em
        >Lemon <em>(Citrus limon),&nbsp;</em>or Grapefruit.
      </div>
      <div
        class="ql-block"
        data-block-id="block-fda6d946-1373-4bdc-bac4-091007f24a3b"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f9de04dc-70f6-4f5a-948a-f3af9b4e0b0e"
      >
        This time, we preferred Grapefruit oil - since it adds freshness without
        an abundant sweetness (unlike Sweet Orange or Clementine).
      </div>
      <div
        class="ql-block"
        data-block-id="block-cacaa57f-3f2d-4276-be49-b055a18cb5ec"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-7cb928d6-4eb7-4b99-bb25-3c66a5da0793"
      >
        Upon choosing the citrus oil, you fancy the most - click on it and see
        what marvelous benefits &amp; applications recommendations are provided
        at the top of your fingertips.
      </div>
      <div
        class="ql-block"
        data-block-id="block-14a91cf5-1884-45ff-9097-d9f4171fae92"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-93fb3d48-177f-4e68-bb55-c42e066f57fd"
      >
        The second oil recommendation is an oil rich in linalool. Since this
        time, we&apos;ve been aiming at the middle note.
      </div>
      <div
        class="ql-block"
        data-block-id="block-26f8659c-a821-47ef-a378-3cfc9e0ddd79"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-20c2a520-4234-48ef-849f-086f27dbeba3"
      >
        The filtering feature is quite handy - since you can use it to find
        oils, with linalool being one of the most dominant chemical constituents
        (over 25% percent and above).
      </div>
      <div
        class="ql-block"
        data-block-id="block-a88202e5-b7c2-4ce2-a567-891799e54961"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-7c66c6fa-956a-4945-99e9-a0b2948323b0"
      >
        This oil will have a flowery smell which is generally liked and is
        extremely easy to blend with other oils.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b61139e6-2341-41d6-87c4-6e2c793b58c5"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-93dcbddc-5616-47d9-8c9f-04b5f6f0715c"
      >
        For the sake of this experiment, we&apos;re going to choose an oil
        highly dominant in linalool, such as Ho Wood (<em
          >Cinnamomum camphora),&nbsp;</em
        >so we quickly add it to other oils whenever we need more antidepressant
        action or sedative properties.
      </div>
      <div
        class="ql-block"
        data-block-id="block-89234b27-2994-4a05-ad7d-56deffbd4061"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-90ee9a10-9eaa-4f38-874f-d01761fb5f44"
      >
        It&apos;s easy to use it in a targeted way. For example, it can
        complement another oil with a middle-note smell or increase a sedative
        effect.
      </div>
      <div
        class="ql-block"
        data-block-id="block-d4491b80-71d7-42e7-9462-99a0b7fc3c1f"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-189c29e5-63c7-4cbe-b3ef-6bba004c64de"
      >
        So to recap - our recommendations for the top five oils include citrus
        oils rich in limonene, and the second oil should be rich in linalool.
      </div>
      <div
        class="ql-block"
        data-block-id="block-35cc09a0-5aff-490d-8db4-9f8a2a690b71"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-162e6300-ccc1-4bb7-9f5c-56556550ef92"
      >
        We aspire to find something more medicinal and activating for the third
        oil recommendation.
      </div>
      <div
        class="ql-block"
        data-block-id="block-1bc72cc9-619b-479e-98cd-765c752bb0c6"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-3a8128a6-b4b9-44f1-95f7-e10c7276b7eb"
      >
        Since linalool has such immense sedative properties, limonene provides
        freshness, and now we want to add something with 1,8 cineol, such as
        Eucalyptus Globulus (<em>Eucalyptus globulus).&nbsp;</em>The most
        important thing is that the ratio of the 1,8 cineol within the oil we
        choose is above 50%.
      </div>
      <div
        class="ql-block"
        data-block-id="block-c84b91ad-bac4-4832-a8cd-6e5d90348ce3"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-66094787-8f82-49ba-993b-1e0745980f8b"
      >
        If Eucalyptus Globulus has a too intense smell for us, we can opt for
        Eucalyptus Radiata (<em>Eucalyptus Radiata)&nbsp;</em>or Ravintsara (<em
          >Cinnamomum camphora)&nbsp;</em
        >or any other suitable option.
      </div>
      <div
        class="ql-block"
        data-block-id="block-c93e14da-f557-4bed-b251-98f6fd7eaabf"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a1759589-3e43-4e22-b7ee-b1163b850b1c"
      >
        This combination is for respiratory infections, bacterial infections,
        pain management, mind/focus activation, etc.
      </div>
      <div
        class="ql-block"
        data-block-id="block-61bc2341-7304-4859-82a8-6ee4a4d3326b"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-1b87144d-c23a-47d5-928f-8c698c7a6e22"
      >
        They do tend to have a more medicinal smell with a middle-to-high note.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b3c78061-744c-47c8-a22f-2ac60b579c70"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-08c1352d-2432-4c1e-b514-61629af9e176"
      >
        We start with a light citrus scent, followed by a flowery smell, and
        proceed with a more medicinal smell.
      </div>
      <div
        class="ql-block"
        data-block-id="block-d59f836a-7e2d-4aa9-9d73-2b898620fe17"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-ffd4e9f5-05c7-4c85-b1c8-173d31d0cb5b"
      >
        So, if we blend, for example, Lemon with Ho Wood, it will help us relax,
        and if we blend it with Eucalyptus Globulus it will activate us and help
        us focus! &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-f2bd213f-bd28-4e2b-8a88-b4125f2b49c2"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-951c2cc1-f510-49ef-a5c1-e945f3996f98"
      >
        The fourth oil should be abundant in citral or citronellal, whereas our
        preference is citral (due to a more intense smell).
      </div>
      <div
        class="ql-block"
        data-block-id="block-0fdda26a-1f76-4a9f-a780-a1d773088c0e"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-907e1b7e-85fa-49f6-85e7-a26864f421b7"
      >
        This oil isn&apos;t everyday usage friendly but is more for exact and
        targeted usage.
      </div>
      <div
        class="ql-block"
        data-block-id="block-f7f0615c-0222-4b23-a1a8-1f4471a9713c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b45eb5a2-8afb-4dc0-afc9-3ddaaae8ae4f"
      >
        For example, Melissa (<em>Melissa officinalis)&nbsp;</em>helps
        tremendously with cold sores, but Lemongrass (<em
          >Cymbopogon flexuosus)</em
        >
        or May Chang (<em>Litsea cubeba)&nbsp;</em>are also pretty singular -
        hence easy to blend.
      </div>
      <div
        class="ql-block"
        data-block-id="block-283fecee-8fc8-4539-b41f-1ad14d07a418"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-ad42ca07-4285-45c7-b633-881543987687"
      >
        Middle notes give these oils freshness - all of them are pretty
        efficient for infections.
      </div>
      <div
        class="ql-block"
        data-block-id="block-3c582ff0-1a50-4404-954c-f3347363063c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b011ed49-53dc-4d8b-b7d9-54dd195504d9"
      >
        Last but certainly not least - fifth oil, we&apos;re choosing lower
        notes.
      </div>
      <div
        class="ql-block"
        data-block-id="block-aa9e9aaf-f31c-4888-967f-5bdbbe124049"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-76ad5b1b-f41b-465b-84cf-6689fd73a749"
      >
        Oil-rich in sesquiterpenes, such as Atlas Cedarwood (<em
          >Cedrus atlantica),&nbsp;</em
        >Copaiba (<em>Copaifera officinalis),&nbsp;</em>or Patchouli<em
          >&nbsp;(Pogostemon cablin)&nbsp;</em
        >will lower the blend, be more gentle on the skin and easy on the mind,
        body &amp; skin.
      </div>
      <div
        class="ql-block"
        data-block-id="block-604c720c-21ea-4d3b-a94e-28be64191651"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b8fd2c13-245b-4386-8c8d-c1e59a8d4550"
      >
        This collection of oils singular in chemistry and smell (the note) they
        will add to another oil is helping us to create a blend on several
        levels. We&apos;re adding to the physical properties, we ensure we have
        three notes &amp; we can obtain absolute control over the smell and the
        healing effect of the oil itself.
      </div>
      <div
        class="ql-block"
        data-block-id="block-8f667d26-798c-4630-b16b-2980ff6e63e8"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-1cf4ca5b-e83e-4449-b64a-1cc766db8e0c"
      >
        We hope this will help you to choose essential oils with confidence and
        success - while achieving incredible results!
      </div>
      <div
        class="ql-block ql-align-center"
        data-block-id="block-7310069c-3077-490f-8e91-d0bae3b4b49a"
      >
        <br />
      </div>
      <div
        class="ql-block ql-align-center text-center"
        data-block-id="block-ac30ef00-14ee-4347-87ce-068361a924b7"
      >
        Thank you for your time, focus and attention!
      </div>
      <div
        class="ql-block"
        data-block-id="block-c68dca7a-c4f4-4394-a1e3-8a9a56b9bf05"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a898bb9e-3a6a-4fb7-b357-212ad031ee90"
      >
        We wish you a lovely day,
      </div>
      <div
        class="ql-block"
        data-block-id="block-e91bccda-f145-459f-be2f-9602e02da95f"
      >
        Dropmart Team
      </div>
      <div
        class="ql-block"
        data-block-id="block-9c21ae17-e8ac-40e9-8212-0ee360b9a522"
      >
        <em
          ><a
            class="ql-link"
            href="http://dropsmart.io/"
            rel="noopener noreferrer"
            target="_blank"
            >Dropsmart.io</a
          >
          - The most trusted essential oil resource center.</em
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-093d496e-38a7-4c23-af52-ff7e8f7fb492"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-9746cffb-2a3c-4e3c-b428-6137a65d7f43"
      >
        <strong>P.S.</strong> Today, we explain why choosing your favourites is
        going to make your practice better, life easier, and creativity lighter
        - all in one go!&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-35d81392-cb2d-40e6-9be3-21838eecb2b1"
      >
        <br />
      </div>
      <div
        class="ql-block ql-align-center text-center"
        data-block-id="block-888cedbc-1e79-4ef9-a60c-3dbb3fea0ae6"
      >
        <strong
          >Thanks for tuning in &amp; please continue your journey with the next
          step!</strong
        >
      </div>
    </article>

    <article v-else-if="stepNumber === 11">
      <p>
        Dear <span>{{ name }}</span
        >,
      </p>
      <div
        class="ql-block"
        data-block-id="block-39803078-ad2b-49a4-be54-fb8b17d80e64"
      >
        Thank you for embarking on this journey with us! We hope you find it
        both interesting &amp; fun! &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-8144fd0f-09fd-4a08-b774-31e01ef046ae"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-52a95a0e-70e6-4a1c-99ef-d2a79dabff6b"
      >
        Last time we wrote about the importance of picking your top 5 oils, as
        it gives us a brighter starting point, more control &amp; feeling of
        ease while experimenting with oils and blends!
      </div>
      <div
        class="ql-block"
        data-block-id="block-bc562d49-6e83-442d-85b7-4ac48993feb1"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-38d55764-99c9-460f-9501-e8d93841e73b"
      >
        Today we will address the topic which hasn&apos;t been addressed often -
        conscious usage of essential oils - even though it is vital!
      </div>
      <div
        class="ql-block"
        data-block-id="block-dd0cfeb0-7b34-4529-b391-40990c9233a8"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-7702e493-913a-46cb-b421-2aacdeb28691"
      >
        The reality is that most of us are unaware of how many essential oils we
        come in contact with daily. Yes, we said - daily!
        <span
          class="ql-emoticon"
          data-emoticon='{"code":"1f62e","name":"Face with Open Mouth"}'
        >
          <span contenteditable="false"
            ><span class="ql-emoticon-icon" style="font-family: initial;"
              >😮</span
            ></span
          > </span
        >&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-a1b87f03-8777-4126-9b25-74e29ed3c784"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-aead5681-0a86-41e4-87f2-99cbfde130d2"
      >
        It&apos;s imperative to talk about how we can use essential oils on a
        day-to-day basis in a safe, efficient, and creative way which helps us
        to experience the benefits while being aware &amp; not overusing them
        fully.
      </div>
      <div
        class="ql-block"
        data-block-id="block-26903b1d-157c-4691-bf9c-0248bf850c2a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-c0e1ba5a-39d2-492d-83c0-0452dd121d4f"
      >
        While traveling the world and speaking to thousands of people, our
        founder, Melani noticed that many of us aren&apos;t aware (including her
        too) of how many essential oils they use daily.
      </div>
      <div
        class="ql-block"
        data-block-id="block-8057a308-2a66-4de2-bb96-df0e733414ff"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-6b75bf47-22d4-410d-b1ba-417643249cff"
      >
        Let&apos;s list out products we typically use daily and are
        enriched/infused with essential oils, such as:
      </div>
      <div
        class="ql-block"
        data-block-id="block-a73a57f7-20e6-4ec9-a55a-2f400b913d47"
      >
        <br />
      </div>
      <ul>
        <li>toothpaste,</li>
        <li>body/face soap,</li>
        <li>hair products (shampoo, conditioner, mask, gel, etc.),</li>
        <li>
          facial care products (facial cream, scrub, tonic, serums, make-up
          removers),&nbsp;
        </li>
        <li>beard grooming products,</li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-29216644-5dad-4b8e-a944-881b3414ec1f"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-4df5b346-a704-4a85-a9f3-25085893a6f8"
      >
        and the list goes on!
      </div>
      <div
        class="ql-block"
        data-block-id="block-db72dd2e-fd03-440f-8db7-8e9c89f4173e"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-37353940-dcfe-45d3-ad48-bc1bddb3b487"
      >
        So far, we have mentioned at least ten different products from different
        categories, each containing
        <strong
          ><em>at least one (usually more) essential oil.&nbsp;</em></strong
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-bb1ff0e3-db73-4650-ae1a-da15f3b7305f"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-36f3c5a4-d2e2-47f9-93d2-4d910fdc2f3c"
      >
        And we only covered the area up to our neck! 🤯
      </div>
      <div
        class="ql-block"
        data-block-id="block-e9bb9b2c-279a-423b-9e29-4485295eb1bb"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-ebee9b08-833c-4a11-bddb-4e3555fcbadd"
      >
        Let&apos;s continue with:
      </div>
      <div
        class="ql-block"
        data-block-id="block-d1024fbe-9b88-4649-bdca-e8297aeab4c4"
      >
        <br />
      </div>
      <ul>
        <li>deodorants,</li>
        <li>body butter and lotions,</li>
        <li>perfumes,</li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-d69f842f-5591-4909-bcfe-2a0bf2001118"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f9b46f37-3843-4d20-a751-4d0a092c0c89"
      >
        and so on!
      </div>
      <div
        class="ql-block"
        data-block-id="block-fd2ae565-e4b6-4d7b-a5b0-addea4d7b831"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-6b9961b3-45fd-49ff-83bb-af40a07eccfb"
      >
        We&apos;ve already counted between 15-20 products we use
        daily<strong>&nbsp;</strong>and which contain essential oils!
      </div>
      <div
        class="ql-block"
        data-block-id="block-0c583905-4b20-494c-b3a8-63cca0ad7c26"
      >
        If we think about it, it is a bit too much - especially if we&apos;re
        using a variety of oils, not a few carefully selected ones.
      </div>
      <div
        class="ql-block"
        data-block-id="block-1a1c33ee-dd4d-4539-9f10-efcd0986a91a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-42915dca-be11-4f8d-9c5c-0d5d499064d9"
      >
        However, this isn&apos;t where the story ends! 😮
      </div>
      <div
        class="ql-block"
        data-block-id="block-f2267687-de0e-4725-8bc4-623af449fa6b"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-deec1327-5be8-4089-8e2b-cb3ce0f6912b"
      >
        We sometimes use essential oils in the diffuser (to stimulate focus or
        treat insomnia) - and we mostly opt for blends (once again, several oils
        at once).
      </div>
      <div
        class="ql-block"
        data-block-id="block-4601944b-becd-4097-aade-384c431c1187"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-cc22cb4b-fe05-42c4-99ca-bf810e004c0c"
      >
        We also often use them for therapeutic purposes, for example, creating
        pain-management remedies, sleep-inducing elixirs, stress-management bath
        additions, etc.
      </div>
      <div
        class="ql-block"
        data-block-id="block-18d4af93-f6fa-4ad5-b2d4-2945cf8b5233"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-4cc76e74-b8ef-480d-a9b6-9f315cf1af3d"
      >
        At this point, it&apos;s pretty clear how many of us are overdoing it
        when it comes to essential oils usage.
      </div>
      <div
        class="ql-block"
        data-block-id="block-34be381e-28d6-43d7-9e5c-87efb77e388c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-5c8069bf-e329-4f27-8035-fb72d378b043"
      >
        How can we go around changing that?
      </div>
      <div
        class="ql-block"
        data-block-id="block-23cadd44-4746-4f5c-a4ff-0b72b32240f5"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-ef4e7305-bd82-4536-baf1-d6eb35986bbe"
      >
        How can we use <strong>a safe number&nbsp;</strong>of essential oils per
        day?
      </div>
      <div
        class="ql-block"
        data-block-id="block-bb08ea12-4246-4994-8a37-b9619200ec4a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-ee983106-4f0e-4cec-a861-6efc0c7da17a"
      >
        How can we stop toxifying and stressing our body and give it what it
        needs?
      </div>
      <div
        class="ql-block"
        data-block-id="block-eb1da1c5-5d2d-4940-8624-9b6d9af0fd9f"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-75c48469-e8e7-41cb-8b4d-e71cb428b7be"
      >
        The approach starts by selecting up to 5 different oils that will use
        interchangeably every month for all of our nuisances. Since, hopefully,
        previous videos taught us how one oil could do as much as five of them
        combined (and sometimes even more), making our pick will be relatively
        easy.
      </div>
      <div
        class="ql-block"
        data-block-id="block-27e453c0-b080-4239-934d-79504c1ca39e"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-e479f3f3-9051-4679-84fe-9f5752888c10"
      >
        Within those five oils, we select oils that can cover the entire day.
      </div>
      <div
        class="ql-block"
        data-block-id="block-4c8e744d-6545-4c3f-8c65-7bd1a19ccf6a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-d1ecf519-86d9-4379-9530-8d6d5d426030"
      >
        One oil can be in charge of helping us sleep, while another one allows
        us to focus.
      </div>
      <div
        class="ql-block"
        data-block-id="block-85cd4496-c433-41a1-a5e2-4eec3716b917"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-612965b3-6c81-410b-bd37-3bfaffe00164"
      >
        But, of course, we&apos;re not going to blend them.
      </div>
      <div
        class="ql-block"
        data-block-id="block-9d0b247e-929c-487c-bcb2-c447e4dc6aa5"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-e9e583db-af49-4e43-b5b7-cfc7606689f3"
      >
        But let&apos;s be explanatory (as always) and talk about how we go about
        that in the Dropsmart.
      </div>
      <div
        class="ql-block"
        data-block-id="block-92c62844-108c-475c-9360-8dd719f90d27"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-e98f6ad7-714e-4834-87e7-e5b3889a1d9c"
      >
        The first idea which comes to mind is choosing those five oils from the
        oils we&apos;ve already favored, which also means it&apos;s highly
        likely we already have them in our collection.
      </div>
      <div
        class="ql-block"
        data-block-id="block-a291a684-d953-4363-880f-fad0d5b033d5"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-9551ea32-41b3-44f8-ae87-1b5521fe5c3f"
      >
        The second suggestion is browsing the entire database with a particular
        keyword (or keywords) related to the reason for usage.
      </div>
      <div
        class="ql-block"
        data-block-id="block-380d071a-b755-48f7-ae7f-8217a4d033d9"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a8b77ade-c6dc-4061-93c8-b01efd8ae144"
      >
        We can, for example, search for
        <strong><em>skin care</em></strong> suggestions in Dropsmart.
      </div>
      <div
        class="ql-block"
        data-block-id="block-bcf9f6db-7914-4bce-8ed9-3964fc27625e"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-6b25c7ef-edfd-4af4-a41e-de3d22e6d84b"
      >
        As we can see instantly, since we&apos;ve selected a rather broad search
        term, we have over 300 options.
      </div>
      <div
        class="ql-block"
        data-block-id="block-9aacc462-271c-4551-9ad2-1db7763d5c25"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-4607709d-ed29-4790-8a55-6281b65ea54b"
      >
        We can also use the same five oils each month and then, after 30 days
        pass, rotate them for a new favorite 5 selection.
      </div>
      <div
        class="ql-block"
        data-block-id="block-5cfe7324-f38e-493f-8a62-3c21e333f7ce"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-3c285333-a393-4629-9bf9-c04cd18563b3"
      >
        This way, we&apos;re making sure we are also acquainted with the
        chemical constituents absorbed into our biggest organ, our skin.
      </div>
      <div
        class="ql-block"
        data-block-id="block-bf85a0f2-11b9-477b-b2f6-c336b32b0969"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-dbe5bed4-e86b-487c-9dd8-8657cc41f903"
      >
        It&apos;s worth remembering that every single oil is a cocktail of over
        100 chemical constituents already, so by using merely 4 essential oils,
        we&apos;re exposing our body to over 400 chemical constituents from the
        get-go.
      </div>
      <div
        class="ql-block"
        data-block-id="block-0be9d3c3-6da1-41eb-8d09-4ff5618daf1c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-15b95a3e-cc76-494d-a4a3-66ca50b6df6a"
      >
        The same applies to our children, friends, family, partners, and clients
        - so being mindful is paramount.
      </div>
      <div
        class="ql-block"
        data-block-id="block-f71d6830-fb8a-4185-b1cc-79eeb9130917"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f8014853-358a-4485-a23e-7395e4216d5c"
      >
        To narrow our search even further, we can try searching for
        recommendations for the usage that aren&apos;t mainstream.
      </div>
      <div
        class="ql-block"
        data-block-id="block-15e4befe-55cf-489a-a4ab-3b6e84a0017a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-709d1ef9-8ee0-4f06-b2f2-a432c0d23996"
      >
        For example - deodorant.
      </div>
      <div
        class="ql-block"
        data-block-id="block-15dfb3cc-572b-499b-bf0c-f13f1febcfd4"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-492c3bc9-74d5-4422-b388-c6475adb4799"
      >
        Not many suggestions have been made on using essential oils in a
        deodorant form.
      </div>
      <div
        class="ql-block"
        data-block-id="block-d84816f7-31e6-4185-804c-8d3b311df289"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-1bae2883-9494-4394-948f-319b90e5d182"
      >
        Even though the search gives us over 100 oils, we can combine those
        recommendations to implement them into other products we need.
      </div>
      <div
        class="ql-block"
        data-block-id="block-60692a40-31f8-4b32-ab49-3afae97e1892"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-e70188a5-ac69-455c-998c-6d5d129d5414"
      >
        So from the deodorant recommendation section, we can choose, for
        example, Lavender (<em>Lavandula angustifolia</em>) to help us to fall
        asleep and Eucalyptus Globulus (<em>Eucalyptus globulus</em>) to wake
        up.
      </div>
      <div
        class="ql-block"
        data-block-id="block-54541317-e790-4f03-87a9-d1fa0497e8bd"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-892d4aca-a161-4618-a4e0-833af29f95ba"
      >
        We don&apos;t even have to use those five essential oils in every
        product we&apos;re using, and this is where creativity comes from. We
        can create products based on the five oils we selected.
      </div>
      <div
        class="ql-block"
        data-block-id="block-df376e03-7f3d-4d97-aef3-558a834030bf"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-91951be5-f5f5-40a4-b354-f1c774819392"
      >
        To simplify this further, our founder Melani has decided to choose 4
        different oils that are pretty standard, easy to get &amp; use, and
        which she likes and use the comparison tool.&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-4778feae-72f0-42c2-86ae-b7dc35dc029c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a308f710-e2b9-4d11-b503-f24ed94059ee"
      >
        The oils she chose are:
      </div>
      <div
        class="ql-block"
        data-block-id="block-58d0e874-6eb4-4571-99f8-2becdea23ef3"
      >
        <br />
      </div>
      <ul>
        <li>Bergamot FCF (<em>Citrus bergamia</em>),</li>
        <li>
          Cypress<em>&nbsp;</em>(<em>Cupressus sempervirens</em>)<em>,</em>
        </li>
        <li>Geranium (<em>Pelargonium graveolens</em>),</li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-216d983f-4372-42bc-a7c1-8bd2e1639e70"
      >
        &nbsp; &nbsp;&amp;
      </div>
      <ul>
        <li>Lavender.</li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-319a3e14-750b-4a73-b1e9-e2f5423e4ff1"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-585e02c0-180c-4266-b1a7-8a4ae719030a"
      >
        Upon reading the information provided in the Comparison Tool, it was
        quite apparent that all the oils can be used for acne, air purification,
        anxiety, wounds, etc.
      </div>
      <div
        class="ql-block"
        data-block-id="block-43629fe0-d241-44ae-bc56-4225abe5a367"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-7da651bf-14d4-4ba6-bd76-32f0b96a4396"
      >
        She checked the safety warnings, as she has a daughter whose health she
        doesn&apos;t want to endanger.
      </div>
      <div
        class="ql-block"
        data-block-id="block-ec3dd205-c564-459f-bedd-95715d0fd5a9"
      >
        Upon checking further, it has been pretty clear that all the oils she
        picked will serve multiple purposes - four of them were quite
        sufficient!
      </div>
      <div
        class="ql-block"
        data-block-id="block-10dfbe4c-5909-418f-8334-d9ccbd79151c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-218b259d-bc1c-46d4-9e9e-cb2058170a1c"
      >
        Of course, we cannot finish today&apos;s journey by reminding you of the
        extraordinary power of the blending tool within Dropsmart.
      </div>
      <div
        class="ql-block"
        data-block-id="block-5d2f712a-c3e6-4a59-8fa4-709e1913bbae"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-6fc02f3b-77be-44dd-bf6b-0fb9d16c5505"
      >
        One of the main reasons it was created is to prevent wastefulness -
        environmentally, monetarily, and time-wise.
      </div>
      <div
        class="ql-block"
        data-block-id="block-0ef3aa41-c940-495b-b339-1b92ac77dc30"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-4ef90226-f872-4d23-a61d-187a11c9cf6f"
      >
        As we love creating new blends, we end up with 10-15 combinations that
        oxidate, and it&apos;s wasteful for our wallet and the environment - but
        luckily, we have a solution.
      </div>
      <div
        class="ql-block"
        data-block-id="block-15766625-05bc-4024-b059-416307caa564"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-46c87d9e-252f-4068-afc1-0b008ddeee5d"
      >
        So, Melani simulated a blend for a natural deodorant within a simulator
        (containing 40% bergamot FCF, 25% cypresses &amp; 35% of geranium) and
        kept exploring what else this blend can be used for! &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-cf683dae-4958-41db-b231-e6be9cc49108"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-0b1db95d-e435-4c9d-bac6-7c9f66837ae3"
      >
        As soon as the blend was completed, she saw that she could reuse it for
        acne, anxiety, air purification, emotional states, wound healing, and
        many more.
      </div>
      <div
        class="ql-block"
        data-block-id="block-526f7449-e9a6-4e72-98c6-dc91faafa5c3"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-76e448da-55ea-4596-9628-f12eace8d0b0"
      >
        But since she added only 3 oils to this multi-useful blend, it gave her
        freedom to seldomly add two entirely new ones - as she feels a need to.
      </div>
      <div
        class="ql-block"
        data-block-id="block-4dab1df1-803c-4807-b258-140fb3a26b3c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-abdd2b8c-a639-462c-b59d-9215c19354ab"
      >
        <strong>So, this approach is highly recommended!</strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-ce989819-90e5-4724-837d-b5d33beae7cb"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-6108c7f2-13c8-40d3-b0e4-5ac0ba6b0b0e"
      >
        One of the reasons this tool is so incredible is that it will give you
        different ideas on the variety of usage for one blend - which means you
        can obtain the same effect with dozen fewer chemical constituents
        entering your body.
      </div>
      <div
        class="ql-block"
        data-block-id="block-87e41ac8-d344-4f29-91a2-76c3cc364cd2"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-e2bda749-f67f-4aa3-b48b-9d2e823880b3"
      >
        We hope this was useful for you, that we&apos;ve managed to convey the
        importance of using oils consciously and wisely, and that we&apos;ve
        encouraged you to play around with Dropsmart&apos;s simulator.
      </div>
      <div
        class="ql-block"
        data-block-id="block-99015fbc-912b-4039-a44b-0e91e28d19b8"
      >
        We can use &amp; reuse the same blend for various issues - some of which
        we&apos;d never even consider.
      </div>
      <div
        class="ql-block"
        data-block-id="block-386ffe5f-1c7a-46c1-8e3a-fcdd67035d7b"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-61ed97e1-cbfd-4ccb-9bbd-c21a8752b187"
      >
        Be safe for you, safe for the environment, without sacrificing
        creativity.
      </div>
      <div
        class="ql-block"
        data-block-id="block-de9d1e33-f433-4f9e-af4c-03786745aceb"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-bcba2e8b-d56c-464e-9e59-edfbe2b93a9a"
      >
        Less is more, at least in this case - and a little awareness goes a long
        way.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b49b42ed-a15a-4ff1-a726-12442d910637"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-89a7b418-d907-481c-94a0-d964961756d9"
      >
        Understanding the dynamics of your essential oils and the calculations
        of their constituents will lead you towards safe, inspiring, and
        powerful everyday usage of the essential oils.
      </div>
      <div
        class="ql-block"
        data-block-id="block-435e900c-df0c-4218-82dd-5814f6a0e892"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a8ed5e9a-8937-4952-bff2-a1594cbf6eb1"
      >
        We hope this was useful and educational for you!
      </div>
      <div
        class="ql-block"
        data-block-id="block-6efeaceb-b5f1-4f00-90f6-3e6f5d45ba04"
      >
        <br />
      </div>
      <div
        class="ql-block ql-align-center text-center"
        data-block-id="block-cfe392e3-a2b3-4bfa-a26e-4d31e298d6d7"
      >
        Thank you for your time, focus and attention!
      </div>
      <div
        class="ql-block"
        data-block-id="block-72eb431b-73c8-43fe-b663-da2f28d3110a"
      >
        <br />
      </div>
      <div
        class="ql-block ql-align-center"
        data-block-id="block-ce4605bc-e3e9-4ec9-af44-636d0951d126"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-cb05d75c-69e8-4780-8eb9-dbed5f8f1721"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-9103b629-92a9-47c8-af36-0f4d120ba453"
      >
        We wish you a lovely day,
      </div>
      <div
        class="ql-block"
        data-block-id="block-c0df1375-857c-4be7-8924-3586310a3211"
      >
        Dropmart Team
      </div>
      <div
        class="ql-block"
        data-block-id="block-22b10ed9-4817-4d99-82db-c17b61a9155e"
      >
        <em
          ><a
            class="ql-link"
            href="http://dropsmart.io/"
            rel="noopener noreferrer"
            target="_blank"
            >Dropsmart.io</a
          >
          - The most trusted essential oil resource center.</em
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-9f65a984-7d36-4ffc-bf7f-f114fd499a33"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-00aab1cc-8bee-41c6-a684-94d05d8f5c77"
      >
        <strong>P.S.</strong> Today, we explained when much is too much, and how
        to use essential oils consciously.&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-7311409f-9e05-43aa-bc89-b3467533aa13"
      >
        <br />
      </div>
      <div
        class="ql-block ql-align-center text-center"
        data-block-id="block-5722417f-b123-4a45-bc06-cbf02dddc97a"
      >
        <strong
          >Thanks for tuning in &amp; please continue your journey with the next
          step!</strong
        >
      </div>
    </article>

    <article v-else-if="stepNumber === 12">
      <p>
        Dear <span>{{ name }}</span
        >,
      </p>
      <div
        class="ql-block"
        data-block-id="block-46af77aa-e151-4ce3-8928-fad2a85eb458"
      >
        Are you enjoying the ride? Is the journey as fun as educational?
      </div>
      <div
        class="ql-block"
        data-block-id="block-ee90af89-ea07-4339-ae6f-762269549a0d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f4f08cb0-0ddd-45a3-b0c9-46c467525605"
      >
        We sure hope so! &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-26cf147e-b403-4758-922c-ce45bbfd5056"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b7658b5e-fc94-4f08-b47c-f04785ab7f83"
      >
        Last time we discussed conscious usage of essential oils and their
        impact on our environment, practice, monetary aspects &amp; life in
        general! We are unaware of how many oils we use daily - and how much
        less we can create extraordinary results.
      </div>
      <div
        class="ql-block"
        data-block-id="block-c433ea10-f813-46f0-bceb-deb402bf9398"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-558998f8-de51-4910-98ca-d59526445919"
      >
        Today we&apos;ll be addressing the universal diluting percentage myth.
      </div>
      <div
        class="ql-block"
        data-block-id="block-6a72e507-2520-424d-8449-d71383e6425e"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-ada5d6dc-c03f-4cf1-ab70-b6a6bea9ff25"
      >
        Most of us are familiar with a specific percentage we should use for our
        products, practices, and life.
      </div>
      <div
        class="ql-block"
        data-block-id="block-18ecfd78-676b-4e41-a795-ec09e06b544f"
      >
        We&apos;re referring to the specific diluting ranges we&apos;re supposed
        to use for different products.
      </div>
      <div
        class="ql-block"
        data-block-id="block-9a81f66b-e048-439d-a7cd-08986fab9de5"
      >
        For example, for facial cosmetics, it is suggested that we use a
        dilution range between 05-1.5% of essential oils in a medium such as
        butter, cream, oil, serum, etc.
      </div>
      <div
        class="ql-block"
        data-block-id="block-837c0e20-c7ec-4771-8833-ee338662f984"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-9c0577b3-16be-41c5-9e8a-52f6ed0339c4"
      >
        However, 0.5 % Cinnamon skin (<em>Cinnamomum Verum</em>) will burn our
        skin even in such low amounts.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b12e0a83-7ef7-4374-aae6-ac6fb5380681"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-c2b84962-862e-464f-8a6e-08f65f97e631"
      >
        Or another example, the suggested range for body massage products is
        between 2-3. But if we use Lemongrass<em>&nbsp;</em>(<em
          >Cymbopogon citratus</em
        >)<em>&nbsp;</em>in the 3% range, we&apos;re again doing more harm than
        good since the safety recommendations for this specific oil are a
        maximum of 1,7%.
      </div>
      <div
        class="ql-block"
        data-block-id="block-572c2dae-623d-41c6-a56d-058366071587"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-8694cf2f-6913-481d-b8a2-189a868542ee"
      >
        So we can&apos;t help but ask - are those universal diluting percentages
        a truth or a myth?
      </div>
      <div
        class="ql-block"
        data-block-id="block-62d6e131-84bc-4265-b9d0-a33cf0df09bc"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-565a82c9-e22e-4b38-b288-414af4fa6602"
      >
        Maybe the answer is somewhere in between, but we must start somewhere.
      </div>
      <div
        class="ql-block"
        data-block-id="block-9bb90ab3-bbaf-443a-bd0c-7f51f5d1b30f"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-cf7e3fe2-3e24-4719-aab5-5f7293cd27cc"
      >
        And that somewhere is actively using Dropsmart not only to answer how
        &amp; why a specific essential oil works but also to address safety
        recommendations simultaneously.
      </div>
      <div
        class="ql-block"
        data-block-id="block-903e87fa-9a17-4e51-a323-b0db4ba7f430"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-c3e0c814-f648-476f-abdd-c7343a7f42f5"
      >
        This leads us back to chemistry.
      </div>
      <div
        class="ql-block"
        data-block-id="block-1b3576f1-2ef9-4607-a058-dee9545059dc"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-eef3e70a-37ae-42db-835f-54b8c524642e"
      >
        But let&apos;s get practical!
      </div>
      <div
        class="ql-block"
        data-block-id="block-fb8fb8c6-028c-456b-b51a-051e0b913235"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-4b9914d1-9fcb-446e-8272-2af8b9de0bba"
      >
        We&apos;re using a rather popular suggestion - mosquitos.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b8ef71a7-6908-45a9-a5b0-340f63ff33cb"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-252ca791-2803-49b6-852a-dde82703eb2b"
      >
        This is a very typical example since we often reach for natural products
        to protect our young ones.
      </div>
      <div
        class="ql-block"
        data-block-id="block-7b2131d5-3b99-41e1-ad58-26a7332ec8fd"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-06446a98-2469-4c95-9597-1adb63ffe726"
      >
        If you wish to see how to create your own safe &amp; efficient blend -
        you might want to check
        <a
          class="ql-link"
          href="https://www.youtube.com/watch?v=e1vt1666zzE"
          rel="noopener noreferrer"
          target="_blank"
          >this video out</a
        >.
      </div>
      <div
        class="ql-block"
        data-block-id="block-598b917d-8d86-46e0-9a04-911e6d4b90cd"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f814842a-c0f8-490d-8e89-c6daa45d72e3"
      >
        <span
          class="ql-comment"
          data-comment-ids="1225442417"
          data-comment-unresolved-ids=""
          >Lemongrass</span
        >
        is one of the most popular oils and the most frequently recommended when
        mosquito repellents are in question. However, this same oil has only
        0.7% of maximum dermal usage recommended, isn&apos;t suitable for
        pregnant women and children under the age of 2, and has a tendency to
        provoke skin sensitivities.
      </div>
      <div
        class="ql-block"
        data-block-id="block-7bc89eb3-3988-4821-a7e3-c2c7cc650a12"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-be464c34-91fc-4aa5-8ab5-23574bb33a90"
      >
        So why is it universally recommended?
      </div>
      <div
        class="ql-block"
        data-block-id="block-6a5f524e-e7df-430f-af72-9a51eec06194"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-18db5b4a-b76b-4eaf-b561-02e3780f9126"
      >
        The answer probably lies between accessibility and a pretty affordable
        price range.
      </div>
      <div
        class="ql-block"
        data-block-id="block-7d949d6e-c653-4c9f-8a19-6bcfe529ef4f"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-60751530-5651-4373-9dd6-ddc7d1ca41a0"
      >
        But, if we want a powerful mosquito repellent - will 0.7% be enough?
      </div>
      <div
        class="ql-block"
        data-block-id="block-ccc7f516-fc64-4422-a5f4-98399048ea35"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-cfe27c5c-f309-4e36-ba9c-72e7f9c8b9ad"
      >
        The concern is that for most repellents, the recommended range is
        between 10-20%, which is way higher than this oil can bear without
        posing a threat to our health.
      </div>
      <div
        class="ql-block"
        data-block-id="block-46ee7863-e2cf-4d8b-a864-6f6996c416e5"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-5fd648c8-98a4-4970-84e2-28a5647605e1"
      >
        This is one reason for not using these universal ranges as a rule of
        thumb.
      </div>
      <div
        class="ql-block"
        data-block-id="block-194ba3cf-917c-4793-8c86-ceea881fa2e1"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-86794a46-cb96-4d87-92c7-b2f53335dc4b"
      >
        What can be done?
      </div>
      <div
        class="ql-block"
        data-block-id="block-0b2244e7-c973-4280-ae41-81d8d13ff605"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-6fa8426a-6a37-43f1-a83c-8c1e7d0a29b2"
      >
        Well, it is filtering Dropsmart&apos;s database to find
        <strong>the perfect fit.&nbsp;</strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-33d1b143-b2e5-446e-afae-c375e6d13291"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-c9b266f9-0d0a-4598-86f0-697153ce2098"
      >
        And leveraging the Comparison Tool - to solidify our choice.
      </div>
      <div
        class="ql-block"
        data-block-id="block-5dc97f5f-c116-4d44-bccf-2225d07a9199"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-21a70e70-a1d5-4c29-b53d-6004bd56d952"
      >
        In her aromatherapy class, our founder Melani has discussed with her
        students on the best options to create a powerful blend that is also
        children-friendly and useful regardless of the time of the day.
      </div>
      <div
        class="ql-block"
        data-block-id="block-ec1d2bbf-31a4-4324-986e-c3b08871c609"
      >
        For example, the efficiency of the Rosemary (<em
          >Rosmarinus officinalis</em
        >
        L.) essential oils as a repellent is non-negotiable. Still, it will also
        probably wake us up if we use it in the evening - which isn&apos;t
        something we&apos;re striving for.
      </div>
      <div
        class="ql-block"
        data-block-id="block-eb50783e-a913-4f6a-be7d-6e26ed84d81a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-8ca2e496-56a7-4ca3-bad3-151e91e9cdbd"
      >
        So, for this blend, we choose 5 essential oils:
      </div>
      <div
        class="ql-block"
        data-block-id="block-d2a1fe8b-2b7f-4b62-98b5-3baeec6111b8"
      >
        <br />
      </div>
      <ol>
        <li>Spearmint<em>&nbsp;(Mentha spicata</em>) - 1 drop.</li>
        <li>Geranium (<em>Pelargonium graveolens</em>) - 2 drops.</li>
        <li>Ginger (<em>Zingiber officinale</em>) - 2 drops.</li>
        <li>
          Sweet Orange&nbsp;(<em>Citrus sinensis</em>)<em>&nbsp;</em>- 5
          drops<em>.</em>
        </li>
        <li>Lavender (<em>Lavandula angustifolia</em>) - 1 drop.</li>
      </ol>
      <div
        class="ql-block"
        data-block-id="block-88a46729-e697-43fa-ad55-cc43f9751047"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-7f4f497e-0282-413f-815e-fae122dbc8bd"
      >
        Those oils were carefully selected according to their chemical
        constituents - and their wide variety, which will ensure that mosquitos
        will be attacked in different ways.
      </div>
      <div
        class="ql-block"
        data-block-id="block-df487b03-d8c6-4b15-a0bf-8768e80ccce4"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a08515d6-9d8b-4432-aa4e-416c98dcd855"
      >
        By covering all three notes, we ensured a rather tempting smell, while
        the colors of the pie charts are complementary, which shows the nice
        &amp; smooth combination of these chemical constituents in different
        oils.
      </div>
      <div
        class="ql-block"
        data-block-id="block-7d2cda32-5fa6-4856-9ff7-9eb748da2cff"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-68c56ba1-2d39-4e06-a4bc-8ef25ed6a568"
      >
        As we&apos;re building layers of the art of formulating, we don&apos;t
        want to leave anything out - including smell, safety, and efficiency.
        This means all oils are going to perform spectacularly well in fighting
        mosquitos.
      </div>
      <div
        class="ql-block"
        data-block-id="block-f2cbac35-eeee-4cd8-87f2-b40129003e2d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-c888c41b-f26c-424c-8689-eb46d2735d73"
      >
        Let&apos;s talk about safety.
      </div>
      <div
        class="ql-block"
        data-block-id="block-6e47d63d-c9df-4f97-8e6b-395d27d06d15"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-3a761fe6-5b13-4bd6-ad55-e6217d18e879"
      >
        Why do we choose Sweet Orange specifically?
      </div>
      <div
        class="ql-block"
        data-block-id="block-d612b69c-c38b-4d1e-aaa3-0bef8daff593"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-cb96f01c-d7e2-4c1e-84cb-d5777e4cbfa7"
      >
        Well, because like many other citruses - it isn&apos;t phototoxic. We
        wanted the freshness of the smell &amp; the efficiency - but we also
        wanted to use it any time of the day.
      </div>
      <div
        class="ql-block"
        data-block-id="block-2200741f-2b82-468f-9690-23e2b10c395a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-dfe6410c-7daa-4df6-b751-cce8701290a3"
      >
        While ginger is something we wouldn&apos;t automatically mark as safe
        due to perceived &quot;spiciness,&quot; ginger is relatively safe to use
        and highly efficient as a repellent, but also incredibly useful to
        soothe itching once we&apos;ve been bitten.
      </div>
      <div
        class="ql-block"
        data-block-id="block-55d52466-68db-4b62-9f88-151492615db5"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-1fa64598-fd8f-4865-8460-258321d14641"
      >
        So this blend will repel mosquitos and soothe inflammation.
      </div>
      <div
        class="ql-block"
        data-block-id="block-196c854a-eb1c-45eb-9546-1ad1ccd3697f"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-109cad85-2fac-4dc4-847a-953e66a22d37"
      >
        Geranium has very high dermal use recommendations, while Spearmint is 7%
        of dermal usage recommended. So we&apos;ll use less of it.
      </div>
      <div
        class="ql-block"
        data-block-id="block-77f5543a-c8d6-4b04-85be-52f15aaff8d0"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-1258721d-8c43-41bb-9e55-84c3c0d2d779"
      >
        We also added Lavender, but we didn&apos;t put it into the comparison
        tool due to its global recognizability.
      </div>
      <div
        class="ql-block"
        data-block-id="block-4ad753a9-9bf9-4ca5-ae35-03a5a86ecbb5"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-c4f0a12f-25a0-4238-b565-9b02fe8d2481"
      >
        We created a concentrated blend to see if we could go over universal
        diluting percentages and stay safe.
      </div>
      <div
        class="ql-block"
        data-block-id="block-f2df4c96-de6c-4f50-8e14-acd786e64bc6"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-d26858f3-a53d-4396-8676-2e9cc789ea8f"
      >
        Whereas 0,7% Lemongrass usage is quite limiting for many reasons, in
        this blend, percentages of oils are incredibly high (11 drops in a 10 ml
        blend) yet completely safe.
      </div>
      <div
        class="ql-block"
        data-block-id="block-2de4b847-70e6-47f5-bae6-b9038b09c51a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-e75c11c1-36e9-4173-902a-66f220fe2582"
      >
        We don&apos;t typically recommend going so high - but we truly wanted to
        highlight how deceiving universal diluting percentages are. They serve,
        at best, as a starting point but most certainly shouldn&apos;t be
        perceived as direct guidelines.
      </div>
      <div
        class="ql-block"
        data-block-id="block-7f22161e-e65c-4a9c-b760-37d1c8eb9671"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-fa750602-d868-4203-9100-5c9285c45db5"
      >
        Sometimes, we can&apos;t go as high as recommended, and other times we
        can go much higher than the recommended dose.
      </div>
      <div
        class="ql-block"
        data-block-id="block-9dfc3ab0-ca56-4803-a109-7afb2da33e32"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-290be416-8e6a-4d16-b9c6-6f32b9764736"
      >
        We hope this step has empowered you to be more creative and efficient at
        the same time since you understand how each oil works and why (by
        looking at the chemistry.
      </div>
      <div
        class="ql-block"
        data-block-id="block-6cca617f-3cdd-4761-bda4-e132c1760ac6"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-e08b3799-ae1f-4034-a6d1-6cf2f693b273"
      >
        Implementing this understanding into the art of blending will boost the
        efficiency and effectiveness of your blends.
      </div>
      <div
        class="ql-block"
        data-block-id="block-4737d08b-2ee2-4091-98a3-0802a3413e7c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-dbb57488-756d-455e-9e0d-639d0d8796a1"
      >
        You don&apos;t have to depend on books, blogs, and seminars to create
        something uniquely expressing from your side - while covering a wide
        range of needs you&apos;re meeting with your oils.
      </div>
      <div
        class="ql-block"
        data-block-id="block-5527cfcd-113c-41cf-aa53-a762d8f3b139"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-7796fc50-881f-4738-aa53-7e37de087703"
      >
        We hope this was useful to you - thank you for your time, focus and
        attentiveness!
      </div>
      <div
        class="ql-block"
        data-block-id="block-9aaf7eb7-06f8-4d62-8c48-b20d3b712fa2"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-496809ac-014d-4ebf-83bb-358c8871564e"
      >
        Also, don&apos;t miss out on the chance to learn more with us🙂!
      </div>
      <div
        class="ql-block"
        data-block-id="block-748c016c-1bc4-4bf2-b6cc-92b032942b89"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-2d5f094f-4c7b-44db-ac98-1a2a184cb5f7"
      >
        We wish you a lovely day,
      </div>
      <div
        class="ql-block"
        data-block-id="block-4241c57e-f1b2-455a-a4cc-8fd1f7202765"
      >
        Dropmart Team
      </div>
      <div
        class="ql-block"
        data-block-id="block-723bc396-00d3-460f-bb6f-0950e3e40cfa"
      >
        <em
          ><a
            class="ql-link"
            href="http://dropsmart.io/"
            rel="noopener noreferrer"
            target="_blank"
            >Dropsmart.io</a
          >
          - The most trusted essential oil resource center.</em
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-e507b97a-f29b-438f-9d53-3667d051770f"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-cbb22de8-b04d-4f51-b732-1bb5888e7b18"
      >
        <strong>P.S.</strong> Today, we debunked universal diluting myths - and
        we hope did it justice!
      </div>
      <div
        class="ql-block"
        data-block-id="block-d5dca93f-e725-4630-b3f9-e807473e2880"
      >
        <br />
      </div>
      <div
        class="ql-block ql-align-center text-center"
        data-block-id="block-32c61dcf-dc4b-45e6-b721-9659e086ba0d"
      >
        <strong
          >Thanks for tuning in &amp; please continue your journey with the next
          step!</strong
        >
      </div>
    </article>

    <article v-else-if="stepNumber === 13">
      <p>
        Dear <span>{{ name }}</span
        >,
      </p>

      <div
        class="ql-block"
        data-block-id="block-3e86ae0a-c9a7-4598-bc66-3032b70cff20"
      >
        We hope you&apos;re having fun and learning much on our journey
        together! &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-d3e4afa5-ab43-47f6-9e18-f69fd591fda8"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-9d398de4-d5ea-4d10-b42c-9eea537b0bff"
      >
        As you surely remember, last time, we wrote about the importance of
        debunking the universal diluting percentages myth since they can be
        contra-productive and dangerous!
      </div>
      <div
        class="ql-block"
        data-block-id="block-f8752cef-a76c-46c2-b6e3-5460a07535f9"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-c02c1bf5-0889-4cfa-839e-22c0cc9de9c7"
      >
        Today we&apos;ll be learning how to ask the right questions instead of
        simply memorizing essential oils&apos; profiles and properties and
        blindly relying on books, articles, and opinions of others instead of on
        our knowledge &amp; inner guidance.
      </div>
      <div
        class="ql-block"
        data-block-id="block-1eb032a8-d0cd-4ba6-a2c7-211f643c2e92"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-572bb721-2edd-44ee-8871-d96ead3937c6"
      >
        A couple of years ago, this was the only solution - but luckily not
        anymore, as we&apos;ve stepped into the new era of Aromatherapy and have
        incredible tools to help us along the way - such as Dropsmart!🙂
      </div>
      <div
        class="ql-block"
        data-block-id="block-5641ebed-0552-4503-844d-a657b275510c"
      >
        &nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-1ce0a731-8c96-4fe5-9b66-9eb441762bfc"
      >
        We aspire to show you how to liberate your mind &amp; find a suitable
        oil for what you&apos;re trying to achieve. Hopefully, the one in your
        cupboard is ready!
      </div>
      <div
        class="ql-block"
        data-block-id="block-cb0abf37-0752-4c28-9c57-8f32b6c51070"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b7ecde51-8cea-4dde-8807-b87cb58fcda8"
      >
        Let&apos;s take stress as an example.
      </div>
      <div
        class="ql-block"
        data-block-id="block-5afe38f1-6eaa-4f91-beaa-f062f5c9cada"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-75b3a87d-435d-46d1-b3e9-eb3c1f9c224e"
      >
        If we type in stress in Dropsmart&apos;s search bar, we&apos;ll come up
        with 400 different suggestions!
      </div>
      <div
        class="ql-block"
        data-block-id="block-0b1f0207-0f8d-4b94-acb2-e624803c5ca9"
      >
        So how can we narrow it down - and make the best possible choice?
      </div>
      <div
        class="ql-block"
        data-block-id="block-2fb6305d-085d-4381-80d1-a89115cad971"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f7731416-8ec4-4b5b-9d12-3315047e350b"
      >
        Here asking the right questions becomes paramount.
      </div>
      <div
        class="ql-block"
        data-block-id="block-91c3d7cd-dfd6-43a4-a08b-13fef23bce5d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-0f9a89d7-434b-4b80-b586-41c903ffd606"
      >
        First, we want to ask ourselves - why are all these oils suggested for
        stress relief?
      </div>
      <div
        class="ql-block"
        data-block-id="block-5a3532d6-f46a-4b69-b369-6051cae1975d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a4d4a216-4929-46f5-9c77-21a96da98f1b"
      >
        Or even better - which type of stress do we hope to alleviate?
      </div>
      <div
        class="ql-block"
        data-block-id="block-059f3c82-ee26-46bc-b942-6b9b0f0a8688"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-3b4d9a91-4c4e-492a-9592-fc65f27c3e5d"
      >
        Are we trying to tackle insomnia-related stress? Or is it the constant
        stress that builds up and prevents us from waking up feeling refreshed
        and rejuvenated?
      </div>
      <div
        class="ql-block"
        data-block-id="block-0c3ca891-1fc4-46b6-b1ae-0d83ca598621"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b09ba655-62e5-4b36-8acb-36e2111c0db3"
      >
        Those are different problems altogether since, in the first scenario,
        we&apos;ll need an oil that will be soothing and relaxing and help us
        fall asleep. In contrast, in the second case scenario, we&apos;ll need
        something that&apos;s going to be more fresh &amp; uplifting.
      </div>
      <div
        class="ql-block"
        data-block-id="block-5532d792-3af1-4ffd-999f-8e7838ee0855"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f1efc56f-a718-4da6-8d6f-d280f0db5327"
      >
        Hence, being specific is paramount.
      </div>
      <div
        class="ql-block"
        data-block-id="block-27ed89e9-8d6e-4477-910e-a6a7cc843605"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-358a8c9f-e32d-41df-8161-dc6ae6054945"
      >
        But, once we are specific, how do we leverage that?
      </div>
      <div
        class="ql-block"
        data-block-id="block-d45a9570-444f-4d2f-a880-d3865f2e16cf"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-3cc22779-d171-46e7-a365-7978c6f9aca4"
      >
        Typically when we need an answer, we dive into the books, articles, and
        other literature, but it all means very little if we need the solution
        straight away.
      </div>
      <div
        class="ql-block"
        data-block-id="block-fc03de24-78ab-4e74-b42d-84ff676b7999"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f001533f-9229-4b9f-a84d-757e21d04b36"
      >
        Our founder Melani has decided to take exotic oils recommended by her
        favorite authors, and the oils she opts for are:
      </div>
      <div
        class="ql-block"
        data-block-id="block-0527e1e2-de46-400f-bb89-acdc5c1ec34d"
      >
        <br />
      </div>
      <ul>
        <li>Spearmint&nbsp;(<em>Mentha spicata</em>)</li>
        <li>Palmarosa<em>&nbsp;</em>(<em>Cymbopogon martini</em>)</li>
        <li>Spike Lavender&nbsp;(<em>Lavandula latifolia</em>)</li>
        <li>Yuzu&nbsp;(<em>Citrus junos Siebold ex Tanaka</em>)</li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-ca8bcfa3-02e9-4d63-b97a-e588f3d13fda"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-c52cec22-58f1-471e-a337-b53bc78c4f0d"
      >
        By observing the chemistry of those four essential oils, we notice that
        they&apos;re all extremely different.
      </div>
      <div
        class="ql-block"
        data-block-id="block-88a0e56a-b52e-411c-b438-cccf8fda9dad"
      >
        First, we wish to observe properties and scientific research on these
        oils - but there&apos;s not much to go by.
      </div>
      <div
        class="ql-block"
        data-block-id="block-9099e081-ff11-4b0c-9e8b-9886571551dd"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-8cb30849-9863-4813-a538-9491f20c724c"
      >
        Yes, we can notice that Yuzu has been proven to be an antistress, and
        Spike Lavender is sedative (which doesn&apos;t come as a surprise seeing
        the high 1,8 cineole percentage), but this is pretty much it.
      </div>
      <div
        class="ql-block"
        data-block-id="block-d2f851ce-a83a-4a33-9202-24e59e31fe24"
      >
        To continue our search, we&apos;re going to browse through application
        suggestions.
      </div>
      <div
        class="ql-block"
        data-block-id="block-7e5f9ecd-fc82-4f92-bfd5-c157d549522d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-51a93f73-afaa-49b3-bb5d-232a81e2d4ef"
      >
        By doing so, we can see that Palmarosa is an incredible oil to ease the
        anxiety, whereas both Spike Lavender &amp; Yuzu address the fatigue,
        which doesn&apos;t come as a surprise due to the 1,8 cineole presence.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b4ca9b20-1239-45c8-91ce-87b862dab1cd"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-eddeaa30-1bd8-414c-b7a7-4e1af90381a3"
      >
        In addition - all oils are mood uplifters!🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-1496b067-d004-4234-a938-47471f45c228"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-d1bd598d-4218-4430-ab2c-dab59aee184e"
      >
        The comparison tool helps us play around with chemistry even better -
        and to dive into the specific properties of chemical components for each
        oil.
      </div>
      <div
        class="ql-block"
        data-block-id="block-e203ae48-db63-430a-8e44-a014e2c3a989"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-2f309bbb-cab0-407f-b338-fbb9a2c9ac6f"
      >
        It also allows us to search properties within chemical constituents of
        these oils - so we can see how many of these properties are, for
        example, sedative and to what extent.
      </div>
      <div
        class="ql-block"
        data-block-id="block-77b6816b-14e5-4d86-bf98-7ce01759f42d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-6d76c2e5-5dda-4acc-9fb1-7f50fb3d330e"
      >
        This means that by searching for chemical constituents, we&apos;re
        broadening our scope of possibilities for usage since, in the
        literature, there are recommendations for up to 100 (if even) essential
        oils. In today&apos;s market, we have over 500. However, not all of them
        come with research - which isn&apos;t the same for the chemical
        components - which are heavily researched and presented in the
        Dropsmart.
      </div>
      <div
        class="ql-block"
        data-block-id="block-46d9a8e1-a5b2-49bc-aa7f-a5d266c80b32"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-7389d7cb-eae3-49af-bdb8-d8e8e209a26b"
      >
        So by using the new way to find information relevant to us, we get more
        creativity, freedom, and opportunities for experimentation and
        expression.
      </div>
      <div
        class="ql-block"
        data-block-id="block-c5b916a5-21ad-43e2-9349-9a148ed70d89"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-35e96caf-51e7-4d44-9796-c36f520e8842"
      >
        Now, since we&apos;re searching for something that&apos;s
        stress-reducing in a way that soothes negative emotions, we&apos;re
        going to see if any of the chemical components in those four oils are
        proven to be antidepressants.
      </div>
      <div
        class="ql-block"
        data-block-id="block-8e01ddf2-11ec-45c4-b1f6-9e6f9aeedadd"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-9127c54d-ba1b-499c-aaae-726e742d0d22"
      >
        We discover that Palmarosa has over 84% of chemical constituents, which
        are antidepressants, whereas Spearmint has only slightly over 20%. This
        is how we will decide on which oil to use when it comes to stress
        related to soothing negative emotions.
      </div>
      <div
        class="ql-block"
        data-block-id="block-88ad41d2-8378-4bb0-b78d-bf13b83c1f10"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-9d8b10d9-6125-4fa3-ac28-8d80fa10e649"
      >
        Seeing this dynamic and understanding not only the antidepressant
        properties of the specific oil but also the extent of it is priceless.
      </div>
      <div
        class="ql-block"
        data-block-id="block-3258c15a-fddf-41f7-a49d-1c5f86eaa85b"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-66aa3742-2d89-4b48-81e4-c823bb568650"
      >
        The following action we wanted to showcase was anxiolytic. With
        Palmarosa, it&apos;s a bit less since the geranium dominates (not even
        3%). Still, within Spearmint, it climbs up to over 56%, which means that
        this oil is more appropriate for anxiety-induced stress episodes.
      </div>
      <div
        class="ql-block"
        data-block-id="block-05c28446-ac2d-44db-bad9-de7d3cd2cd6d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-55c1f826-0f21-4de1-9a3e-ebc0b983d5d8"
      >
        This is how we suggest approaching the oils you already have.
      </div>
      <div
        class="ql-block"
        data-block-id="block-825c7755-aeff-4f21-9e14-4c1e84ab8447"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-8d591b7f-5dbb-499d-8701-e1aa24c3fa5f"
      >
        Take a pick of your favorites and look at what Dropsmart suggests when
        it comes to their usage! &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-d8748a33-1693-49a8-88fc-8f8f65c2855d"
      >
        So instead of searching for stress through our Search button, we&apos;re
        going to filter through chemical constituents and components - and
        search, for example, only oils which are rich (over 30%) in carvone.
      </div>
      <div
        class="ql-block"
        data-block-id="block-3dba2206-45f8-42bc-9329-63e66f33f57a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-5c90086e-1bad-4451-9945-2a80d964402a"
      >
        This leads us to the recommendation of only 9 oils, of which some are
        pretty surprising, such as:
      </div>
      <div
        class="ql-block"
        data-block-id="block-7894de6c-5ae9-4b33-9c30-c43224ef4602"
      >
        <br />
      </div>
      <ul>
        <li>Caraway (<em>Carum carvi</em>), and</li>
        <li>Dill Seed<em>&nbsp;(Anethum graveolens</em>).</li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-90502eaf-d76d-4e96-9629-29e618971f72"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-2ffd47dd-b13b-4e02-a766-ea5550105505"
      >
        If we look just a book researched, we&apos;ll probably end up using them
        only as repellents.
      </div>
      <div
        class="ql-block"
        data-block-id="block-bf66f0d3-6951-40e8-a5de-ae9d1c31d01f"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-35479fa5-621b-4afa-ae0e-512e74dbe0ec"
      >
        However, upon glimpsing through the detailed report (taking 3 clicks)
        and observing the properties research we collected, it&apos;s incredible
        to witness how many different options we have.
      </div>
      <div
        class="ql-block"
        data-block-id="block-9303c5de-912a-4879-9466-fb053f0c44cd"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-25ad1116-17c8-45d9-81e8-85b47cecfb4a"
      >
        Let&apos;s focus on, for example, emotional distress. We can see that
        both oils have a high percentage of antidepressant and anxiolytic
        properties within their chemical constituents.
      </div>
      <div
        class="ql-block"
        data-block-id="block-588c6943-6907-4f1a-a240-f7ca7a71056b"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-103a4e13-1685-446b-8efe-b35eb7664c97"
      >
        Safety recommendations are also on the side - since the safety
        recommendations are pretty high for both of them!
      </div>
      <div
        class="ql-block"
        data-block-id="block-2259a420-f7ea-4829-ac9f-d15517af545e"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-98ac3ab7-0557-41c5-8903-6f744af0b90d"
      >
        Isn&apos;t that incredible?
      </div>
      <div
        class="ql-block"
        data-block-id="block-625dc6f2-7076-4cd6-b296-2871b9efa37c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-4835b548-e740-4a0c-abb8-574163e3d440"
      >
        It allows us to be more creative, expressive, and authentic - while
        making sure we&apos;re recommending efficient solutions!
      </div>
      <div
        class="ql-block"
        data-block-id="block-07231b60-f230-4c2d-ba74-469b897acfe7"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f867e43f-60a3-4678-bb8b-c8b7fe37cda6"
      >
        So let&apos;s use the oils we have and are about to oxidate.
      </div>
      <div
        class="ql-block"
        data-block-id="block-94e2248c-11c1-4763-886e-e5f62594997c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-1ae0d201-36ec-42a1-9f9f-a5a2e09cf75d"
      >
        Or the ones who keep collecting dust in our cupboards simply because we
        don&apos;t know what to do with them.
      </div>
      <div
        class="ql-block"
        data-block-id="block-1c2430c4-53e2-4686-be16-918a91f9b06b"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-fcb48450-1231-41e3-9e3b-a4a2384741f2"
      >
        We can infuse our articles with this new wisdom, enrich our practice
        with a creative approach, use the oils we have instead of buying new
        ones, and boost our professional credibility while doing so.
      </div>
      <div
        class="ql-block"
        data-block-id="block-67deb455-214b-4768-8e2e-87cddfbe57b0"
      >
        And all of that in a few clicks.
      </div>
      <div
        class="ql-block"
        data-block-id="block-90264473-df5b-4eea-b0f1-e1b742471748"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-d5bb3314-c450-4d72-a61d-b9a850dc48f6"
      >
        Isn&apos;t that extraordinary?
      </div>
      <div
        class="ql-block"
        data-block-id="block-8f613a5a-754e-4666-b855-d45a78691f04"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f7b25845-7c06-4ee9-842f-7996a96b8890"
      >
        We hope this was useful and that it has inspired you to explore the oils
        you already have! &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-592e22ea-d362-4006-b8aa-ea8bed7ebe95"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-ba7206fc-1a37-45b5-afc8-269923a2e8a9"
      >
        We wish you a lovely day,
      </div>
      <div
        class="ql-block"
        data-block-id="block-db59ecb2-b437-4054-8a91-513df80cf614"
      >
        Dropmart Team
      </div>
      <div
        class="ql-block"
        data-block-id="block-dfc1b781-e059-47ad-a229-0994f41a0d63"
      >
        <em
          ><a
            class="ql-link"
            href="http://dropsmart.io/"
            rel="noopener noreferrer"
            target="_blank"
            >Dropsmart.io</a
          >
          - The most trusted essential oil resource center.</em
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-27de9e5e-c5b5-4eae-8080-8375310155b3"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-4a31ee1e-3651-4ae7-959b-af2a53928db6"
      >
        <strong>P.S.</strong> Today, we shared why the shortcut to success is
        asking the right questions and how to use the oils you already have (and
        why to do it, to begin with).
      </div>
      <div
        class="ql-block"
        data-block-id="block-de939b98-172e-4e9c-a85f-5d69714521b4"
      >
        <br />
      </div>
      <div
        class="ql-block ql-align-center text-center"
        data-block-id="block-549617ae-cf6e-4871-938e-b67a31e0f4cc"
      >
        <strong
          >Thanks for tuning in &amp; please continue your journey with the next
          step!</strong
        >
      </div>
    </article>

    <article v-else-if="stepNumber === 14">
      <p>
        Dear <span>{{ name }}</span
        >,
      </p>
      <div
        class="ql-block"
        data-block-id="block-123cd21a-c294-4ee9-885d-94870d352f56"
      >
        We hope you&apos;re having fun and learning much on our journey
        together! &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-cd74f110-f078-4e2e-ad2b-612ba9e0b5d5"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b0687ee1-6324-4298-bb2b-5e36bab1394c"
      >
        As you surely remember, last time, we discussed how asking the right
        questions is paramount if we aspire to obtain ease and excellence within
        our practice and life.
      </div>
      <div
        class="ql-block"
        data-block-id="block-c8fd4f20-712d-4855-a8d6-abb30d260fd9"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-62836f9a-cc9d-49f3-bb92-758f2a75a1dc"
      >
        Today we&apos;ll learn how to self-express through aromatherapy.
      </div>
      <div
        class="ql-block"
        data-block-id="block-43eefd82-8b46-4fd9-8966-2e658d6e34dd"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a2019f4e-d4e2-401c-8327-00555a5caaf8"
      >
        We&apos;ve decided to navigate you through creating three blends with
        confidence, creativity, and oils you already have.
      </div>
      <div
        class="ql-block"
        data-block-id="block-399551a8-341a-4845-ace0-85c598d7bc67"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-2ccde37a-a4b9-4518-8594-00f0e17ab7d6"
      >
        As you know, before we create any blend, we usually go through a
        plethora of books, articles, and materials, in general, to get proper
        references and ensure we are doing the &quot;right thing.&quot;
      </div>
      <div
        class="ql-block"
        data-block-id="block-eb36a817-4e88-4ae8-aeaa-78cae7a5db0f"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-60b4b3a8-8675-42ab-9ee4-625f3fc201ca"
      >
        However, this approach is becoming outdated rapidly.
      </div>
      <div
        class="ql-block"
        data-block-id="block-8193ffb5-4f90-4530-98cc-cfea734d0359"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-9f1832d1-19ec-429d-aa90-18bc5987752f"
      >
        How so?
      </div>
      <div
        class="ql-block"
        data-block-id="block-9ebe9b63-46fb-4579-b15b-802feed97a15"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-60ccbc26-1f33-4428-b252-4f5bd9e5e3f5"
      >
        Since:
      </div>
      <div
        class="ql-block"
        data-block-id="block-90986276-f1c8-4be1-89f0-33c49b56a5d1"
      >
        <br />
      </div>
      <ul>
        <li>
          It&apos;s hard to keep up with the new oils which are popping as
          mushrooms after the rain.
        </li>
        <li>
          It&apos;s equally challenging to keep up with the research which
          follows each oil.
        </li>
        <li>
          It&apos;s extremely time-consuming - search, comparison, and
          re-evaluation-wise.
        </li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-d3101c77-6436-4c12-ae29-673dbea09e28"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f78f3dd6-6141-448d-91f8-f3260e62539a"
      >
        So we decided to show you three recipes you can use in less than 15
        minutes and hopefully teach you how to find/blend them on your own next
        time, according to what you need.
      </div>
      <div
        class="ql-block"
        data-block-id="block-d228a7f5-d3a5-4fb8-a047-bbc56dcf1cf6"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-d64c725d-3305-4cbc-a71b-17dfaef02971"
      >
        However, we need to start with the search button and want to put into
        the search bar the term we&apos;re looking for.
      </div>
      <div
        class="ql-block"
        data-block-id="block-093cad21-a155-4e2a-8b45-8cc13117c10a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-83c8f9d2-27c6-42e7-b244-21e918017942"
      >
        Let&apos;s take the stress keyword as an example (the exact keyword we
        used last time around).
      </div>
      <div
        class="ql-block"
        data-block-id="block-e0248691-c781-499e-9ae1-3400eadca6c8"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-1ff48154-22aa-475e-b21d-f2a9241d8130"
      >
        By typing stress in the search bar, we&apos;re left with over 400
        recommendations.
      </div>
      <div
        class="ql-block"
        data-block-id="block-d054354a-e091-4afd-9834-69967bbfcd23"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-65d8aa1c-2a15-4d7f-9d49-ddbefa712f5c"
      >
        Luckily, we can sum it up pretty quickly by asking ourselves a rather
        important question:
      </div>
      <div
        class="ql-block"
        data-block-id="block-590fb52d-2345-4107-99d7-5d8406da75eb"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-67697f82-da0c-45ab-a682-93392b79503d"
      >
        &quot;Which oils do I already have?&quot;
      </div>
      <div
        class="ql-block"
        data-block-id="block-48b6b99c-8814-4c1c-b605-525f4ba727e6"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-150006c7-a375-417b-a6ee-b189aa443739"
      >
        By doing this, we will select the &quot;favorites&quot; category, in
        which we presumably have our favorite essential oils saved. But, of
        course, we&apos;re talking about the oils we own, not simply those we
        like.
      </div>
      <div
        class="ql-block"
        data-block-id="block-0be5d805-8935-4d39-9b43-4c17035393f3"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-003f0362-65a5-4ca1-9adf-c86ec08e8b1a"
      >
        By following our founder Melani&apos;s lead, we could see she was left
        with 42 recommendations upon browsing the keyword &quot;stress&quot; in
        her favorites section.
      </div>
      <div
        class="ql-block"
        data-block-id="block-87513deb-728e-4db9-9537-10e0d90a6d47"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-96e15992-cc84-4843-aa0b-4d21af64a4b5"
      >
        This has significantly narrowed our options.
      </div>
      <div
        class="ql-block"
        data-block-id="block-48dd3960-fcad-4819-89ed-01d14fefcc4a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-ab1d1270-4c92-431f-9a2b-3c223ba6e615"
      >
        By searching for an oil(s) we use this way, not only are we being
        mindful of the environment, but we&apos;re also saving both money and
        time in the process.
      </div>
      <div
        class="ql-block"
        data-block-id="block-1197770e-1f81-4c47-892d-3f18592da0f2"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-5f05c200-dc6d-404a-9baa-174fb77e525b"
      >
        We all have oils dusting out somewhere in our cupboards - why
        wouldn&apos;t we use them and help whoever knocks on our door?
        &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-679b4fd7-55c4-49d7-9e31-ba270c4dc2f0"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-3a044cf4-8115-4904-a1b6-ef90d249ac47"
      >
        To exemplify this, our founder Melani decided to choose three oils and
        showcase how and what we can do in the future.
      </div>
      <div
        class="ql-block"
        data-block-id="block-5e457280-6afe-4734-8996-946fa61ce573"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-01e2f66b-e8dd-4f48-a771-3e512e043a66"
      >
        As she was selecting them, she kept colors in mind due to the
        determination to have all of the three main notes represented in the
        oils which are chosen so the smell would be well-rounded.
      </div>
      <div
        class="ql-block"
        data-block-id="block-cedbfdbc-0ca5-4b36-93b7-ae379e0d72ee"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-54e3bacb-61a0-4eca-9303-3a798c275968"
      >
        Those three oils are:
      </div>
      <div
        class="ql-block"
        data-block-id="block-df006227-ee2a-409d-ad20-4d6438f42dd1"
      >
        <br />
      </div>
      <ul>
        <li>
          Rose&nbsp;(<em>Rosa x damascena</em>)&nbsp;- for the middle not.
        </li>
        <li>
          Pacific Sandalwood (<em>Santalum austrocaledonicum</em>) - for the low
          note.
        </li>
        <li>
          Lemon<em>&nbsp;</em>(<em>Citrus limon</em>)&nbsp;- for the top note.
        </li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-f23a2269-8ffd-4f06-ac0a-280fd2ac3791"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-d39a0017-0c37-4c15-8ca7-0724764be37e"
      >
        The selection was relatively quick and covered all of the notes.
      </div>
      <div
        class="ql-block"
        data-block-id="block-7bb0efd0-041d-4d3d-a5bf-3b7b0929f429"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-161448c1-458f-4f70-9365-9661a59f42ff"
      >
        This specific blend was named &quot;Stress 1&quot;. Playing around with
        a virtual blending simulator reminded us how a beneficial tool it is -
        especially when it comes to predicting smell and ensuring complete
        coverage of all notes, while allowing us to change the quantity of each
        particular oil (if we see there&apos;s a need for it).
      </div>
      <div
        class="ql-block"
        data-block-id="block-92f87574-1d68-4a67-b4be-1b149d1fe784"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-810aba20-4b0a-4e4d-bace-cc75f9a084f2"
      >
        This blend was rounded up (and saved) in the following quantities:
      </div>
      <div
        class="ql-block"
        data-block-id="block-6f8b6711-4423-4299-bdd2-3f91e7c292be"
      >
        <br />
      </div>
      <ul>
        <li>2 drops of Lemon.</li>
        <li>1 drop of Pacific sandalwood.</li>
        <li>2 drops of Rose.</li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-ded931c2-9a93-4e05-af37-031e8cfc900b"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-005b8342-9002-4f12-af86-09f3576dbfe2"
      >
        Upon glimpsing through the applications suggestions for this blend, it
        was easy to spot:
      </div>
      <div
        class="ql-block"
        data-block-id="block-002be02c-4206-451f-9edc-06349f1c5df1"
      >
        <br />
      </div>
      <ul>
        <li>anxiety,</li>
        <li>depression,</li>
        <li>relaxation,</li>
        <li>sleep,</li>
        <li>stress,</li>
        <li>fatigue, and</li>
        <li>calmness.</li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-5f165ff4-4b17-437f-8be0-c6eabe19d920"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-ad4520ed-b9a8-4682-b02d-d8808632f928"
      >
        And so on.
      </div>
      <div
        class="ql-block"
        data-block-id="block-f67aef3a-96da-4156-bcff-49aa289199da"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-00aa8e62-b489-4462-9c96-9c7750e0d4ec"
      >
        So many references are available for us to &quot;back up&quot; our
        choice, and specific safety recommendations are given for each oil and
        the blend specifically.
      </div>
      <div
        class="ql-block"
        data-block-id="block-6bc64ff4-c455-42da-a849-7f8a4ee483db"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b5383d00-fdbc-4a9b-bfe4-416cc31daa7c"
      >
        And just like this - a fantastic blend is here to serve us!
        &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-a95357d5-cc02-42b8-a2e9-1e465b5ca759"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-fc9bd19b-91a0-429f-abcf-19190aeafe92"
      >
        However, both Rose &amp; Sandalwood belong to the more expensive oils,
        so we were curious as to what we could do if we wished to be a tad more
        economical.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b23f7d0a-f830-4765-9c63-aa4b3f8474a6"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-147126a8-ccb7-4547-950c-816fd82ca41d"
      >
        So, as always, it starts with the search bar - within the favorites
        category (since we wish to use oils we already have).
      </div>
      <div
        class="ql-block"
        data-block-id="block-40322dfb-a2db-4058-8669-11843a5f990d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-ce99addc-d065-4e9a-9797-e71aad1994f4"
      >
        So, we again type in stress and browse through the recommended oils.
      </div>
      <div
        class="ql-block"
        data-block-id="block-e5ced7a6-d293-44a6-b384-344641d40f64"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-7c8e1e40-c6e6-4ce5-9321-42f79d3f7e71"
      >
        This time we opted for a less expensive and more traditional blend
        consisting of:
      </div>
      <div
        class="ql-block"
        data-block-id="block-73fae407-879d-43a8-a6be-190196bf0df0"
      >
        <br />
      </div>
      <ul>
        <li>
          Lavender&nbsp;(<em>Lavandula angustifolia</em>)<em>&nbsp;</em>- 1
          drop.
        </li>
        <li>
          Bergamot&nbsp;(<em>Citrus bergamia</em>)<em>&nbsp;&amp;&nbsp;</em>- 3
          drops.
        </li>
        <li>
          Spikenard&nbsp;(<em>Nardostachys jatamansi</em>)<em>&nbsp;</em>- 2
          drops.
        </li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-aa993dfd-be8e-4ab2-a163-44c2fbb01422"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-2ac5e411-df58-46e0-b34a-50bcde576bd2"
      >
        This blend was named &quot;Stress 2&quot;, and its creation helped us to
        appreciate the virtual blending simulator even more since we saw which
        notes were underrepresented and increased the quantity accordingly.
      </div>
      <div
        class="ql-block"
        data-block-id="block-ec8cd6cf-86c5-4d1b-a7b2-2b8d42cf1589"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-1ae09df6-efce-4701-ab8b-86c92753c8da"
      >
        This blend is more &quot;safe&quot;, traditional &amp; safe.
      </div>
      <div
        class="ql-block"
        data-block-id="block-11775698-5447-4dab-89c8-1f8da937309f"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-6ce73fea-0791-4fba-817b-659a10d9c2bb"
      >
        Again, among the application suggestions, we found:
      </div>
      <div
        class="ql-block"
        data-block-id="block-4c3a47c2-cc8a-43e5-9726-18f24fbdccae"
      >
        <br />
      </div>
      <ul>
        <li>calmness,</li>
        <li>fatigue,</li>
        <li>nervousness,</li>
        <li>agitation, and</li>
        <li>anxiety.</li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-755b3fd2-19c1-4f83-b797-a2f187ebf55d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-aea6edb7-0cd7-41da-9e33-8c7d5ce2a4cc"
      >
        And a plethora of suggestions for usage.
      </div>
      <div
        class="ql-block"
        data-block-id="block-1660db0a-44e6-454d-8675-139e8ab2b6fd"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-5b325068-458c-4a9b-b0d1-eccff9bb9158"
      >
        Of course, each oil selected is heavily researched and ensures
        professional efficiency.
      </div>
      <div
        class="ql-block"
        data-block-id="block-86c3407d-114f-4b36-9fec-d595a9e59af0"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-5bb3fc26-19e7-4b51-90e7-88b8ceb3a0b3"
      >
        Last but not least, we opted for creating a third blend - something a
        bit more exotic, daring, and fun.
      </div>
      <div
        class="ql-block"
        data-block-id="block-11077114-6f02-4673-b5d8-ea52137994b8"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-38e9d6a9-6d8a-4275-80dd-ee3af4670f2a"
      >
        The same procedure is followed for creating this blend.
      </div>
      <div
        class="ql-block"
        data-block-id="block-a35e5ced-afba-47ef-8a96-5f9e526ead28"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-af2fd778-0109-48cf-bf47-851f93e3aa09"
      >
        Oils selected for this blend are:
      </div>
      <div
        class="ql-block"
        data-block-id="block-6c497685-a7e3-4c7b-b1f4-feff1248247e"
      >
        <br />
      </div>
      <ul>
        <li>
          Cardamom&nbsp;(<em>Elettaria cardamomum</em>)<em>&nbsp;</em>- 2 drops.
        </li>
        <li>Sweet Orange&nbsp;(<em>Citrus sinensis</em>) - 2 drops.</li>
        <li>
          Vetiver&nbsp;(<em>Chrysopogon zizanioides</em>)<em>&nbsp;</em>- 3
          drops.
        </li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-8d6379ac-207a-43a1-8530-cc9ad511364d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-da715574-671a-4abd-bd93-a5000c65c9d3"
      >
        This blend was named &quot;Stress 3&quot; and saved as well.
      </div>
      <div
        class="ql-block"
        data-block-id="block-d6bbbb42-e715-419c-bdc7-4d2cdae18a89"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f9c2f28b-57c9-41d7-a5df-bda134bf5c73"
      >
        Application suggestions:
      </div>
      <div
        class="ql-block"
        data-block-id="block-c0188864-e8d6-42a3-947d-ebea764cebae"
      >
        <br />
      </div>
      <ul>
        <li>relaxation,</li>
        <li>depression,</li>
        <li>energy,</li>
        <li>stress,</li>
        <li>depression,</li>
        <li>calmness, etc.</li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-5e988af4-5924-4670-9cea-e69f91fdc770"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f7a97d76-4922-4f70-bf5f-a1f49e719f6c"
      >
        Confirmed we did a good job.
      </div>
      <div
        class="ql-block"
        data-block-id="block-26588a2c-f9ce-436d-a613-d1d82c1c0ff9"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-391e5563-ba0e-48f6-b18c-d1c5115a3e90"
      >
        And this is how we can create a verifiable, quick, and efficient
        solution.
      </div>
      <div
        class="ql-block"
        data-block-id="block-5b74b726-9d77-4e23-a4b9-3c7de96caaec"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-c3d759ec-5974-4f67-af3d-dd3153d27a8d"
      >
        If we want to be open and spicy while remedying stress - we&apos;ll
        choose this one.
      </div>
      <div
        class="ql-block"
        data-block-id="block-50b9f4d5-8a81-4ba8-9a48-e73af9bfd6f4"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-4127667c-72f3-4908-943e-d4b3fb88a3c2"
      >
        On the other hand, if we wish to be more &quot;safe&quot; and
        traditional, we&apos;re most likely to opt for a blend &quot;Stress
        2&quot;.
      </div>
      <div
        class="ql-block"
        data-block-id="block-448ab8df-a836-4d7c-9fef-6e4da9c591c5"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-675abd15-41fa-4b5b-adb7-1622fa63062e"
      >
        However, if we want to provide a top-notch premium (albeit pricey)
        experience, we&apos;ll most certainly go with the blend &quot;Stress
        1&quot;.
      </div>
      <div
        class="ql-block"
        data-block-id="block-2b6976e0-0c81-47cd-82a2-45f0a19342fd"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-03d8ed05-32dc-4593-a53e-f958f8450702"
      >
        So choosing the right blend depends partly on chemistry, partly on our
        preferences, and partly on our client&apos;s needs.
      </div>
      <div
        class="ql-block"
        data-block-id="block-3da8b58a-4d6c-4cda-8e0a-40ef174438a1"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f7eb3dfd-d784-4884-a303-ed2a3f556a68"
      >
        We hope this video was helpful and educational and showed how you could
        present professional and efficient solutions while saving time, money,
        and the environment in the process (by using oils you already have).
      </div>
      <div
        class="ql-block"
        data-block-id="block-4b9c3712-ec98-425b-a86b-1548d000c628"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-9da4cb60-4253-4c95-8037-030645a62b34"
      >
        Let&apos;s use what we have - was the undertone of this step!
        &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block ql-align-center"
        data-block-id="block-bfc868a0-f565-4474-8fc4-823e4f059114"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-7df7d6b0-d31f-49f6-9f24-f4875479a50f"
      >
        We wish you a lovely day,
      </div>
      <div
        class="ql-block"
        data-block-id="block-553e64db-d93d-4f0a-b509-f3264847d307"
      >
        Dropmart Team
      </div>
      <div
        class="ql-block"
        data-block-id="block-c8896e0b-e646-445e-8f73-5a44052dffd4"
      >
        <em
          ><a
            class="ql-link"
            href="http://dropsmart.io/"
            rel="noopener noreferrer"
            target="_blank"
            >Dropsmart.io</a
          >
          - The most trusted essential oil resource center.</em
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-6511c57b-5d20-4c33-8fa4-0b1bda0ed61c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f089db31-6e14-4ae0-bc69-4c8f96956e58"
      >
        <strong>P.S.</strong> Today, we shared why the shortcut to success is
        asking the right questions and how to use the oils you already have (and
        why to do it, to begin with).
      </div>
      <div
        class="ql-block"
        data-block-id="block-60cf7a67-f880-40b2-b65b-2bdfcb2fafdf"
      >
        <br />
      </div>
      <div
        class="ql-block ql-align-center text-center"
        data-block-id="block-fdd2373a-f390-4c02-91b3-913e3d033701"
      >
        <strong
          >Thanks for tuning in &amp; please continue your journey with the next
          step!</strong
        >
      </div>
    </article>

    <article v-else-if="stepNumber === 15">
      <p>
        Dear <span>{{ name }}</span
        >,
      </p>
      <div
        class="ql-block"
        data-block-id="block-62d2bb71-fed7-4a06-9ccf-5e815d9e774a"
      >
        We hope this journey with us is fun and educational at the same time!
      </div>
      <div
        class="ql-block"
        data-block-id="block-31e010c7-fe1f-4a52-98dc-e6ed24587ab5"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-062e00b3-7940-45cf-bc0a-e118d5cf378a"
      >
        Are you enjoying it? Let us know! &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-b85ae55d-e624-44f9-be50-644781fb0f0a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-532835b6-a15a-4e40-898c-ceba7d863c94"
      >
        As you surely remember, last time, we led you through a step-by-step
        customized process of creating your unique blends from the
        <strong>oils you already own.&nbsp;</strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-02f0bf18-a042-47f1-a685-3923c43ba6d7"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-3a3f897b-822a-4c20-950f-ac7b575f082c"
      >
        Today we&apos;ll be talking about experimentation without consequences.
      </div>
      <div
        class="ql-block"
        data-block-id="block-94410798-b54c-4adf-94d4-3f0f1ed48035"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-37ad1820-f468-44a5-a694-95f6cf1053cb"
      >
        Being an aromatherapy expert/lover nowadays comes with many perks (one
        of which is the usage of Dropsmart) but also a couple of minutes.
      </div>
      <div
        class="ql-block"
        data-block-id="block-15ce4c51-fab6-4155-a3dc-aa7bb97fa0dd"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-e8ae8e05-48ba-493c-9cc6-deab1de6aa30"
      >
        One of the main minuses is - FOMO (fear of missing out).
      </div>
      <div
        class="ql-block"
        data-block-id="block-06956833-3f4d-4064-9914-7220e8a84c80"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-7078fd72-c632-47fb-9898-19a54cda4576"
      >
        Yes, we are referring to the desire to try all oils - new ones, old
        ones, exotic ones, the ones that someone recommended to us, the ones we
        bought at our latest conference, etc., and having a feeling that no
        matter what, we&apos;ll never get to enjoy them all.
      </div>
      <div
        class="ql-block"
        data-block-id="block-11e29f15-68b6-4755-92ca-36b9d4ab3b10"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-1f4a7b9d-3444-496c-9bee-19b9df0c6ecb"
      >
        In addition, essential oils are potent and need to be handled with care
        not only because we want to achieve specific results but also because we
        don&apos;t want to endanger anyone&apos;s health.
      </div>
      <div
        class="ql-block"
        data-block-id="block-7497a4a4-32eb-40b8-9527-f1db95e28ed9"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-bb272d2d-e9a7-4b36-8eca-f63ffe956592"
      >
        So how do we do it? 🤔
      </div>
      <div
        class="ql-block"
        data-block-id="block-b61b0e4f-23f4-49d7-b2db-87b02bc208df"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-e0f36953-456f-4043-a7c5-0c2167822bf3"
      >
        How do we make sure we&apos;ll deliver maximum results to our clients
        with maximum safety and, at the same time, satisfy our need for
        experimentation by trying out new oils? 🤔
      </div>
      <div
        class="ql-block"
        data-block-id="block-248f80bb-fdc5-4800-b283-55f4cdeb6f3c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-78316e14-bb87-4b45-a33c-40a4eddbfd3b"
      >
        Although mentioned many times in the previous emails, the first step
        must be said again.
      </div>
      <div
        class="ql-block"
        data-block-id="block-63d61a55-f58e-4fe9-9409-441f07858528"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-ead53e01-c45b-4bea-b7f3-9304f6742969"
      >
        And that first step is - creating our own collection within Dropsmart.
      </div>
      <div
        class="ql-block"
        data-block-id="block-f46b980b-d753-4fca-8240-4e1880450506"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a4e8dc17-5d64-4f93-a734-5efa83202987"
      >
        Let&apos;s remember - we want to start by using oils that we
        <strong>already have,&nbsp;</strong>and we want to make the most of
        them! &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-f1e8d709-e6c3-4e38-bf4f-1908eaf3dd42"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-54ecd1d2-9021-42e8-be00-22b33b1ff9ad"
      >
        Hence - favoriting our essential oils is essential.
      </div>
      <div
        class="ql-block"
        data-block-id="block-3adc9810-0dbe-4975-ae80-19abddd4887d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-de265a6f-26cd-444a-b393-bb43b3ab0ba4"
      >
        This allows us to search for a specific term (issue) among the oils we
        already have in our collection but also reminds us of the oils we have
        (and should use) before they oxidate.
      </div>
      <div
        class="ql-block"
        data-block-id="block-7ebc2f75-8d4e-4720-90af-c45b2820c31b"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-0aaddae1-b127-4c06-b2b7-7f6eb1323dc9"
      >
        The second step is to read what Dropsmart says about how to use this oil
        - from a suggestion for application over healing properties to safety
        recommendations.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b8fa13c6-386c-445f-aab0-36d87fe5aba7"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-e47414a1-c836-4b0c-a002-a4057f0e442e"
      >
        Now, if the oil we have and wish to use isn&apos;t well researched, such
        as:
      </div>
      <div
        class="ql-block"
        data-block-id="block-f0db01f2-cbe4-4e52-883c-ac555da6873d"
      >
        <br />
      </div>
      <ul>
        <li>
          Frosted mint&nbsp;(<em>Poliomintha incana</em>)<em>&nbsp;</em>or
        </li>
        <li>Winged prickly ash&nbsp;(<em>Zanthoxylum armatum</em>).</li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-9ef4ab7e-54d1-432b-9c54-dab3c12b5137"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-086d4b86-d686-4975-b221-a51e78da8118"
      >
        We will seek the answer in the detailed report - chemical constituents.
      </div>
      <div
        class="ql-block"
        data-block-id="block-521b5cd3-1e2e-4466-a527-5e22661cf022"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a8cb36b0-f4c1-47d1-9e85-86166ec4828c"
      >
        Because oils can be under-researched, but chemical constituents of which
        the oils are comprised rarely are.
      </div>
      <div
        class="ql-block"
        data-block-id="block-2771f32e-aa0e-49da-86b8-b3eb2228768c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-41b79d2a-77b9-489c-87b2-5594091c1809"
      >
        So scrolling down to the summary of the constituent will provide us with
        enough information we need to use those oils safely.
      </div>
      <div
        class="ql-block"
        data-block-id="block-7670107d-85fc-410e-bfb8-ce569291c42d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a32390fb-f0b2-4a51-8f1e-872b07e984ed"
      >
        We can also choose a specific chemical component, for example, geraniol,
        to address a particular issue.
      </div>
      <div
        class="ql-block"
        data-block-id="block-ed3ad08c-4dca-47b2-a46e-bec731660872"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-4c85ac31-e77f-4fab-8966-21c517b8786d"
      >
        In this case, the advanced filtering feature in Dropsmart that allows us
        to browse our database (favorites and beyond) is beneficial.
      </div>
      <div
        class="ql-block"
        data-block-id="block-17e46069-f273-466f-b415-43448098f03c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-bd86c980-85f3-44e3-b614-0ca2ace62c8a"
      >
        So our founder Melani did just that and looked at oils in her collection
        with at least 30% of geraniol to address an emotional unbalance.
      </div>
      <div
        class="ql-block"
        data-block-id="block-918f3aae-5bfa-402f-b1eb-43f5b7244b9a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-7e0ca0c6-d7e1-4ded-b356-c0ea6f631a6e"
      >
        The recommendation which came as a surprise in her case was Gingergrass
        (<em>Cymbopogon martini</em>) which she otherwise would have no idea how
        to use.
      </div>
      <div
        class="ql-block"
        data-block-id="block-97a9173b-bc73-466d-b47d-7fd930944430"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-cb9d3675-8852-4182-80aa-01cd7c028b8f"
      >
        This oil is under-researched, but the list of the healing properties and
        application suggestions in the detailed report unraveled a lot. But also
        reiterated the fact that this oil can be used as an antidepressant.
      </div>
      <div
        class="ql-block"
        data-block-id="block-ec25cb6b-b52a-4071-80f4-ac6a8b0af083"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-192332c7-211d-4916-8c22-a16057a22dec"
      >
        So, by searching by the chemical constituents, we can find the one we
        want to work with.
      </div>
      <div
        class="ql-block"
        data-block-id="block-2a726301-ad69-4049-b6d3-2d0332e02275"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-0f2e6b44-dc74-4c03-bad0-df1438c0925e"
      >
        Once we dive deep into the chemistry of oils, we understand that we have
        merely a couple of chemical constituents which repeat themselves.
      </div>
      <div
        class="ql-block"
        data-block-id="block-19ca6349-b24e-42c1-837b-26a28c2bb9d2"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-9f976e62-42f4-46c2-b688-42a758b8496c"
      >
        So instead of memorizing essential oils profiles, we actually develop a
        deep understanding, which helps us to use oils in a very efficient,
        creative, and useful way! &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-168903de-d6df-419f-a3c0-d485f0fde572"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-0aad412d-47ed-4cf6-9415-3ffd8892ef49"
      >
        We can even get surprised what we can use a specific oil for - a usage
        we would otherwise not even think of.
      </div>
      <div
        class="ql-block"
        data-block-id="block-c7ee9446-85bd-4024-a90e-802627c13fa9"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f0701300-2452-42e2-ba24-d6d6cf853135"
      >
        So let&apos;s use oils we already have, explore chemical constituents,
        and have fun while doing it!
      </div>
      <div
        class="ql-block"
        data-block-id="block-1ad841ec-f143-4b6b-87f7-679c38cd0047"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-eff46e4c-1ac4-4862-8d3f-bb432b8a0c6d"
      >
        Hopefully, you&apos;ll go and play in the Dropsmart - and create
        spectacular blends! &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-e94dde50-e6c1-4b6a-be20-be8a311d0ef9"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-3076e738-3ce2-4118-a2a3-4612f1c75e53"
      >
        <strong>Thanks for tuning in! &nbsp;🙂&nbsp;</strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-a3b4228a-69f7-4fc0-86b0-fef6b749fa8c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-0530fc83-25c2-4d86-ab18-4f2fbb4eaf0d"
      >
        We wish you a lovely day,
      </div>
      <div
        class="ql-block"
        data-block-id="block-f524f4fd-8327-4250-abff-c7f8d6344b65"
      >
        Dropmart Team
      </div>
      <div
        class="ql-block"
        data-block-id="block-d963c9da-0fa6-424d-9022-2e4ed3a4aa2c"
      >
        <em
          ><a
            class="ql-link"
            href="http://dropsmart.io/"
            rel="noopener noreferrer"
            target="_blank"
            >Dropsmart.io</a
          >
          - The most trusted essential oil resource center.</em
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-4140134a-10a4-4fb4-8200-c3928937af2d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-c542549c-eed0-433a-b110-f549102b3d62"
      >
        <strong>P.S.</strong> Today, we shared two methods through which we can
        enjoy conscious, responsible, and safe experimentation.
      </div>
      <div
        class="ql-block"
        data-block-id="block-571c4f9c-8247-42e7-8d3e-d1395dd05ca8"
      >
        <br />
      </div>
      <div
        class="ql-block ql-align-center text-center"
        data-block-id="block-be0d76f4-ee9c-45b3-b86c-da092c72dd15"
      >
        <strong
          >Thanks for tuning in &amp; please continue your journey with the next
          step!</strong
        >
      </div>
    </article>

    <article v-else-if="stepNumber === 16">
      <p>
        Dear <span>{{ name }}</span
        >,
      </p>
      <div
        class="ql-block"
        data-block-id="block-23c54544-53a8-4a0e-92f1-d094c67b809c"
      >
        Thank you for embarking on this journey with us! We hope you find it
        both interesting &amp; fun! &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-5c1cf2f4-00d2-4d51-8a60-1d03f1e8847c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b5439bfe-1d3e-4a89-a287-742d2109fbc5"
      >
        Last time we wrote about how to experiment without consequences and how
        to be mindful during our experimentation to yield incredible results!
      </div>
      <div
        class="ql-block"
        data-block-id="block-45c9df20-a676-4304-8c7c-ae5981049d75"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-5dc8900c-1060-49e4-b8b2-d2da629eae3e"
      >
        Today we&apos;re tackling the Impostor Syndrome, or better said, how to
        defeat it for good!
      </div>
      <div
        class="ql-block"
        data-block-id="block-ee482e79-5bad-4a5e-b011-6188149e1fa5"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-5c09ad4c-fd4f-4fed-b5d2-602d59fd2a4c"
      >
        At some point, we all feel insecure. Especially in this ever-evolving
        field, it is increasingly easy to get overwhelmed with a variety of
        choices while serious decisions are to be made.
      </div>
      <div
        class="ql-block"
        data-block-id="block-4857be0a-0eaa-459c-bf44-853d72b93977"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-eabf27e0-23c0-4e0f-a4eb-aefd5bf27508"
      >
        There are so many opportunities, options, and actual areas in which
        aromatherapy oils touch that even mastering chemistry doesn&apos;t
        presume success, because you&apos;re not (let&apos;s suppose) equally
        savvy in distilling, formulating, or working with people in real-time.
      </div>
      <div
        class="ql-block"
        data-block-id="block-23e018f0-ca7b-4011-a91c-bea60a31e139"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-40e71881-57fc-446f-a0b8-88eaeed154c5"
      >
        You might have genuine expertise in research but minimal experience in
        the application part of the research (what specific oils do for the
        clients).
      </div>
      <div
        class="ql-block"
        data-block-id="block-0e4b0858-7189-4321-90b7-8091c88de0b2"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-c0b62e28-609c-418c-851f-a71132dae5b3"
      >
        There are so many areas in aromatherapy &amp; essential oils in general
        are, that it&apos;s seemingly impossible not to feel
        <strong>Impostor Syndrome</strong> at times.
      </div>
      <div
        class="ql-block"
        data-block-id="block-c5a6651c-e7e9-4ea2-a6ac-ac2655156e77"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-617b3a31-259f-494a-845e-fe94aca4a7b4"
      >
        And this is where we aim to share how you can use your unique abilities
        and the mode of genius to overcome not only the Impostor Syndrome but
        also to defeat the feeling you have to know everything, be everywhere
        and do it all at the same time - to be reputable, respected &amp;
        professional.
      </div>
      <div
        class="ql-block"
        data-block-id="block-179b34f4-228e-444a-869a-12ce9aff0831"
      >
        However, that cannot be farther from the truth.
      </div>
      <div
        class="ql-block"
        data-block-id="block-3c1250bc-d33c-443b-8218-f8ce57f5130d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-5c68fb2f-fdda-4042-8840-eca3bb1c12c3"
      >
        Let&apos;s exemplify.
      </div>
      <div
        class="ql-block"
        data-block-id="block-7b965cf6-45cf-427c-962e-2f5c6f25a0fc"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-496f348e-7a4e-434c-8ded-8830227e033c"
      >
        Let&apos;s imagine you have an extremely important presentation to
        create for a room packed with people, followed by a blog that will be
        published on the massively visited site.
      </div>
      <div
        class="ql-block"
        data-block-id="block-d4789e26-b003-43f1-948b-a905a514df0b"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-89cddaff-70d1-4fdd-ac5a-4015a565dfbc"
      >
        This real-life occurrence is taken directly from our founder&apos;s
        Melani life - way before she enjoyed the reputation she does now.
      </div>
      <div
        class="ql-block"
        data-block-id="block-355ccdba-b1c7-4575-82da-2b3929aa2e7e"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-dee5a83b-2e37-4bc8-af11-b2ca7a376565"
      >
        How do we find relevant and credible information in the shortest amount
        of time - and present them equally well?
      </div>
      <div
        class="ql-block"
        data-block-id="block-1fbaf028-aec7-4ffc-85c1-1403962bdaac"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-59db1ed9-0f2b-448b-8d86-fea4b98d483d"
      >
        Luckily, there are <strong>three steps formulas</strong> derived from
        numerous hours of on-field research Melani took to determine how
        A-players in the industry do it.
      </div>
      <div
        class="ql-block"
        data-block-id="block-da68a3c7-84a1-4a98-b525-01eb1c8607d1"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-fc40f72a-f77a-4c89-b0ce-b81e12feffbc"
      >
        She was curious about how the stars of aromatherapy prepare their
        content - and found that the research part (or references) is one of the
        most important, if not <strong>the most critical,&nbsp;</strong>factors.
      </div>
      <div
        class="ql-block"
        data-block-id="block-88309b75-ec99-4202-97d5-5842205deb4d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-6d083d25-a4c5-429c-95af-438191458933"
      >
        Each piece of content that is backed up by scientific literature is
        considered supreme when it comes to educating, lecturing, or simply
        sharing the content with the audience.
      </div>
      <div
        class="ql-block"
        data-block-id="block-c83d7f47-5f39-496b-900d-a1551383beb1"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-cd646b57-850f-460b-b85f-7016b6753e1d"
      >
        So the formula for creating great content (and conquering Impostor
        Syndrome) goes as follows:
      </div>
      <div
        class="ql-block"
        data-block-id="block-c59f9e61-87b1-401c-b6f7-5ff7bb256ea1"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-368bac49-8094-4761-9093-5c3b95f0eaeb"
      >
        <strong>STEP 1 - be as detailed as possible</strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-a2e38f17-11f0-4dda-aed9-7975fd106ee7"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-528b5cc8-67f3-4bb7-b973-db8085eb5c69"
      >
        A marvelous feature that allows us to compare species and chemotypes to
        see how they are similar and different.
      </div>
      <div
        class="ql-block"
        data-block-id="block-ddcd584b-d730-4242-873f-16c7c2e9ff60"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a0170e6c-82d6-456c-8d4c-a6cfe246a9f9"
      >
        For this example, we&apos;re going to take Salvia.
      </div>
      <div
        class="ql-block"
        data-block-id="block-9e51b2c7-3eb7-4fe1-bb22-dc8007f44ee6"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-cda3fd27-c4f9-4464-9968-828e342e554c"
      >
        Let&apos;s imagine you&apos;re creating a presentation (and writing an
        article) in which you&apos;re recommending Sage (perhaps from your
        region) for a specific result.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b23354f2-05e9-4b83-9c3f-1dc6078361cc"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-80ada546-e63b-40bf-bdc0-a278758adf06"
      >
        To make things even more interesting, let&apos;s opt for a White
        sage<em>&nbsp;</em>(<em>Salvia apiana</em>)<em>&nbsp;</em>as its
        application recommendations are non-existent since the oil&apos;s
        research is still in its infancy.
      </div>
      <div
        class="ql-block"
        data-block-id="block-ee30bb7e-5c90-450c-a8bb-21c1dd895a10"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-cdc6cd3d-b09b-4957-9006-4706026cbfe7"
      >
        By opening Dropsmart, we can notice that even though healing properties
        and application suggestions aren&apos;t listed, there&apos;s a plethora
        of information around safety recommendations - hence this can be our
        opener.
      </div>
      <div
        class="ql-block"
        data-block-id="block-332c803b-938c-4cfa-9f90-55d5fb2f1f69"
      >
        We can share that using it around children isn&apos;t recommended while
        referencing our share simultaneously.
      </div>
      <div
        class="ql-block"
        data-block-id="block-2480efc0-14b1-4b5c-8130-4686c72e6890"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-19cf1c08-117e-4daf-aed7-1197a46a5300"
      >
        By checking the detailed report, it&apos;s pretty apparent that even
        though 1,8 cineol has to be handled with caution around little ones,
        it&apos;s a component with incredible healing properties (from
        anti-inflammatory, antibacterial, antifungal, to the rest, which makes
        it super-potent for usage on fungus (e.g., candida).
      </div>
      <div
        class="ql-block"
        data-block-id="block-85c117d7-058a-4b9f-a378-db61f65026e1"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-9e35d893-399d-462e-9844-a6ec75d1d12e"
      >
        Now we have our opener - and we can write an entire article on White
        Sage alone. So let&apos;s go back to the comparison part.
      </div>
      <div
        class="ql-block"
        data-block-id="block-de053647-fe44-40b6-bbe8-d8654dbafd3e"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-d8a6b96a-c350-4515-82f3-fb9cf19fa9db"
      >
        <strong>STEP 2 - use the comparison tool&nbsp;</strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-96398897-69a3-4427-b533-1ac6eb63ac6e"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-88110c55-5c58-4d03-8707-b7c8636886fc"
      >
        It&apos;s always good to write the data accurately and precisely.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b713b6e8-bf62-44e6-b8de-3bf774aca45d"
      >
        Precise data entry and detailed explanations boost our credibility and
        reputation at the same time.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b4b88fdb-011a-4458-866d-9725b6ebdfd4"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-5bb29f4b-9c34-4979-ab13-24106fd4af2e"
      >
        For this example, we decided to compare four different types of Sage:
      </div>
      <div
        class="ql-block"
        data-block-id="block-17808ab4-ecc0-43cb-aea9-5b1715d0e18e"
      >
        <br />
      </div>
      <ul>
        <li>
          Regular Sage&nbsp;(<em>Salvia officinalis</em>)&nbsp;mentioned
          earlier,
        </li>
        <li>White Sage<em>&nbsp;</em>(<em>Salvia apiana</em>),</li>
        <li>Clary Sage&nbsp;(<em>Salvia sclarea</em>), and</li>
        <li>
          Lavender Sage&nbsp;(<em>Salvia officinalis subsp. lavandulifolia</em
          >).
        </li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-21e05343-edc0-46d9-aae9-0280577e0ba0"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b5bf7915-ee01-45c5-9ab4-b1d1ec562555"
      >
        You can start by describing the chemistry or comparing the essential
        oils&apos; scientific properties.
      </div>
      <div
        class="ql-block"
        data-block-id="block-40029214-3042-4067-bfc2-2e902720ce78"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-9e94e61e-abbc-499b-b0f4-7587311fdf1a"
      >
        However, what we should be the most cautious about is SAFETY!
      </div>
      <div
        class="ql-block"
        data-block-id="block-8b796923-3d5f-43d8-b8ee-a7bc5c45fbe0"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-9bed49d2-db3e-429e-b15b-51b636db2e1f"
      >
        Safety recommendations may be a slippery slope because they can be
        limiting, but without them, we have no chance to establish credibility.
      </div>
      <div
        class="ql-block"
        data-block-id="block-1fb8f721-0cae-47db-a082-fda93e378dc4"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a8df6fc6-3714-49dd-8822-97f32c48c10b"
      >
        And safety is always directly connected to chemistry.
      </div>
      <div
        class="ql-block"
        data-block-id="block-c67ccc11-a33b-4feb-85a3-865ece0259dc"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-43add75f-fb50-4675-8764-29a29d5ee167"
      >
        Which oils are safe to use and why?
      </div>
      <div
        class="ql-block"
        data-block-id="block-938bbd52-b9ff-46a6-8f3f-ae23031f7001"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-8c1196eb-132d-4c29-8a3f-146d621915ac"
      >
        So, Dropsmart&apos;s comparison tool shows that the regular Sage has a
        relatively low dermal usage threshold and is neurotoxic.
      </div>
      <div
        class="ql-block"
        data-block-id="block-2c3af203-6311-4af0-aeed-d14188df61b8"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-7c8c9751-cd29-4334-8553-2005229605cb"
      >
        In this case, other chemotypes are recommended.
      </div>
      <div
        class="ql-block"
        data-block-id="block-fd63e024-198b-48d2-98df-3ee1d5aacc31"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-77250d09-0178-4246-be80-bbb9a35dca0b"
      >
        <strong>STEP 3 - use Dropsmart to answer questions&nbsp;</strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-cf9f28f3-8c70-4fa0-921e-49bd1b4c667d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-66a86a69-9a6f-4bf2-a823-9615d7faf5d8"
      >
        Has it ever happened to you that one of your clients came up with a
        question you had no response for? Or suggested/asked for a specific oil
        for which you aren&apos;t that well acquainted?
      </div>
      <div
        class="ql-block"
        data-block-id="block-36508791-2e27-4280-8db0-abf1c24e99a6"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f75ae1b8-99c6-4afa-a511-204d446c9273"
      >
        It happened to us - and especially our founder Melani
        <strong>a lot!</strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-10990bc0-5770-42b3-a58f-7d6eb0c5b203"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-adc434f7-3f43-4e06-81c9-94d0824f25c9"
      >
        Dropsmart&apos;s catalog comes in handy in this case scenario, as we can
        browse safety recommendations, application suggestions, and healing
        properties.
      </div>
      <div
        class="ql-block"
        data-block-id="block-82a2b089-89dd-436b-8183-7139ba9fb089"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-05a63684-4267-4806-b8bc-7b1f1fdaaab2"
      >
        Dropsmart can (and is) your most loyal ally - since it will always
        (without exception) provide scientifically backed references in a matter
        of seconds.
      </div>
      <div
        class="ql-block"
        data-block-id="block-9ed20a90-c224-467e-8167-6554b8f79244"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-4729e082-2739-46ab-9050-0252608c747d"
      >
        We hope this has taken some edge off you and offered new ways to
        integrate the power of chemistry into your work and life in an easy,
        simple, yet highly efficient way! &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-d6f98c01-ce80-4b0b-92e4-1c533d5fc6d0"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-b73012bc-07b8-4834-9a88-b2671c45acd7"
      >
        And Dropsmart will hopefully help you to liberate and express your
        creativity and blend authenticity while knowing you&apos;re being
        responsible and safe.
      </div>
      <div
        class="ql-block"
        data-block-id="block-13dbe1c4-b81a-4ab2-92ae-c2effe7030b9"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-0ec5483d-941b-4a5f-8282-cdcd6435bc5b"
      >
        <strong>Thanks for tuning in! 🙂&nbsp;</strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-4b323bf1-1439-441d-bee0-7cf4e8ff5622"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-e981d134-74cf-4bf9-9ccc-0b8d9beb2c99"
      >
        We wish you a lovely day,
      </div>
      <div
        class="ql-block"
        data-block-id="block-a301b5b5-dc53-44fc-8609-3cdd6c404edd"
      >
        Dropmart Team
      </div>
      <div
        class="ql-block"
        data-block-id="block-2e1d0365-f61c-4771-9a14-327146f5fd97"
      >
        <em
          ><a
            class="ql-link"
            href="http://dropsmart.io/"
            rel="noopener noreferrer"
            target="_blank"
            >Dropsmart.io</a
          >
          - The most trusted essential oil resource center.</em
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-cd73c186-935a-43dc-acf7-184d0f0e69bb"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-a60fea68-126c-4e25-b2ee-9c4d80e54a0c"
      >
        <strong>P.S.</strong> Today, we shared the three steps formula for
        mastering the knowledge of essential oils and presenting it
        professionally and credibly!
      </div>
      <div
        class="ql-block"
        data-block-id="block-0d1d3716-d975-4987-b914-30c64420d848"
      >
        <br />
      </div>
      <div
        class="ql-block ql-align-center text-center"
        data-block-id="block-ae15715c-9ddc-4481-bcd5-9c2a55d07bbc"
      >
        <strong
          >Thanks for tuning in &amp; please continue your journey with the next
          step!</strong
        >
      </div>
    </article>

    <article v-else-if="stepNumber === 17">
      <p>
        Dear <span>{{ name }}</span
        >,
      </p>
      <div
        class="ql-block"
        data-block-id="block-481e5f12-6c98-4211-a553-9f7e02ac7df7"
      >
        Thank you for embarking on this journey with us! We hope you find it
        both interesting &amp; fun! &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-0ee4ca9a-f8b1-400a-85f2-89718dd29521"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-9cd31b22-6624-4e36-9da8-09df3b5ee230"
      >
        Last time we wrote about how we can conquer Impostor Syndrome.
      </div>
      <div
        class="ql-block"
        data-block-id="block-55d44bf6-8274-45c9-9f9f-ccf92ee7205b"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-1e6bd69b-17f6-40a4-a237-4e7a168c7378"
      >
        Today we will discuss how to achieve ultimate literature independence
        and achieve it.
      </div>
      <div
        class="ql-block"
        data-block-id="block-a17e0b0b-3dbd-4b39-be6e-f31cc966cdcc"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-ffa97616-4010-4ddc-86fc-0306a60ae40d"
      >
        With this final (for now) step, we aim to wrap up everything you&apos;ve
        been doing till this point and help you obtain maximum freedom while
        applying what we&apos;re learning.
      </div>
      <div
        class="ql-block"
        data-block-id="block-fe098575-3293-45e2-9be8-8bb0645bc194"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-20974a99-3f3c-4eee-9a17-e6d725f8ba43"
      >
        Whether selling the essential oils, recommending them, or distilling
        them, we presume you wish to be free from all of the literature while
        knowing exactly how and what to do (and having credible, science-back
        references that solidify your choice).
      </div>
      <div
        class="ql-block"
        data-block-id="block-e1d52145-c8cd-4bce-9846-436643ca08fe"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-61c26ddc-1921-40fc-9f1b-a3c3e5ee1d52"
      >
        The idea is to have information and digital, easily accessible, and
        truly reliable references.
      </div>
      <div
        class="ql-block"
        data-block-id="block-330f1e57-9888-4d12-851d-85616e7cb4dd"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-9720205c-149a-4e46-b8cb-fedc45008f75"
      >
        First, let&apos;s ensure we&apos;ve favored all oils we use.
      </div>
      <div
        class="ql-block"
        data-block-id="block-26d08e00-9308-4b4b-b9d2-debfd7e79e5d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-437fc292-11c6-42b9-bf66-026667b9e1e0"
      >
        It&apos;s only when you save the oils you already have that you&apos;ll
        be able to swiftly go through them and make the most rational and wisest
        choice - by utilizing the resources, you already own.
      </div>
      <div
        class="ql-block"
        data-block-id="block-d1eab7f5-775d-4cfa-959e-1d22015677c4"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-573e59ea-c6c8-456e-88c7-0afcb650b977"
      >
        To exemplify this, let&apos;s imagine someone came to us in need of
        essential oil for joint pain.
      </div>
      <div
        class="ql-block"
        data-block-id="block-49e2ea41-585b-438c-a0bc-3b309807e921"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f84e19a9-2f73-4267-bcb9-ed75cdf4a871"
      >
        Of course, Dropsmart will offer many options, but by using the favorite
        feature, we can select those we already own.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b997a2dc-0dac-4a15-8718-eda04a30ceba"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-2b0a67ed-b660-44fe-b4ec-472f08b48672"
      >
        The next step is presenting a couple of options to our future clients in
        their pure form.
      </div>
      <div
        class="ql-block"
        data-block-id="block-f294fd25-78ff-402d-a26f-7eee731f318e"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-6433302f-77fe-4fab-91ae-fb2f2c8d7959"
      >
        To remedy joint pain, she has presented a couple of oils from her
        collection, such as:
      </div>
      <div
        class="ql-block"
        data-block-id="block-97204ba5-e59b-410e-9943-93014a098225"
      >
        <br />
      </div>
      <ul>
        <li>Lavender<em>&nbsp;</em>(<em>Lavandula angustifolia</em>),</li>
        <li>Rosemary&nbsp;(<em>Rosmarinus officinalis</em>),</li>
        <li>
          Nutmeg&nbsp;(<em>Myristica fragrans</em>),<em>&nbsp;</em>&amp;<em
            >&nbsp;</em
          >
        </li>
        <li>Ginger (<em>Zingiber officinale</em>).</li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-2abe2588-28bc-4bb7-a5a4-abfc681e9d33"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-fc144d4b-2be6-4d3b-beb8-f27f3fb1d42f"
      >
        Of course, we will use the Comparison tool to solidify our choice.
      </div>
      <div
        class="ql-block"
        data-block-id="block-04b2c434-568e-43a8-8c5c-671fd928513b"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-427bba64-623c-4a9f-bbf5-62f7a467c0a6"
      >
        The chemistry of each selected oil is different, and so is the smell.
      </div>
      <div
        class="ql-block"
        data-block-id="block-e41d1e94-3192-44dc-b2cd-1893a03bed94"
      >
        To save time and spare ourselves tedious research, we can browse through
        the list of healing properties, references &amp; application
        suggestions.
      </div>
      <div
        class="ql-block"
        data-block-id="block-55292118-b581-447b-8cad-e9d40b9c9c25"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-5af17f99-c65f-4918-bf33-f06ad13ed279"
      >
        As aromatherapy experts, we can choose whether we are willing to devote
        our time towards creating a product, spending it on sessions/meetings
        with our clients/customers/patients, or researching.
      </div>
      <div
        class="ql-block"
        data-block-id="block-67f8f8ae-4911-4a7c-8531-8094afb4cdf9"
      >
        Every minute is essential, and each minute counts.
      </div>
      <div
        class="ql-block"
        data-block-id="block-ce2a1419-13d6-46f4-a423-262bfa7a94cb"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-96d826f7-8e2c-4baf-8774-b1117ad8c42b"
      >
        By showcasing details in the Comparison tool, we can explain precisely
        WHY we recommend the blend.
      </div>
      <div
        class="ql-block"
        data-block-id="block-5c6b99aa-8f8c-4f58-b199-d2b486320f0a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-ee5e9fec-c5d7-4069-b5ca-ebf5732b6e40"
      >
        We can also discuss safety recommendations and warn our clients how and
        why to use a specific oil.
      </div>
      <div
        class="ql-block"
        data-block-id="block-affb0cc3-e1da-4147-9a1c-04558d244c7c"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-5192f9d4-fd02-437b-b96b-e86dfa08f846"
      >
        After we&apos;ve carefully selected the oil we find to be the best
        option, for example, Rosemary &amp; Lavender, we are going to browse
        through details and recommend proper usage in accordance to the
        references provided within the Dropsmart, such as:
      </div>
      <div
        class="ql-block"
        data-block-id="block-4ab28ef3-6d45-43bd-a5c8-9cdbbed5a119"
      >
        <br />
      </div>
      <ul>
        <li>using Lavender in the evening and Rosemary in the morning, and</li>
        <li>
          using Rosemary not only to soothe joint pain but also to relax
          muscles.
        </li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-501b672f-00fa-40a8-9880-713e8793f767"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-490bb6fb-7846-4a97-be63-c2eeba22cb17"
      >
        And so much more.
      </div>
      <div
        class="ql-block"
        data-block-id="block-0ef39389-3a06-4749-ba38-dc53be9a693d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-adc2d24b-8cc9-4060-a463-07e9bbb37e40"
      >
        In the next step, we can explain the scientific references of essential
        oils and their chemical constituents to boost our credibility and
        enhance trust in us and our products.
      </div>
      <div
        class="ql-block"
        data-block-id="block-8fcad96e-5db4-4a39-a8b6-3de69664da50"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-4d45bd37-94a4-47b7-b977-e86c47866239"
      >
        At this point, your clients should already develop a profound sense of
        trustworthiness towards your work since you&apos;re backing everything
        up not only by experience but also by science.
      </div>
      <div
        class="ql-block"
        data-block-id="block-7b98bf8d-c000-48c7-a46f-ea4e52f4821d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-4e349478-ccb8-40a4-9bfc-23c6e2c9677a"
      >
        The next step recommended is to present a couple of solutions - perhaps
        in the form of a blend.
      </div>
      <div
        class="ql-block"
        data-block-id="block-5de64fcf-af47-43b0-a334-d4def0d26e31"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-dba14fc7-340b-4eae-8d9a-7ddeef9162e9"
      >
        It&apos;s always recommended to pre-prepare a couple of different blends
        in the virtual blending simulator by the information about the condition
        and oils your client currently has to present genuinely customized and
        unique solutions.
      </div>
      <div
        class="ql-block"
        data-block-id="block-568e89da-a446-4228-aedc-072ad2b8b293"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-88e8fe59-d430-4b64-8a70-19be20e06d75"
      >
        To showcase how this is supposed to look like, our CEO Melani has also
        prepared three different blends:
      </div>
      <div
        class="ql-block"
        data-block-id="block-1b656ba3-fbfc-49d6-8bcc-5ea933455622"
      >
        <br />
      </div>
      <ul>
        <li>one for general joint pain,</li>
        <li>one blend for morning joint pain, and</li>
        <li>one blend for evening joint pain.</li>
      </ul>
      <div
        class="ql-block"
        data-block-id="block-9bac0f39-8e17-43a8-b592-c43017b39692"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-5a4bd19f-8331-4246-868d-e1a1cfac98cf"
      >
        Of course, each blend has to be additionally properly diluted - within a
        lotion, cream or gel.
      </div>
      <div
        class="ql-block"
        data-block-id="block-78dcb627-0463-4324-acba-012f6e48d69a"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-c2bc1f15-3148-4574-93fd-9f900ca2b61a"
      >
        So we are presenting options without wasting money, time, or resources
        by doing it.
      </div>
      <div
        class="ql-block"
        data-block-id="block-ea56fc82-f0ab-4ee3-977a-c71559c45e68"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-ee560b08-c180-4a64-b62c-f3d8070fcc64"
      >
        Of course, some blends (such as the first one) have many safety
        recommendations, so we may feel more comfortable replacing them with
        another, less &quot;dangerous.&quot;
      </div>
      <div
        class="ql-block"
        data-block-id="block-564dae14-c29f-4b09-a965-859b9a2e4475"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-0c3aee78-a886-4b9a-b11d-04dc0cb0bd66"
      >
        As well as with an oil separately, we can go into the details of the
        chemical constituents of each oil that blend contains.
      </div>
      <div
        class="ql-block"
        data-block-id="block-54c2a255-5719-4ee7-ace6-a52bde7889c3"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-58599ce5-1a1c-4455-8f11-d69f6d80777f"
      >
        But the point of this step, and this entire journey, really is to
        transmit less is more premise.
      </div>
      <div
        class="ql-block"
        data-block-id="block-b3106ede-e8c4-4566-a31e-eee20c13dee8"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-f9899353-34c7-4f50-8683-4ec86e40c0dc"
      >
        As you can see yourself (if you watch the video presented), our
        co-founder Melani created requisite blends with merely 3 oils (and
        covered all three notes doing it).
      </div>
      <div
        class="ql-block"
        data-block-id="block-30e908c8-003e-407a-b8d6-89309cf2b5ce"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-2eb0e418-5a87-43b4-9294-9f88dda49d98"
      >
        Creating well-balanced blends is not only a chance but a direct path
        upon using Dropsmart.
      </div>
      <div
        class="ql-block"
        data-block-id="block-4868446c-6acc-4e95-8b0a-66d4fff04e5d"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-e8335db6-025b-4131-97e3-09a9fad3c0ce"
      >
        The power of the dashboard is even more apparent upon searching for
        specific oil abundant in a particular component and finding it in a
        split second.
      </div>
      <div
        class="ql-block"
        data-block-id="block-d7d11d34-6d6f-4b87-8796-3602277ecb1b"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-25eee5f1-9b23-4747-b88e-2ba78a7e400a"
      >
        In other words, being free from insecurities, guesswork, searching for
        answers in front of your clients, etc., becomes a norm upon using
        Dropsmart. &nbsp;🙂&nbsp;
      </div>
      <div
        class="ql-block"
        data-block-id="block-f30cf6ab-6ef1-4936-9efd-bd3d053d6dff"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-683593ce-c906-4b4e-8e4e-4594315c7dce"
      >
        We hope this journey has been helpful for you and that you&apos;re going
        to reap all of the benefits essential oils usage brings, especially when
        it comes to using them in a creative, exotic, and authentic way!
      </div>
      <div
        class="ql-block"
        data-block-id="block-82a72775-f10e-4ff4-aaf6-ed09ecc000b2"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-9abb6297-9d4b-4a0e-afdf-da3a82de74af"
      >
        Hopefully, you will rely on Dropsmart to express your uniqueness, blend
        authentically, and thoroughly enjoy the fact that you don&apos;t only
        know what you&apos;re doing, but have scientific references backing you
        up every step of the way.
      </div>
      <div
        class="ql-block"
        data-block-id="block-9a49ef49-4893-474e-9179-2396f7a00c95"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-216f7101-27c9-4c4a-8f34-aedd99212f11"
      >
        <strong>Thanks for tuning in! 🙂&nbsp;</strong>
      </div>
      <div
        class="ql-block"
        data-block-id="block-73883de8-daa8-499e-b886-e5bd7c992891"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-18e2b983-17e2-4bc6-84aa-4838c0e16ae3"
      >
        We wish you a lovely day,
      </div>
      <div
        class="ql-block"
        data-block-id="block-5ead38ac-9e54-4618-a0f6-02da984d5090"
      >
        Dropmart Team
      </div>
      <div
        class="ql-block"
        data-block-id="block-fff4172c-b12a-4bd2-a9b4-da9d493a9126"
      >
        <em
          ><a
            class="ql-link"
            href="http://dropsmart.io/"
            rel="noopener noreferrer"
            target="_blank"
            >Dropsmart.io</a
          >
          - The most trusted essential oil resource center.</em
        >
      </div>
      <div
        class="ql-block"
        data-block-id="block-2b6db3d8-1545-4257-aff8-74af18584358"
      >
        <br />
      </div>
      <div
        class="ql-block"
        data-block-id="block-12ab0e28-8d81-42fb-8238-af3592dc4139"
      >
        <strong>P.S.</strong> Today, we shared the three steps formula for
        mastering the knowledge of essential oils and presenting it
        professionally and credibly!
      </div>
      <div
        class="ql-block"
        data-block-id="block-1ffa606e-55aa-47cc-a405-b88b11f06e71"
      >
        <br />
      </div>
      <div
        class="ql-block ql-align-center text-center"
        data-block-id="block-f4c0c2ce-7fe3-4b46-963f-61ed715c0d6b"
      >
        <strong
          >Thanks for tuning in &amp; please continue your journey with the next
          step!</strong
        >
      </div>
    </article>
  </div>
</template>
<script>
export default {
  name: "TextContent",
  props: ["customerInfo"],
  mounted() {
    this.$root.$on("step-number", (step, title, url, number) => {
      this.stepNumber = number;
    });
    this.stepNumber = parseInt(this.$route.query.step);
  },
  data() {
    return {
      stepNumber: 1,
      name: JSON.parse(sessionStorage.getItem("customerInfo")).user.firstName,
    };
  },
};
</script>

<style scoped lang="scss">
article {
  font-size: 1.25rem;
  margin: 70px 0;
  .text-center {
    text-align: center;
  }
  a {
    color: #79b867;
  }
  a.hover {
    text-decoration: none;
  }
}
</style>
